/* ============================================================
   BayBayBelle — storefront behaviour
   原生 JS，零依赖。购物车走 Shopify Cart API。
   ------------------------------------------------------------
   设计取舍：
   · 加购做「乐观更新」—— 先动界面再等回包，点击手感才跟得上
   · 任何一步请求失败都回滚到服务端真实状态，不留假 UI
   · 视频统一 muted + playsinline + x5 同层播放，否则手机浏览器
     会把它抽成原生层，压住底部结算条
   ============================================================ */
/* ============================================================================
   BB-STOCK-20261029 —— 前端「展示库存」引擎（侯哥 2026-10-29 11:2x 定制）
   ----------------------------------------------------------------------------
   需求：后台真实库存 292 的卡，前端不要写 "292 in stock"（一点都不稀缺）。
        全站显示值压到 20 以下，按热度动态变化，营造「马上卖完」。
        真实库存仍是唯一权威：真售罄必须照实显示，绝不能用编造数字挡住购买。

   铁律（四道必须守住）：
     ① 显示值 = min(公式值, 真实库存) —— 永远不超过真值，客户点买的件数永远买得到
     ② 真实库存为 0 / 不可售 ⇒ Sold out 优先，公式完全让位
     ③ 同一业务日内显示值锁死：客户刷新 100 次、来回点 10 次都不变（变了就是穿帮）
     ④ 跨业务日只降不升；补货回填幅度 <= 3 且间隔 >= 28 天（避免"刷新一下涨回去"）

   为什么按【天】衰减而不是按【浏览次数】：
     一个客户站在 PDP 上反复看，如果每看一次掉一件，3 分钟就能从 9 掉到 1，
     再掉就没了 —— 那不叫紧迫，那叫假。所以单次停留内数字纹丝不动，
     只有跨过美西 0 点（CUT_TZ=-8，与后台 GMV 重置同一时区）才掉 1。
     「一直看一个商品看到没有」的解法：掉到 1 就停在那，进入 30 天补货周期，
     周期到了从 top 重新开始（各卡按 handle 哈希错开，不会全站同一天一起涨）。

   热度源：ERP 销量（#bbHeatData 第一项），取全店百分位 0..1。
     热门卡起点低、掉得快（8~10 天见底）；冷门卡起点高、掉得慢（30 天见底）。
     ⇒ 客户看到「这张卡别人都在买，剩得越来越少」，且每张卡的数字都不一样。

   调试：任意页面加 ?stock=real ⇒ 本次会话全站直出真实库存（内部对账用，存 sessionStorage）。
   ============================================================================ */
(function () {
  'use strict';

  var CAP = 19;          /* 显示值硬上限（池子模型下实测最大 pool+1 = 10，这里是保险） */
  /* FLOOR = 2：渲染值永远不说「Only 1 left」—— 那一句只留给真实库存真的为 1 的卡。
     否则一张真实库存 115 的卡会因为渲染走到低位而挂着「最后一件」，客户买掉之后立刻归零，
     看起来像卖光了，其实仓库里还有一百多张。渲染归零 ≠ 真实售罄，这两件事必须彻底分开。 */
  var FLOOR = 2;
  var LOW_AT = 10;       /* <=10 用 "Only N left" */
  /* 真实库存 ≤2 时直接说真话（不再渲染）。这种卡马上会被 inv-sync 摘掉，
     再编数字没有意义，反而容易让客户点了买不到。 */
  var STOCK_TRUTH = 2;
  var CUT_TZ = -8;       /* 美西（保留：业务日口径，与后台 GMV 重置一致） */
  /* 池子走一格的间隔。
     BB-STOCK-PUNCH-20261029：12 → **8 分钟**。客人逛一圈回来数字就动了，
     但又不至于刷新一次变一个数（同一格内绝对稳定）。
     一个完整循环（pool=6）＝ 48 分钟，一天转 30 轮。 */
  var TICK = 8 * 60 * 1000;

  var forceReal = false;
  try {
    if (/[?&]stock=real\b/.test(location.search)) sessionStorage.setItem('bbs_real', '1');
    forceReal = sessionStorage.getItem('bbs_real') === '1';
  } catch (e) {}

  /* FNV-1a：同一 handle 永远得到同一个 0..1，保证「这张卡天生剩几件」是固定的 */
  function h01(s) {
    var h = 2166136261, i;
    s = String(s || '');
    for (i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    return ((h >>> 0) % 1000003) / 1000003;
  }

  /* 业务日序：美西 UTC-8 的 0 点换日 */
  function dayIdx(ms) { return Math.floor((ms / 1000 + CUT_TZ * 3600) / 86400); }

  /* ---- 热度百分位（懒算一次，全店排序） ---- */
  var heatM = null;
  function heatMap() {
    if (heatM) return heatM;
    heatM = {};
    try {
      var raw = window.__bbHeatData;
      if (!raw) {
        var tag = document.getElementById('bbHeatData');
        raw = tag ? JSON.parse(tag.textContent || '{}') : {};
      }
      var arr = [], k;
      for (k in raw) {
        if (raw.hasOwnProperty(k) && raw[k] && typeof raw[k][0] === 'number') arr.push([k, raw[k][0]]);
      }
      arr.sort(function (a, b) { return a[1] - b[1]; });
      for (var i = 0; i < arr.length; i++) heatM[arr[i][0]] = arr.length > 1 ? i / (arr.length - 1) : 0.5;
    } catch (e) { heatM = {}; }
    return heatM;
  }
  function heat01(handle) {
    var v = heatMap()[handle];
    return typeof v === 'number' ? v : 0.35;   /* 查不到就当偏冷门 */
  }

  /* ---- 池子大小：热门卡池子小（抢得快、补得勤），冷门卡池子大 ----
     BB-STOCK-PUNCH-20261029：由 5~9 收到 **4~6**，显示区间随之从 2~10 压到 **2~7**。
     全场平均显示 ≈ 4.5 件 —— 每一张都在「快没了」的档位上，而不是一半在 8~10 的不痛不痒区。 */
  function poolSize(handle) {
    var p = 6 - Math.round(2 * heat01(handle));
    return p < 4 ? 4 : (p > 6 ? 6 : p);
  }

  /* ---- 对外：给定真实库存，返回「该显示几件」 ----
     🔴 BB-STOCK-PURE-20261029（侯哥 14:30：「前端库存只是一个渲染作用，一定要以后台真实调用的库存为主。
        举例：前端显示 3 张、实际还有 50 张，这时十个客户同时下单，都必须能成功；
        下单成功后前端渲染的 3 归零，系统要能快速把渲染数量补上去」）
     ----------------------------------------------------------------------
     这一版把「渲染」和「真实」彻底解开：

       真实库存（服务端）   → 唯一决定「能不能买、能买几件」
       渲染数字（本函数）   → 只决定「写几件」，绝不参与购买判定

     所以去掉了上一版那行 `if (v > q) v = q`（真实库存反过来压低渲染值）：
       真实库存 50 而池子算到 3 → 显示 3，客户照买不误（买 10 件也成功，因为服务端有 50）；
       真实库存从 50 掉到 5 → **显示值完全不变**（它只看 handle + 时间），不会跟着缩；
       真实库存真到 0 → 才 Sold out。

     只保留一个例外：真实库存 ≤ 2 时说真话（`STOCK_TRUTH`）。
     这时候卡马上要被 inv-sync 摘掉，说真话既准确也不损失什么。

     万一出现「显示 6 但实际只剩 3」：客户点加购 6 件，`stockGuard` 会用**真实库存**拦住
     并提示真实数量 —— 渲染数字从来不会让客户超买后才发现。 */
  function shown(handle, realQty, avail) {
    var q = parseInt(realQty, 10);
    if (isNaN(q)) q = 0;
    if (avail === false || avail === 'false' || !(q > 0)) return { q: 0, out: true };
    if (forceReal) return { q: q, out: false };
    var pool = poolSize(handle);
    var seed = Math.floor(h01(handle) * pool);
    var slot = Math.floor(Date.now() / TICK);
    var v = FLOOR + (pool - 1 - (((slot + seed) % pool) + pool) % pool);   /* 2 .. pool+1 */
    if (q <= STOCK_TRUTH) v = q;      /* 真实库存 ≤2：说真话 */
    if (v > CAP) v = CAP;
    return { q: v, out: false };
  }

  /* 文案：全站一套口径（<=LOW_AT 说 Only N left，否则 N in stock） */
  function text(handle, realQty, avail) {
    var r = shown(handle, realQty, avail);
    if (r.out) return 'Sold out';
    return r.q <= LOW_AT ? ('Only ' + r.q + ' left') : (r.q + ' in stock');
  }

  /* 扫描所有带 data-bbs-qty 的节点统一改写（Liquid 侧只负责把真值和 handle 挂上去） */
  function applyAll(root) {
    var list = (root || document).querySelectorAll('[data-bbs-qty]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.getAttribute('data-bbs-avail') === 'false') continue;   /* 售罄保持 Liquid 原样 */
      var r = shown(el.getAttribute('data-bbs-key') || '', el.getAttribute('data-bbs-qty'), true);
      if (r.out) continue;
      el.textContent = r.q <= LOW_AT ? ('Only ' + r.q + ' left') : (r.q + ' in stock');
      el.setAttribute('data-bbs-shown', r.q);
      el.classList.toggle('is-low', r.q <= LOW_AT);
    }
    /* 顺带把"限时/限量"角标的数量也压下来（若有 data-bbs-num） */
    var nums = (root || document).querySelectorAll('[data-bbs-num]');
    for (var j = 0; j < nums.length; j++) {
      var n = nums[j];
      var rr = shown(n.getAttribute('data-bbs-key') || '', n.getAttribute('data-bbs-num'), true);
      if (!rr.out) n.textContent = rr.q;
    }
  }

  window.BBStock = {
    shown: shown,
    text: text,
    apply: applyAll,
    lowAt: LOW_AT,
    isReal: function () { return forceReal; }
  };
})();

(function () {
  'use strict';

  /* ============================================================================
     BUILD-GUARD-20261026 —— 「改了没反应」的根治
     ----------------------------------------------------------------------------
     现象：主题文件推送成功、线上实测就是新的，顾客/侯哥却一直看到旧样式。
     根因：页面 HTML 一旦被浏览器或代理留在手里，里面的 <style> 就是老的；
          brand.js 带 ?v= 换键会重新下载，但它管不了 HTML。
     做法：<html data-build> 由 theme.liquid 输出（与 brand.js 的 ?v= 同一个 Liquid 变量），
          这里把自己 script src 上的 v 跟它比 —— 不一致就说明「页面是旧的、脚本是新的」，
          直接重载一次拿新 HTML。
     防死循环：sessionStorage 记 60 秒，最多自动刷一次；刷完还对不上就静默（不再刷）。
     ============================================================================ */
  (function buildGuard() {
    try {
      var cur = (document.documentElement.getAttribute('data-build') || '').trim();
      /* currentScript 在 defer 脚本里不一定可靠（Shopify 会重排 script 标签），
         只认它的话 buildGuard 会静默失效 —— 必须再用选择器兜一层。 */
      var me = (document.currentScript && document.currentScript.src)
        || ((document.querySelector('script[src*="brand.js"]') || {}).src) || '';
      /* ⚠️ Shopify 的 asset_url 自己就带一个 ?v=<长数字>，我们再拼 &v=<build>
         ⇒ URL 上会有**两个 v**，必须取最后一个，否则永远比的是 Shopify 的资源指纹。 */
      var hits = me.match(/[?&]v=([a-zA-Z0-9]+)/g) || [];
      var v = hits.length ? hits[hits.length - 1].replace(/^[?&]v=/, '') : '';
      /* 可观测：把判断结果打在 <html data-bbguard>，真机/探针一眼看走到哪一步 */
      var mark = function (st) { try { document.documentElement.setAttribute('data-bbguard', st); } catch (e) {} };
      mark('v=' + (v || '-') + '|cur=' + (cur || '-'));
      if (!v) return;

      var url = new URL(location.href);
      var hasBb = url.searchParams.has('bb');

      /* ---------- 情况 A：版本一致（页面是新的）→ 把上次破缓存留下的 bb 参数擦掉 ---------- */
      if (cur && cur === v) {
        mark('ok');
        if (hasBb) { url.searchParams.delete('bb'); history.replaceState(null, '', url.toString()); }
        return;
      }

      /* ---------- 情况 B：页面是旧的 / 连 data-build 都没有 ---------- */
      /* 🔴 HTML-EDGE-CACHE-20261026（侯哥 19:5x：换了安卓那个带"已过滤广告"的浏览器，
         刷 n 次都是旧版；实测他截图卡片左右各 16px、宽 407.7 ＝ --rd-cardw 老样式，
         而同一页面的 VIDEO/PHOTO 缩略图（18:1x 才加）却在 ⇒ **JS 新、HTML 旧**。
         结论：HTML 卡在**浏览器厂商的云加速/广告拦截代理**里，刷新只是问代理要，代理给旧的。
         ⇒ `location.reload()` 是同一个 URL，代理照样命中旧缓存，等于白刷。
         必须换 URL：拼一个时间戳参数，代理的缓存键变了才会回源。 */
      /* 兜底①：立刻注入一版"看货器视频卡"样式。
         即使下面的跳转被代理吞掉（有些代理不认新参数），屏幕上也是对的，不用再等一轮。 */
      injectReelsCardFix();

      /* 兜底②：带时间戳重进，绕过所有中间缓存。sessionStorage 记 60 秒，最多跳一次，绝不循环。 */
      var KEY = 'bbBuildBust';
      var t = parseInt(sessionStorage.getItem(KEY) || '0', 10) || 0;
      if (Date.now() - t < 60000) return;
      sessionStorage.setItem(KEY, String(Date.now()));
      url.searchParams.set('bb', Date.now().toString(36));
      mark('busting|' + url.search);
      location.replace(url.toString());
    } catch (e) { /* 静默：任何异常都不该影响页面 */ }
  })();

  /* 只在「页面是旧的」时注入。新版页面 build 对得上，永远不会走到这里，
     所以这份 !important 不会干扰正常样式；它存在的唯一意义是让旧页面也能立刻正确显示。 */
  function injectReelsCardFix() {
    if (document.getElementById('bbReelsCardFix')) return;
    var st = document.createElement('style');
    st.id = 'bbReelsCardFix';
    st.textContent = [
      '.reel.is-vid .reel__card{left:50%!important;top:calc(88px + env(safe-area-inset-top))!important;',
      'transform:translateX(-50%) translateZ(0)!important;width:calc(100% - 40px)!important;',
      'height:var(--fitH,calc((100% - 40px)/var(--vr,.75)))!important;max-height:none!important;',
      'aspect-ratio:auto!important;border-radius:24px!important;overflow:hidden!important;',
      'background:#f6f6f7!important;outline:1px solid rgba(23,23,26,.07)!important;outline-offset:-1px!important;',
      'box-shadow:0 12px 34px -12px rgba(23,23,26,.16)!important}',
      '.reel.is-vid .reel__card video{position:absolute!important;inset:0!important;display:block!important;',
      'width:100%!important;height:100%!important;object-fit:cover!important;border-radius:inherit!important}',
      '.reel.is-vid .reel__card img{display:none!important}',
      '.reel.is-vid.is-photo .reel__card img{display:block!important;position:absolute!important;inset:0!important;',
      'width:100%!important;height:100%!important;object-fit:cover!important;border-radius:inherit!important}',
      '.reel.is-vid .reel__ui{top:auto!important;bottom:0!important;height:var(--uiH,156px)!important;',
      'background:transparent!important;justify-content:space-between!important}'
    ].join('');
    (document.head || document.documentElement).appendChild(st);
  }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = document.documentElement;

  /* ---------------- money ---------------- */
  var CURRENCY = 'USD';   // 原来是个 MONEY 对象，其中 format 字段从未被读取
  function money(cents) {
    var n = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: CURRENCY
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  /* 免邮金额专用格式：整数不带 .00（$99），非整数保留两位（$83.20）。
     CONSISTENCY-UNIFY-20261025：公告条门槛与购物车差额原来一个 $99、一个 $99.00。
     商品价格仍走 money()（一律两位），两者语义不同，别混用。 */
  function moneyNZ(cents) {
    var n = (cents || 0) / 100;
    var isInt = Math.abs(n - Math.round(n)) < 0.005;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: CURRENCY,
        minimumFractionDigits: isInt ? 0 : 2, maximumFractionDigits: isInt ? 0 : 2
      }).format(n);
    } catch (e) {
      return '$' + (isInt ? String(Math.round(n)) : n.toFixed(2));
    }
  }

  /* ---------------- cart state ---------------- */
  var cart = { item_count: 0, total_price: 0, items: [] };
  /* 🔴 2026-10-23：这个 0 只是占位。服务端渲染的角标/金额才是真值，
     在 fetchCart() 成功之前绝不能用它去 paintCart（见下面 paintCart 首行守卫）。 */
  var cartFresh = false;

  /* PERF-CART-20261023：/cart.js 单次要 ~1s（Shopify 服务端 + 跨境），而实测一次加购
     会连发 **3 次** /cart.js（addToCart、referral 的空车检测、init 各一次）⇒ 2 秒以上。
     这里加「并发去重 + 1.2s 节流」：同一时刻只飞一个，刚拿过的直接复用。 */
  var _fetchCartBusy = null, _fetchCartAt = 0;
  function fetchCart(force) {
    var now = Date.now();
    if (_fetchCartBusy) return _fetchCartBusy;
    if (!force && _fetchCartAt && now - _fetchCartAt < 1200) return Promise.resolve(cart);
    _fetchCartBusy = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        /* 🔴 2026-10-23：Shopify Ajax API 偶发 429 / 返回非购物车 JSON 时，
           旧代码照样 `cart = c; paintCart()` ⇒ money(undefined) 把
           **小计和合计一起写成 $0.00**（购物车页实测：$59.40 → $0.00，客户会以为免费）。
           拿不到合法购物车就保持上一次的真值，绝不写脏数。 */
        if (!c || typeof c.item_count !== 'number' || typeof c.total_price !== 'number') return cart;
        cart = c;
        cartFresh = true;
        _fetchCartAt = Date.now();
        paintCart();
        try { settlePendingLines(); } catch (e) {}
        return c;
      })
      .catch(function () { return cart; })
      .then(function (c) { _fetchCartBusy = null; return c; });
    return _fetchCartBusy;
  }

  /* 🔴 CART-DISCOUNT-20261023（侯哥：「如果是享受 5% 订阅就显示出来，让客户知道自己在享受折扣」）
     实测带 COLLECTOR5 的车：total_price 1881 / total_discount 99 /
     cart_level_discount_applications[0] = {title:"COLLECTOR5", value_type:"percentage", value:"5.0"}。
     金额早就是折后价，买家只是看不出来 ⇒ 这里把「折前价划掉 + 减几 %」画出来。
     ⚠️ 必须和 snippets/cart-total-price.liquid、cart-discount.liquid 的 DOM 结构逐字一致：
        Liquid 首屏渲染、JS 数量变化后重画，两条路径共用一个结构，否则一改数量原价就消失。
     ⚠️ 折前价用 total_price + total_discount，不用 items_subtotal_price
       （后者在有商品级折扣时 ≠ 折前总价）。 */
  function paintTotalPrice() {
    if (!cart) return;
    var disc = cart.total_discount || 0;
    var app = (cart.cart_level_discount_applications || [])[0] || null;
    var title = (app && app.title) || '';
    var isSub = /COLLECTOR/i.test(title);
    var isCombo = /FRIEND15/i.test(title);
    var pct = 0;
    if (app && app.value_type === 'percentage') pct = Math.round(parseFloat(app.value) || 0);
    /* ⚠️ /cart/change.js 的响应**不带** cart_level_discount_applications（实测：改一次数量后
       徽章从「−5%」退化成「−$1.48」并丢掉订阅蓝）。缺 app 时用两道兜底：
       ① 用折扣占比反推比例（disc / 折前价）—— 只有一个码时就是那个码的百分比；
       ② 订阅蓝改成看 cookie（bb_collector），不依赖服务端字段。 */
    if (disc > 0 && !pct) {
      /* 条件不能写 `!app`：change.js 的响应里 app **存在但字段残缺**（只是没有 value_type/value），
         实测改数量后徽章从「−5%」退化成「−$1.48」就是这个原因。改成「算不出比例时才反推」。 */
      var _before = cart.total_price + disc;
      if (_before > 0) {
        var _r = Math.round(disc / _before * 100);
        if (_r >= 1 && _r <= 100) pct = _r;
      }
      if (!isSub) { try { if (readCollector()) isSub = true; } catch (e) {} }
    }

    $$('[data-total-price]').forEach(function (el) {
      var html = '<span class="tp-now" data-tp-now>' + money(cart.total_price) + '</span>';
      if (disc > 0) {
        html += '<s class="tp-was" data-tp-was>' + money(cart.total_price + disc) + '</s>';
      }
      el.innerHTML = html;
    });

    $$('[data-disc-badge]').forEach(function (el) {
      if (disc > 0) {
        el.hidden = false;
        el.textContent = pct > 0 ? '\u2212' + pct + '%' : '\u2212' + money(disc);
        el.classList.toggle('disc-badge--combo', isCombo);
        el.classList.toggle('disc-badge--sub', isSub && !isCombo);
        /* ONE-TRUTH-20261101：全站只有一个折扣 —— 订阅 10%。
           原来这里写 'Subscriber 5%'（FRIEND15 组合码时代的遗留），客户 hover 徽章
           看到 5% 而实际减了 10%，是明确的错。 */
        el.setAttribute('title', isSub ? 'Subscriber 10%' : title);
      } else {
        el.hidden = true;
      }
    });
  }

  function paintCart() {
    /* 还没拿到真实购物车就别画：否则 money(0)/item_count=0 会把服务端渲染的
       $29.70 / 角标 8 覆盖成 $0.00 / 0（实测踩到，属 P0）。 */
    if (!cartFresh) return;
    var n = cart.item_count || 0;
    /* REELS-CARD-HEIGHT-20261026：加购会让看货器信息块多出「还差多少包邮 · View cart」那一行，
       信息块一变高、卡片可用高度就变 ⇒ 必须重算一次 --uiH/--fitH，
       否则高度还按旧的算，视频被压扁/出现白边（侯哥 20:39 那张截图）。 */
    try { setTimeout(syncVidFrames, 40); } catch (e) {}

    // 角标（页头、播放器里各一个）
    $$('#cartCount, [data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('on', n > 0);
    });

    // 底部结算条：有货、且不在结账/商品页（商品页有自己的购买条）时出现
    var bar = $('#cartbar');
    if (bar) {
      /* CARD-4UP-20261023 原本合集页也隐藏（怕 69px 固定条盖住第二排卡片按钮）。
         🔴 CARTBAR-COLLECT-20261025（侯哥 21:00 截图要求）：「合集加购里也显示这条」。
         遮挡改用**容器底部留白**解决（见 sections/cart-bar.liquid 的 padding-bottom），
         不再靠「不显示」来回避。PDP 有自己的购买条、购物车页有汇总区、结账页不用 —— 这三处继续隐藏。 */
      var hideOn = /\/products\//.test(location.pathname) ||
                   /\/checkout/.test(location.pathname) ||
                   /\/cart/.test(location.pathname) ||
                   document.body.classList.contains('locked');
      var show = n > 0 && !hideOn;
      bar.classList.toggle('on', show);
      document.body.classList.toggle('has-cartbar', show);
      if (n > 0) {
        var c1 = $('#cartbarCount'), c2 = $('#cartbarTotal');
        if (c1) c1.textContent = n + (n === 1 ? ' item' : ' items');
        if (c2) c2.textContent = money(cart.total_price);
        /* 2026-10-24 11:3x：底部条差额并进上一行 —— 括号挂在金额后面，不再单开第二行。
           口径与 cart-bar.liquid / 抽屉免邮条 / locales 完全一致。 */
        var ship = $('[data-cartbar-ship]');
        if (ship) {
          var th = parseInt(ship.getAttribute('data-threshold'), 10) || 9900;
          var left = th - cart.total_price;
          ship.textContent = left > 0
            ? '(' + moneyNZ(left) + ' to free shipping)'
            : '(Free shipping)';
          ship.classList.toggle('is-hit', left <= 0);
        }
      }
    }

    // 播放器里的结算条
    $$('[data-reel-checkout]').forEach(function (el) {
      el.classList.toggle('on', n > 0);
      var b = el.querySelector('[data-reel-count]'), i = el.querySelector('[data-reel-total]');
      if (b) b.textContent = n + (n === 1 ? ' item' : ' items');
      if (i) i.textContent = money(cart.total_price);
      /* 2026-10-24 12:0x：包邮差额跟全站 sticky bar 同一口径（金额后括号，11px 弱化） */
      var rs = el.querySelector('[data-reel-ship]');
      if (rs) {
        var rth = parseInt(el.getAttribute('data-threshold'), 10) || 9900;
        var rleft = rth - cart.total_price;
        rs.textContent = rleft > 0
          ? '(' + moneyNZ(rleft) + ' to free shipping)'
          : '(Free shipping)';
        rs.classList.toggle('is-hit', rleft <= 0);
      }
    });
    /* REELS-FIT-20261024：结算条显隐会改变文字块高度（46 + 10），图必须重算，
       否则车里有货时图会压到结算条上。 */
    layoutReels();

    // 抽屉里的数目和金额
    var d = $('#drawerCount'); if (d) d.textContent = n;
    // 2026-10-23：抽屉和购物车页各有一套金额节点，$ (querySelector) 只写第一个
    // ⇒ 购物车页的合计永远停在首屏渲染值。改成写全部匹配节点。
    if (typeof cart.total_price === 'number') {
      $$('[data-subtotal]').forEach(function (el) { el.textContent = money(cart.items_subtotal_price); });
      paintTotalPrice();
      $$('[data-checkout-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
    }

    /* THANKYOU-SHARE-20261023：购物车从「有货」变「空车」＝ 极大概率刚下完单
       ⇒ 自动弹一次分享面板。判定用的是**手上已有的 cart 状态**，不发任何请求
       （上一版在 referral-share 里 fetch /cart.js 判定，实测每次进站白扣 1s）。
       只在真降为 0 时弹一次（sessionStorage 防重），首页之后正常浏览不再打扰。 */
    try {
      var _prevN = Number(localStorage.getItem('bb_last_cart') || -1);
      /* ⚠️ 只在首页弹：购物车页/商品页把车清空通常是「删光了」而不是「下完单」，
         在这儿弹分享卡就是打扰（实测 /cart 页误弹过一次）。 */
      var _onHome = (location.pathname === '/' || location.pathname === '');
      if (_onHome && _prevN > 0 && n === 0 && !sessionStorage.getItem('bb_thanks')) {
        sessionStorage.setItem('bb_thanks', '1');
        setTimeout(function () {
          if (typeof window.BB_OPEN_SHARE === 'function') {
            window.BB_OPEN_SHARE('Thanks for your order \u2014 share & earn 10%');
          }
        }, 1400);
      }
      localStorage.setItem('bb_last_cart', String(n));
    } catch (e) {}

    var fs = $('[data-freeship]');
    if (fs) {
      var th = parseInt(fs.getAttribute('data-threshold'), 10) || 9900;
      var left = th - cart.total_price;
      var txt = $('[data-freeship-txt]');
      var fill = fs.querySelector('.freeship__track i');
      if (txt) {
        /* 2026-10-24 11:3x：与底部条同一口径（短句、不写整句）。抽屉这条独立成行，不带括号。 */
        txt.textContent = left > 0
          ? '(' + moneyNZ(left) + ' to free shipping)'
          : '(Free shipping)';
      }
      if (fill) fill.style.width = (left > 0 ? Math.min(100, cart.total_price / th * 100) : 100) + '%';
    }

    // 购物车页的「同系列」货架：要跟着购物车数据走，所以挂在 paintCart 末尾
    // （抽屉那支只在 openCart 里跑，因为抽屉是点开才渲染）
    renderPageRecs();
  }

  /* ---------------- toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    var s = $('#toastText'); if (s) s.textContent = msg || 'Added to cart';
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }
  /* BB-STOCK-LIVE-20261029：库存实况监控模块在另一个 IIFE 里，需要复用同一个 toast */
  try { window.__bbToast = toast; } catch (e) {}

  /* ---------------- add to cart（乐观更新） ---------------- */
  /* INSTANT-ADD-20261023（侯哥：「在这个界面加购总要加载才能显示，不能无感加入吗」）
     ---------------------------------------------------------------------------
     病根不是慢，是**整页刷新**：购物车页点推荐卡 Add 后，原代码 `setTimeout(location.reload, 750)`
     ——注释还写着「购物车页的行是服务端渲染的，加完必须让服务端重排」。一次 reload 就是 2~4s
     （跨境 + Shopify 渲染），用户看到的就是「点了没反应，等一会儿整页闪一下」。
     做法：**本地先插一行**（用推荐卡现成的图/名/价，视觉与真行一致），
     服务端回来后只把 data-line-key 补上、价格校正，**不重建、不刷新**；
     加购失败就把这行撤掉。
     ⚠️ 占位行故意不带 data-line-key —— refreshDrawer/折叠算法只认带 key 的行，
        不会误把它当成购物车行去匹配，也就不会误删。
     ⚠️ 占位期间 Remove 按钮 disabled：此时没有真 key，点了会打空。 */
  /* 🔴 DRAWER-OPTIMISTIC-20261026（侯哥 21:34：「推荐区加购还是太慢，点一下半天加到购物车」）
     实测瓶颈不在接口（POST /cart/add.js 874ms、GET /cart.js 288ms），而在**串行等待**：
       add.js → cart.js → syncDrawerHTML（再拉一次抽屉 section）→ 才重绘列表。
     抽屉里 4.4 KB/s 的移动网络下这三步串起来就是好几秒，期间购物车列表**一个字都不动**
     ⇒ 用户当然觉得「半天没加上」。
     注意：原来的 insertPendingLine 只喂 `#cartPageLines`（购物车页），抽屉里根本没有占位行。
     这里补一个抽屉版：点下即插一行「Adding…」，服务端回来后 syncDrawerHTML 整块替换掉它。
     失败也没关系 —— catch 分支同样会 syncDrawerHTML 冲掉。 */
  function insertDrawerPendingLine(btn) {
    var body = document.getElementById('drawerBody');
    if (!body || !btn) return;
    if (body.querySelector('[data-pending="1"]')) return;   /* 一次只插一行，别叠 */
    var item  = btn.closest('.rec__item');
    var img   = item && item.querySelector('img');
    var name  = item && item.querySelector('.rec__n');
    var price = item && item.querySelector('.rec__p');
    var row = document.createElement('div');
    row.className = 'line';
    row.setAttribute('data-pending', '1');
    row.innerHTML =
      '<a class="line__img">' + (img && img.src ? '<img src="' + img.src + '" width="80" height="80" alt="">' : '') + '</a>' +
      '<div class="line__mid">' +
        '<a class="line__name">' + (name ? name.textContent.trim() : '') + '</a>' +
        '<div class="line__var">Adding…</div>' +
      '</div>' +
      '<div class="line__price tnum">' + (price ? price.textContent.trim() : '') + '</div>';
    /* ⚠️ 必须用 first.parentNode.insertBefore —— `.line` 不在 #drawerBody 的直接子级
       （外面还裹着 wrapper），直接 body.insertBefore(row, first) 会抛
       「The node before which the new node is to be inserted is not a child of this node」，
       然后被外层 try 静默吞掉，占位行永远不出现（本轮踩过，白查两轮）。 */
    var first = body.querySelector('.line');
    if (first && first.parentNode) first.parentNode.insertBefore(row, first);
    else body.appendChild(row);
    try { applyDrawerFold(); } catch (e) {}
  }

  function insertPendingLine(vid, card, qty) {
    var box = document.getElementById('cartPageLines');
    if (!box) return null;
    var row = document.createElement('div');
    row.className = 'line';
    row.setAttribute('data-pending', '1');
    row.setAttribute('data-vid', String(vid));
    row.innerHTML =
      '<a class="line__img">' + (card.img ? '<img src="' + card.img + '" width="80" height="80" alt="">' : '') + '</a>' +
      '<div class="line__mid">' +
        '<a class="line__name">' + (card.title || '') + '</a>' +
        '<div class="line__var"></div>' +
        '<div class="line__foot">' +
          '<div class="miniqty" data-qty><button type="button" data-qty-down aria-label="-">-</button>' +
          '<span class="tnum" data-qty-val>' + (qty || 1) + '</span>' +
          '<button type="button" data-qty-up aria-label="+">+</button></div>' +
          '<button class="line__rm" type="button" data-remove disabled>Remove</button>' +
        '</div></div>' +
      '<div class="line__price tnum">' + (card.price || '') + '</div>';
    var cont = box.querySelector('.cart-continue');
    if (cont) box.insertBefore(row, cont); else box.appendChild(row);
    row.style.opacity = '0';
    row.style.transition = 'opacity .18s var(--ease)';
    requestAnimationFrame(function () { row.style.opacity = '1'; });
    try { applyCartFold(); } catch (e) {}
    return row;
  }

  /* 服务端回来后把占位行「转正」：补真 key、校正价格、放开 Remove、闪一下。
     找不到对应 item ＝ 加购其实失败了 ⇒ 撤掉占位行，不留假行。 */
  function settlePendingLines() {
    var pend = $$('[data-pending]');
    if (!pend.length) return;
    var items = (cart && cart.items) || [];
    pend.forEach(function (row) {
      var vid = row.getAttribute('data-vid');
      var hit = null;
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].id) === vid) { hit = items[i]; break; }
      }
      if (!hit) { row.parentNode && row.parentNode.removeChild(row); return; }
      row.removeAttribute('data-pending');
      if (hit.key) row.setAttribute('data-line-key', hit.key);
      var p = row.querySelector('.line__price');
      if (p) p.textContent = money(hit.final_line_price);
      var q = row.querySelector('[data-qty-val]');
      if (q) q.textContent = hit.quantity;
      var rm = row.querySelector('.line__rm');
      if (rm) rm.disabled = false;
      row.classList.add('just-added');
      setTimeout(function () { row.classList.remove('just-added'); }, 1600);
    });
    try { applyCartFold(); } catch (e) {}
  }

  /* ================= 库存闸门 STOCK-GUARD-20261025 =================
     侯哥 21:10 截图报：「明明库存只有一个，却能无限加购，库存岂不是摆设」。

     实测的事实（不改：这是 Shopify 的标准设计，不是 bug）：
       · `/cart/add.js` **不校验库存**，1 件库存的商品也能加成 8 件（2026-10-25 实测 status 200）。
         官方口径：**购物车不是库存预留（cart is not a reservation）**。
       · 库存只在 **进结账那一刻** 由 Shopify 校验并保留 10 分钟；付款成功才真正扣减。
       · 全店 221 个变体 policy=DENY、220 个 tracked=true ⇒ 服务端不会超卖。
     ⇒ 所以「加购不锁库存」是对的（否则谁都能加满购物车把库存锁死），
        但**前端不能装作加成功了**：客户加 8 件、结账只剩 1 件，是最伤人的体验。
        这里按「已知库存」在点击时就把关，并对失败给出真实原因。
     ================================================================= */
  /* 🔴 铁律 STOCK-LAW-20261030：本函数**只读真值轨**（data-inv / data-qty / bbInvMap）。
     严禁在此读取或用 data-bbs-qty、data-bbs-shown、或按钮/文案里的数字 ——
     那些是渲染轨（BBStock.shown 造出来的营销数字），参与拦截就会让客户"真实有 100 件却只让买 2 件"。
     拿不到真值 ⇒ 返回 null（放行，交结账兜底），绝不用渲染值顶上。 */
  /* 这个入口能拿到的库存上限：data-inv（看货器/商品卡）→ data-qty（PDP 变体）→ bbInvMap（handle 映射） */
  function stockLeftOf(el) {
    try {
      var n = el.getAttribute && el.getAttribute('data-inv');
      if (n === null && el.closest) {
        var a = el.closest('[data-inv]');
        if (a) n = a.getAttribute('data-inv');
      }
      if (n !== null && n !== undefined && n !== '' && !isNaN(parseInt(n, 10))) return parseInt(n, 10);

      var form = el.closest && el.closest('form');
      var qi = (form && form.querySelector('[data-pdp-qty-input]')) || document.querySelector('[data-pdp-qty-input]');
      if (qi && qi.getAttribute('data-qty') !== null) {
        var qd = parseInt(qi.getAttribute('data-qty'), 10);
        if (!isNaN(qd)) return qd;
      }

      var h = (el.getAttribute && el.getAttribute('data-handle')) || '';
      if (!h && el.closest) {
        var hp = el.closest('[data-handle]');
        if (hp) h = hp.getAttribute('data-handle') || '';
      }
      if (!h && el.closest) {
        var lk = el.closest('a[href*="/products/"]');
        if (lk) h = (lk.getAttribute('href') || '').split('/products/')[1].split('?')[0];
      }
      if (h) {
        var m = reelInv || buildReelInv();
        if (m && m[h] !== undefined && m[h] !== null) return parseInt(m[h], 10);
      }
    } catch (e) {}
    return null;   /* 拿不到库存 ⇒ 不拦，交给 Shopify 结账时兜底 */
  }

  /* 购物车里这个变体已经放了几件（cart 里存的是 variant_id） */
  function cartQtyOf(variantId) {
    var sum = 0, vid = String(variantId);
    ((cart && cart.items) || []).forEach(function (it) {
      if (String(it.variant_id || it.id) === vid) sum += (it.quantity || 0);
    });
    return sum;
  }

  /* 返回 null = 可以加；返回字符串 = 拒绝原因（已 toast） */
  function stockGuard(el, variantId, qty) {
    var left = stockLeftOf(el);
    if (left === null) return null;              /* 库存未知，交给服务端 */
    var want = qty || 1;
    var inCart = cartQtyOf(variantId);
    /* STOCK-UI-RESET-20261030：被拦时把按钮残留的「Added ✓」立刻收回来。
       否则连点场景下客户看到的是「已加购」+「已满」两个矛盾信号。
       目录上的 dataset.label 是首次点击存下的原始文案（见 CARD-LABEL-20261030）。 */
    function _resetBtn() {
      if (!el || !el.dataset || !el.dataset.label) return;
      el.textContent = el.dataset.label;
      el.classList.remove('is-added');
      if (el.style) el.style.opacity = '';
    }
    if (left <= 0) {
      _resetBtn();
      toast('Sold out — this card just went');
      return 'soldout';
    }
    if (inCart + want > left) {
      _resetBtn();
      var canAdd = Math.max(0, left - inCart);
      if (canAdd > 0) {
        toast('Only ' + left + ' in stock (' + inCart + ' already in your cart)');
      } else if (left === 1) {
        toast('This is the only one — it’s already in your cart');
      } else {
        toast('All ' + left + ' in stock are already in your cart');
      }
      return 'over';
    }
    return null;
  }
  function addToCart(variantId, qty, opts) {
    opts = opts || {};
    var before = { count: cart.item_count, total: cart.total_price };

    // 先动界面（没拿到真实购物车就先别乐观更新，等 fetchCart 回填）
    if (cartFresh) {
      cart.item_count += qty;
      paintCart();
    }
    if (!opts.quiet) toast();

    /* PERF-ADD-OPTIMISTIC-20261023：上面那句 `if (cartFresh)` 只在「已经拿到过真实购物车」
       之后才乐观；页面刚加载、fetchCart 还没回来时点加购，角标是**不动**的
       （用户以为没点上，等 0.9s 才跳数字）。这里补上未就绪时的兜底：
       直接在当前 DOM 数字上 +qty，等服务端回来由 paintCart 校正。
       ⚠️ 必须放在 `if (cartFresh)` 之外且**只在 !cartFresh 时**执行，否则会 +2 次。 */
    /* 购物车页点推荐卡加购：先插一行（视觉 0 延迟），服务端回来由 settlePendingLines 转正。
       其它入口（商品卡/PDP/抽屉）不开这个，因为用户看不到购物车页的列表。 */
    if (opts.card) { try { insertPendingLine(variantId, opts.card, qty || 1); } catch (e) {} }

    if (!cartFresh) {
      try {
        $$('#cartCount, [data-cart-count]').forEach(function (el) {
          var _n = parseInt(el.textContent, 10) || 0;
          el.textContent = String(_n + (qty || 1));
          el.classList.add('on');
        });
      } catch (e) {}
    }

    /* ADD-TIMEOUT-20261029：跨境链路抖动时 add.js 实测最慢到 9.7s，
       旧代码没有超时 —— 按钮会一直停在 Adding…，用户只能干等。
       8s 未回就直接判失败、走 catch 回滚（角标退回、提示重试）。 */
    var _ac = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var _tm = _ac ? setTimeout(function () { try { _ac.abort(); } catch (e) {} }, 8000) : 0;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty }),
      signal: _ac ? _ac.signal : undefined
    })
      .then(function (r) {
        if (_tm) { clearTimeout(_tm); _tm = 0; }
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      /* 🔴 DRAWER-OPTIMISTIC-20261026：原来 cart.js → syncDrawerHTML 是**串行**的，
         两次跨境往返叠加（0.29s + 0.7s 起），弱网下直接变成「半天」。
         两者互不依赖（抽屉 HTML 是服务端按购物车渲染的），改 Promise.all 并行，省一整趟。 */
      .then(function () {
        var d = document.getElementById('drawer');
        var p1 = fetchCart(true);
        var p2 = (d && d.classList.contains('on')) ? syncDrawerHTML(true) : Promise.resolve(true);
        var all = Promise.all([p1, p2]);
        /* ══ REEL-ADD-FAST-20261029（侯哥 08:4x：「加购点了之后反应很慢」）════════
           线上实测（412×915）：点击 → /cart/add.js 844ms 回 200 → /cart.js 再 390ms
           → 按钮才变 Added ✓，合计 1272ms。
           但按钮的「成功/失败」只取决于 /cart/add.js，/cart.js 与抽屉重渲染只是刷新
           角标金额与抽屉列表 —— **不该挡着按钮反馈**。
           fast=true（看货器、商品卡这类不开抽屉的入口）⇒ add.js 一回来就返回 true，
           购物车同步丢后台跑，失败也不影响已成功的加购。
           PDP 大按钮仍走原串行（它加完要立刻 openCart，抽屉 HTML 必须是最新的）。 */
        if (opts.fast) {
          /* 后台同步再等内容：先让「Added ✓」画完（下一帧），再发 /cart.js，
             免得两趟跨境请求抢同一条连接，把按钮反馈拖慢。 */
          all.then(function () { try { revealAdded(); } catch (e) {} }).catch(function () {});
          return true;
        }
        return all;
      })
      /* 🔴 ADD-RESULT-20261027：这里原来**没有 return** ⇒ 本 Promise 的成功值恒为 undefined，
         调用方 `_adding.then(function(ok){ ok ? 'Added ✓' : 'Not added' })` 与
         `_adding.then(function(ok){ ok && openCart() })` 全部走失败分支 ——
         线上实测 8/8 次「加购成功（add.js 200 + cart +1 + toast Added to cart）却显示 Not added」，
         客户看到 Not added 会再点一次 ⇒ 同 SKU 变 2 件；PDP 加购后抽屉也永不弹。
         修法：显式 return true（失败分支本来就是显式 return false）。 */
      .then(function () { try { revealAdded(); } catch (e) {} return true; })
      .catch(function () {
        if (_tm) { clearTimeout(_tm); _tm = 0; }
        // 失败就退回服务端真实状态，绝不留下假数字
        cart.item_count = before.count;
        cart.total_price = before.total;
        toast('Could not add — please try again');
        return fetchCart()
          .then(function () { return syncDrawerHTML(true); })
          .then(function () { return false; });
      });
  }

  var _cartChain = Promise.resolve();
  function changeLine(key, qty) {
    /* CART-RACE-20261025 ①：串行化 —— 同一时刻只允许一个 /cart/change.js 在飞。
       并发时响应乱序，用旧响应去对齐 DOM 就会把刚删掉的行画回来。 */
    _cartPending++;
    var run = function () { return _changeLineNow(key, qty); };
    var p = _cartChain.then(run).then(
      function (v) { _cartPending--; return v; },
      function (e) { _cartPending--; throw e; }
    );
    _cartChain = p.catch(function () {});
    return p;
  }

  function _changeLineNow(key, qty) {
    /* 🔴 2026-10-23 线上实测（tools/_diag_qty.js）：
       库存只剩 5 件时点「+」→ /cart/change.js 返回 **422**
       {"message":"Only 5 items were added to your cart due to availability."}，
       旧代码把错误体当购物车对象 (cart = {status:422}) ⇒ paintCart 拿到 undefined 的 item_count
       ⇒ refreshDrawer 里 `if (!cart.item_count) location.reload()` 直接把整页刷了：
       用户看到「点了 + 页面闪一下、数量没变」，也没有任何提示。这是最招人烦的假死。
       修法：先判 r.ok，非 2xx 就把 Shopify 的原话用 toast 说出来，再静默重取，绝不整页刷新。 */
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.data && (res.data.description || res.data.message)) || 'That quantity is not available';
          toast(msg);
          return fetchCart();
        }
        cart = res.data;
        cartFresh = true;
        _cartMutSeq++;                       // 标记"车已变过"，让在飞的重建作废
        if (qty === 0) delete _pendingRemove[key];
        paintCart();
        refreshDrawer();
        /* 🔴 FIX-CART-FOLD-REMOVE-20261023：原来这里只调了 applyCartFold（购物车页 /cart 的），
           抽屉的折叠从不重算 ⇒ 删掉一个「可见」行后，尾部 .is-folded 原地不动，
           每删一件可见行就少一行，删到只剩 2 行时全被折叠、列表空白，
           而「View N more」还是旧文案（实测 8→0 行，见 tools/_repro_cart_fold2_20261023.js）。
           两个函数各管一个容器，都要调。 */
        try { applyDrawerFold(); } catch (e) {}
        try { applyCartFold(); } catch (e) {}
      })
      .catch(function () {
        delete _pendingRemove[key];
        toast('Could not update — please try again');
        /* 乐观删除的回滚：行已经从 DOM 拿掉了，服务端这一步又失败 ⇒ 只能整块重建，
           把真实购物车（含刚才那行）放回来。绝不留在「行没了但车里有」的假状态。 */
        return fetchCart(true).then(function () {
          try { if (document.querySelector('.cart-page__lines')) rebuildCartLines(); } catch (e) {}
          try { if (document.getElementById('drawer') && document.getElementById('drawer').classList.contains('on')) syncDrawerHTML(true); } catch (e) {}
        });
      });
  }

  /* 🔴 CART-DRAWER-SYNC-20261023（2026-10-23 07:2x 侯哥报的 P0）
     病根：抽屉里的商品行**只在页面加载时由 Liquid 服务端渲染一次**。
     addToCart() 成功后只做了 fetchCart + paintCart —— 它们只改角标、金额、免邮文案，
     从不重绘 `.cart-lines`。后果（线上实测，tools/_diag_cart_real_20261023.js）：
       · 页面加载时车是空的 ⇒ 抽屉渲染空态；加购 1/2 件后打开抽屉，
         `Your cart 2` 数字对、`$19.80` 金额对，但商品行一条都没有，也没有 Checkout 按钮；
       · 页面加载时车里有货 ⇒ 逐件 Remove 会把行一条条删掉（refreshDrawer 的 row.remove()），
         之后再加购，行永远是空的 ⇒ 侯哥截图那张「Your cart 2 / $19.80 / 行区空白」。
     修法：用 Section Rendering API 拉服务端渲染好的整块 drawer，原地替换 innerHTML。
     保持事件不变（所有点击都委托在 document 上，替换 DOM 不会丢监听）。 */
  var _drawerSyncAt = 0, _drawerSyncBusy = null, _drawerRetried = false;
  function syncDrawerHTML(force) {
    var now = Date.now();
    if (!force && now - _drawerSyncAt < 1200) return Promise.resolve(true);
    if (_drawerSyncBusy) return _drawerSyncBusy;
    _drawerSyncBusy = fetch('/?section_id=cart-drawer&_=' + now, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        _drawerSyncBusy = null;
        _drawerSyncAt = Date.now();
        if (!html) return false;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#drawer');
        var cur = $('#drawer');
        if (!fresh || !cur) return false;
        var wasOn = cur.classList.contains('on');
        /* 🔴 DRAWER-REC-KEEP-20261026（侯哥 20:43：加购卡死半天 · 第二轮定位）
           上一处只挡住了 renderCartRecs 的重建，真正的大头在这里：
             `cur.innerHTML = fresh.innerHTML` 把**整个抽屉**换掉 ⇒ 推荐区那 4 个 <img>
             连同节点一起销毁 ⇒ renderCartRecs 再填回来时浏览器只能重新下载。
             实测 5 张推荐图合计 30s（ttfb 1.4s、下行 ~9.8 KB/s）就是这么来的。
           修：替换前把 #cartRec 那个节点**整个摘出来**（节点不销毁、img 不解码），
               替换后放回服务端刚给的那个空占位里。DOM 节点复用 ⇒ 图片零重新请求。
           ⚠️ 必须用 move 而不是保存 innerHTML —— 存字符串等于重建节点，还是会重下。 */
        var recNode = cur.querySelector('#cartRec');
        if (recNode && recNode.parentNode) recNode.parentNode.removeChild(recNode);
        cur.innerHTML = fresh.innerHTML;
        if (recNode) {
          var slot = cur.querySelector('#cartRec');
          if (slot && slot.parentNode && slot !== recNode) slot.parentNode.replaceChild(recNode, slot);
          else if (!slot) cur.appendChild(recNode);
        }
        // 只搬状态 class，别的 class（主题/应用加的）一律保留，别整包覆盖
        cur.classList.toggle('on', wasOn);
        cur.setAttribute('aria-hidden', wasOn ? 'false' : 'true');
        // 重建出来的 DOM 是「裸服务端渲染」：免邮文案的 {{ amount }} 走的是整串 money（畸形成 $0.00），
        // 送达预估停在 'Arrives —'。这两块原来只在 init 时算一次，重建后必须补跑，否则抽屉里就是坏文案。
        try { paintCart(); } catch (e) {}
        try { paintDelivery(); } catch (e) {}
        try { applyDrawerFold(); } catch (e) {}
        if (wasOn) { try { renderCartRecs(); } catch (e) {} try { renderPageRecs(); } catch (e) {} }
        /* 🔴 DRAWER-EMPTY-RETRY-20261023：加购高峰实测偶发「服务端说 item_count=8、抽屉却一行没有」
           （syncDrawerHTML 拿到瞬时/缓存的空车响应，2026-10-23 13:0x 线上复现一次）。
           对买家这就是「购物车突然空了」，必须自愈：只重试一次，避免死循环。 */
        if (cart && cart.item_count > 0 && !document.querySelectorAll('#drawerBody .line').length
            && !_drawerRetried) {
          _drawerRetried = true;
          setTimeout(function () { _drawerRetried = false; syncDrawerHTML(true); }, 700);
        }
        return true;
      })
      .catch(function () { _drawerSyncBusy = null; return false; });
    return _drawerSyncBusy;
  }

  /* 🔴 DRAWER-COMPACT-FOLD-20261023（2026-10-23 07:5x 侯哥：「完全显示不了几个商品」）
     行压缩后（见 sections/cart-drawer.liquid 里的 <style>）按**真实可用高度**算能放几行：
     可用 = body 可视高 － 免邮条 － 金额区 － 送达条 － 折叠按钮，
     N = floor(可用 / 单行高)，下限 2 行。超出的行加 .is-folded，折成「View N more」，
     点开看全部（可再收起）。任何品牌/机型高度都自适应，不写死数字。 */
  var cartFoldOpen = false;
  function applyDrawerFold() {
    var body = $('#drawerBody');
    if (!body) return;
    var oldBtn = body.querySelector('[data-cart-fold]');
    if (oldBtn && oldBtn.parentNode) oldBtn.parentNode.removeChild(oldBtn);
    var lines = $$('#drawerBody .line');
    if (!lines.length) return;
    lines.forEach(function (l) { l.classList.remove('is-folded'); });
    if (lines.length <= 2) { cartFoldOpen = false; return; }

    /* 行被折叠（display:none）时 offsetHeight 是 0 ⇒ 直接除会得到 Infinity，
       再用 Math.max(2, Infinity) 会把所有行都折叠掉。显式兜底。 */
    var rowH = Math.max(60, lines[0].offsetHeight || 92);
    /* reserved 只算「必须留在商品行下面的东西」：
       · 免邮条已经移到滚动区外（FREESHIP-PINNED-20261023），body.clientHeight 天然扣掉了；
       · .drawer__totals（小计/合计）**不再计入** —— 它就在行列表末尾，往下滚一格就能看到，
         而 Checkout 按钮在 drawer__foot 常驻，用户不滚也能下单。
         把 totals 算进去会让一屏只剩 2 行（2026-10-23 实测 8 件时只露 2 行，太少）。 */
    var reserved = 0;
    ['.delivery'].forEach(function (sel) {
      var el = body.querySelector(sel);
      if (el) reserved += el.offsetHeight;
    });
    var avail = body.clientHeight - reserved - 40;
    var maxN = Math.max(2, Math.floor(avail / rowH));
    if (maxN >= lines.length) { cartFoldOpen = false; return; }

    var rest = lines.length - maxN;
    if (!cartFoldOpen) {
      for (var j = maxN; j < lines.length; j++) lines[j].classList.add('is-folded');
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cart-fold';
    btn.setAttribute('data-cart-fold', '1');
    btn.textContent = cartFoldOpen
      ? 'Show fewer ▴'
      : 'View ' + rest + ' more item' + (rest > 1 ? 's' : '') + ' ▾';
    var host = body.querySelector('.cart-lines');
    if (host) host.parentNode.insertBefore(btn, host.nextSibling);
  }

  /* 加购后把新加的那一行露出来并闪一下：
     syncDrawerHTML 会整块重建 DOM，用户如果不看总价根本不知道加没加上。
     若新行正好被折叠，先自动展开（刚加的东西不能藏起来）。 */
  function revealAdded() {
    var lines = $$('#drawerBody .line');
    if (!lines.length) return;
    var last = lines[lines.length - 1];
    if (!last.getBoundingClientRect().height) {
      cartFoldOpen = true;
      applyDrawerFold();
      lines = $$('#drawerBody .line');
      last = lines[lines.length - 1];
    }
    if (!last) return;
    last.classList.remove('just-added');
    void last.offsetWidth;              // 强制重排，保证动画能重放
    last.classList.add('just-added');
    setTimeout(function () { last.classList.remove('just-added'); }, 1900);
    try { last.scrollIntoView({ block: 'nearest' }); } catch (e) {}
  }

  /* 🔴 CART-PAGE-COMPACT-20261023（2026-10-23 08:4x 侯哥：「结算页还是老样子，应该和加购页面同步」）
     购物车页 /cart 的折叠。服务端现在全量渲染（无 JS 也能看到全部），这里按真实可用高度收：
     可用 = 视口高 − 列表顶部离视口顶的距离 − 底部固定结算条(手机) − 尾部(Continue/政策行) − 按钮高，
     N = floor(可用 / 单行高)，下限 2；超出的加 .is-folded，按钮「View N more items ▾ / Show fewer ▴」。
     和抽屉用同一套算法，只是容器不同。 */
  var cartPageFoldOpen = false;
  function applyCartFold() {
    var host = document.getElementById('cartPageLines');
    if (!host) return;
    var oldBtn = host.parentNode ? host.parentNode.querySelector('[data-cart-fold-page]') : null;
    if (oldBtn && oldBtn.parentNode) oldBtn.parentNode.removeChild(oldBtn);
    var lines = $$('#cartPageLines .line');
    if (!lines.length) return;
    lines.forEach(function (l) { l.classList.remove('is-folded'); });
    if (lines.length <= 2) { cartPageFoldOpen = false; return; }

    var rowH = lines[0].offsetHeight || 80;
    var topInView = host.getBoundingClientRect().top;
    var bottomBar = window.innerWidth > 732 ? 0 : 96;
    var tail = 0;
    ['.cart-continue', '.cart-legal'].forEach(function (sel) {
      var el = document.querySelector('.cart-page ' + sel);
      if (el && el.getBoundingClientRect().height) tail += el.offsetHeight + 14;
    });
    var avail = window.innerHeight - Math.max(topInView, 0) - bottomBar - tail - 46;
    var maxN = Math.max(2, Math.floor(avail / rowH));
    if (maxN >= lines.length) { cartPageFoldOpen = false; return; }

    var rest = lines.length - maxN;
    if (!cartPageFoldOpen) {
      for (var j = maxN; j < lines.length; j++) lines[j].classList.add('is-folded');
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cart-fold';
    btn.setAttribute('data-cart-fold-page', '1');
    btn.textContent = cartPageFoldOpen
      ? 'Show fewer ▴'
      : 'View ' + rest + ' more item' + (rest > 1 ? 's' : '') + ' ▾';
    /* 🔴 按钮必须紧贴商品行：原来 insertBefore(host.nextSibling) 是插到整个列表区块之后，
       Continue shopping / 政策行都在区块里面 ⇒ 按钮被甩到页面底部（2026-10-23 实测截图）。
       折叠态插在第一个被隐藏的行前面；展开态插在最后一行后面。 */
    if (!cartPageFoldOpen) {
      lines[maxN].parentNode.insertBefore(btn, lines[maxN]);
    } else {
      var lastLine = lines[lines.length - 1];
      lastLine.parentNode.insertBefore(btn, lastLine.nextSibling);
    }
  }

  /* 🔴 LINE-KEY-DRIFT-20261023（侯哥：「加了三个，移除了一个，就变成一个，另外一个也不加载了」）
     ------------------------------------------------------------------------------------------
     病根：cart/change.js 会给「没动过」的行也重新生成 line key 的哈希。实测同一件商品：
       DOM 里（页面加载时 Liquid 渲染）  41947622965381:447349eddc6455bd2fe62243449c143c
       change.js 返回                    41947622965381:a98337d2b38f4f4aad93b2016b5cf007
       —— variant id 相同，哈希变了。
     旧版 refreshDrawer 是「按 key 匹配、匹配不上就 row.remove()」⇒ 只要 key 漂移就把
     **不该删的行也删掉**：3 件移除 1 件、服务端剩 2 件，DOM 只剩 1 行，
     角标与金额是 2 件、列表 1 行 —— 侯哥截图那张就是这个。

     修法（四件一起，缺一不可）：
       1. 匹配改成「key 命中 → 否则用 variant_id 兜底」（id 稳定，key 的哈希不稳定）；
       2. 永不 row.remove() —— 匹配不上就跳过，宁可留旧行，绝不删错；
       3. 命中后把行的 data-line-key 刷成新 key，下次就不用兜底；
       4. 行集合对不上（匹配数 < cart.items 数）⇒ 整块重建：抽屉 syncDrawerHTML、
          购物车页拉 ?section_id=main-cart 重建 #cartPageLines。减少行只走这条路，由服务端说了算。
     ------------------------------------------------------------------------------------------ */
  /* ===== CART-RACE-20261025（侯哥 21:30 报的"移除后跳回来又消失"）======
     _cartMutSeq   ：每次变更成功 +1，用来丢弃过期的 section 响应
     _cartPending  ：在飞的 /cart/change.js 数量；>0 时**禁止重建**（重建会把中间态画上去）
     _pendingRemove：乐观删除中的 line key；重建后要再删一遍，绝不复活 */
  var _cartRebuildBusy = false;
  var _cartMutSeq = 0;
  var _cartPending = 0;
  var _pendingRemove = {};
  window.__cartRaceGuard = { skippedRebuild: 0, staleDropped: 0, revivedKilled: 0 };

  /* ================= 移除幂等化 REMOVE-ALL-20261025 =================
     侯哥 2026-10-25 23:2x：「全部移除之后有时候卡住不跳空车页，刷新后还剩一件，要再删一次」
     —— 复现脚本 tools/_diag_cart_remove_all_20261025.js --slow=3000 --interrupt：
        慢网下每件 Remove 排一次 /cart/change.js（3s/次），3 件要 9s；用户等不住自己下拉刷新，
        在飞的请求被浏览器掐断 ⇒ 服务端一件都没删掉（4/4 组复现，刷新后残留 1~2 件）。
        结论：**不是浏览器缓存**（/cart 是服务端渲染，刷新后仍显示 = 服务端真有）。
     修法四条（缺一条就会复发）：
       ① 连点合并成**一次** /cart/update.js —— N 件也只等 1 个 RTT，不再 3s×N；
       ② 发请求前重读 /cart.js，用**最新 line key**（key 会随属性/折扣漂移，Shopify 官方确认）；
       ③ 失败自动重试（≤2 次），每次重解析 key；
       ④ pagehide / hidden 时用 sendBeacon 把没落地的移除补发 —— 手刷、切后台、关标签都不留残件。
     ================================================================= */
  var _removeIntents = {};      // variantId -> 最新已知 line key
  var _removeTTL = 120000;      // 意图有效期：超过 2 分钟就当过期，避免误删客户重新加的同款
  var _removeFlushTimer = null, _removeFlushBusy = false, _removeRetry = 0;

  function markRemoveLine(row) {
    if (!row) return;
    var k = row.getAttribute('data-line-key') || '';
    var vid = k.split(':')[0];
    if (!vid) return;
    _removeIntents[vid] = k;
    _pendingRemove[k] = 1;
    saveRemoveIntents();
    scheduleRemoveFlush();
  }

  /* 为什么要落盘：手刷那一刻在飞的请求一定被掐断，beacon 又可能比新页面的 /cart.js 慢一步，
     新页面就会渲染出「其实已经被删掉」的旧行。落盘一次，新页面自己再补一刀。 */
  function saveRemoveIntents() {
    try { sessionStorage.setItem('bb_remove_intents', JSON.stringify({ t: Date.now(), v: _removeIntents })); } catch (e) {}
  }
  function clearRemoveIntents() { try { sessionStorage.removeItem('bb_remove_intents'); } catch (e) {} }
  function restoreRemoveIntents() {
    try {
      var raw = sessionStorage.getItem('bb_remove_intents');
      if (!raw) return;
      var o = JSON.parse(raw);
      if (!o || !o.v || Date.now() - (o.t || 0) > _removeTTL) { clearRemoveIntents(); return; }
      var n = 0;
      Object.keys(o.v).forEach(function (vid) { if (o.v[vid]) { _removeIntents[vid] = o.v[vid]; n++; } });
      if (n) { scheduleRemoveFlush(); }
      else clearRemoveIntents();
    } catch (e) { clearRemoveIntents(); }
  }

  function scheduleRemoveFlush() {
    clearTimeout(_removeFlushTimer);
    _removeFlushTimer = setTimeout(flushRemoveIntents, 60);
  }

  function flushRemoveIntents() {
    if (_removeFlushBusy) { scheduleRemoveFlush(); return Promise.resolve(); }
    if (!Object.keys(_removeIntents).length) { _removeRetry = 0; return Promise.resolve(); }
    _removeFlushBusy = true;
    return fetch('/cart.js?_=' + Date.now(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || typeof c.item_count !== 'number') throw new Error('cart read failed');
        cart = c; cartFresh = true;
        var onServer = {};
        (c.items || []).forEach(function (it) { onServer[String(it.id)] = it.key; });
        var updates = {}, remain = 0;
        Object.keys(_removeIntents).forEach(function (vid) {
          if (onServer[vid]) { _removeIntents[vid] = onServer[vid]; updates[onServer[vid]] = 0; remain++; }
          else delete _removeIntents[vid];      // 服务端已经没有了 ⇒ 意图达成（幂等）
        });
        if (!remain) { _removeFlushBusy = false; _removeRetry = 0; clearRemoveIntents(); settleRemoveUI(c.item_count); return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.text().then(function (t) { var d = null; try { d = JSON.parse(t); } catch (e) {} return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            _removeFlushBusy = false;
            if (res.ok && res.d && typeof res.d.item_count === 'number') {
              cart = res.d; cartFresh = true; _cartMutSeq++;
              (res.d.items || []).forEach(function (it) { delete _removeIntents[String(it.id)]; });
              Object.keys(_pendingRemove).forEach(function (kk) { delete _pendingRemove[kk]; });
              try { paintCart(); } catch (e) {}
              try { applyCartFold(); } catch (e) {}
              try { applyDrawerFold(); } catch (e) {}
              if (Object.keys(_removeIntents).length && _removeRetry < 2) { _removeRetry++; saveRemoveIntents(); scheduleRemoveFlush(); return; }
              _removeRetry = 0;
              if (!Object.keys(_removeIntents).length) clearRemoveIntents(); else saveRemoveIntents();
              settleRemoveUI(res.d.item_count);
            } else if (_removeRetry < 2) {
              _removeRetry++; scheduleRemoveFlush();
            } else {
              _removeRetry = 0;
              toast('Could not update — please try again');
              try { location.reload(); } catch (e) {}
            }
          });
      })
      .catch(function () {
        _removeFlushBusy = false;
        if (_removeRetry < 2) { _removeRetry++; scheduleRemoveFlush(); }
        else { _removeRetry = 0; toast('Could not update — please try again'); }
      });
  }

  /* 终态：0 件 ⇒ 跳空车页；仍有残留 ⇒ 让服务端重渲。
     绝不留在「行被我删了、车里其实还有」这种半坏状态（那才是结账时被砍单的源头）。 */
  function settleRemoveUI(count) {
    if (typeof count !== 'number') return;
    if (count === 0) { try { location.reload(); } catch (e) {} return; }
    if (document.getElementById('cartPageLines')) { try { rebuildCartLines(); } catch (e) {} }
    else { try { syncDrawerHTML(true); } catch (e) {} }
  }

  /* 用户手刷 / 切后台 / 关标签页：把还没落地的移除用 beacon 补发（文档卸载后浏览器仍会送出） */
  function beaconPendingRemoves() {
    var updates = {};
    Object.keys(_removeIntents).forEach(function (vid) {
      var k = _removeIntents[vid];
      if (k) updates[k] = 0;
    });
    if (!Object.keys(updates).length) return;
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon('/cart/update.js', new Blob([JSON.stringify({ updates: updates })], { type: 'application/json' }));
      }
    } catch (e) {}
  }
  window.addEventListener('pagehide', beaconPendingRemoves);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') beaconPendingRemoves();
  });
  restoreRemoveIntents();     // 上次没删干净就接着删（幂等，服务端没有了就什么都不做）

  function rebuildCartLines() {
    if (_cartRebuildBusy) return;
    if (_cartPending > 0) { window.__cartRaceGuard.skippedRebuild++; return; }   // ② 有变更在飞：不重建
    _cartRebuildBusy = true;
    var _seqAtStart = _cartMutSeq;
    try { syncDrawerHTML(true); } catch (e) {}
    var cur = document.getElementById('cartPageLines');
    if (!cur) { _cartRebuildBusy = false; return; }
    /* ⚠️ section_id 用 **section 文件名**（main-cart），不是 templates/cart.json 里的 key（main）：
       实测 /cart?section_id=main → 404、/?section_id=main → 404、/cart?section_id=main-cart → 200 + 8252 B。
       传错会 404 拿空 body，静默失败（上一版就是这么错的）。 */
    fetch('/cart?section_id=main-cart&_=' + Date.now(), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        _cartRebuildBusy = false;
        if (!html) return;
        /* ③ 过期响应直接丢：请求发出后又有变更成功 ⇒ 这块 HTML 已经不代表最新车 */
        if (_seqAtStart !== _cartMutSeq || _cartPending > 0) {
          window.__cartRaceGuard.staleDropped++;
          return;
        }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cartPageLines');
        var box = document.getElementById('cartPageLines');
        if (!fresh || !box) return;
        box.innerHTML = fresh.innerHTML;      // 事件全是 document 委托，替换不影响监听
        /* ③ 重建后把「乐观删除中、服务端还没删完」的行再摘一次 —— 这是"跳回来"的直接止损 */
        var revived = 0;
        Array.prototype.slice.call(box.querySelectorAll('[data-line-key]')).forEach(function (r) {
          var k = r.getAttribute('data-line-key') || '';
          if (_pendingRemove[k]) { r.parentNode && r.parentNode.removeChild(r); revived++; }
        });
        if (revived) window.__cartRaceGuard.revivedKilled += revived;
        try { paintCart(); } catch (e) {}
        try { applyCartFold(); } catch (e) {}
      })
      .catch(function () { _cartRebuildBusy = false; });
  }

  function refreshDrawer() {
    // 数量变化后，行的数字和总额就地更新，整块重渲染会打断动画
    var items = (cart && cart.items) || [];
    var byKey = {}, byVid = {};
    items.forEach(function (it) {
      byKey[it.key] = it;
      var vid = String(it.id || (it.key || '').split(':')[0] || '');
      if (vid) { (byVid[vid] || (byVid[vid] = [])).push(it); }
    });
    /* PERF-CART-20261023（侯哥：「加购和移除都响应好久」）
       ---------------------------------------------------------------------------
       量到的账（服务器本机 TTFB，不是网络问题）：
         /cart?section_id=main-cart  0.84s   ／  /?section_id=cart-drawer  0.81s
         /collections/all/products.json  1.31s
       Shopify 渲染一个 section 就要 0.8s，而上一版每次增删行都会**同时**拉这两个
       section（购物车页 0.84 + 抽屉 0.81 + change.js 0.4 ≈ 2 秒），这就是「响应好久」。
       现在改成：
         1. 先用本地 DOM 删/留（零请求）—— 判据用「孤儿行数是否正好等于差额」，
            对得上就地删；对不上才回退整块重建（重建只渲染**当前页面需要的那一个** section）；
         2. 抽屉没打开时一律不刷抽屉（打开时 openCart 会自己刷）。
       --------------------------------------------------------------------------- */
    var orphanRows = [];
    $$('[data-line-key]').forEach(function (row) {
      var k = row.getAttribute('data-line-key') || '';
      var vid = k.split(':')[0];
      // ① key 优先，② variant_id 兜底（该 variant 在车里只有一行时才敢用，避免多行同款串号）
      var it = byKey[k] || (byVid[vid] && byVid[vid].length === 1 ? byVid[vid][0] : null);
      if (!it) { orphanRows.push(row); return; }   // 先记账，暂不删
      if (it.key && it.key !== k) row.setAttribute('data-line-key', it.key);   // ③ 刷成新 key
      var v = row.querySelector('[data-qty-val]');
      if (v) v.textContent = it.quantity;
      var p = row.querySelector('.line__price');
      if (p) p.textContent = money(it.final_line_price);
    });

    if (cart && cart.item_count > 0) {
      var wantRows = items.length;
      var onCartPage = !!document.querySelector('.cart-page__lines');
      var drawerOn = !!(document.getElementById('drawer') && document.getElementById('drawer').classList.contains('on'));

      /* 购物车页：孤儿行数正好等于差额 ⇒ 就地删（0 请求、0 闪烁）。
         对不上说明 DOM 和 cart 已经不同步，只能请服务端重渲。 */
      if (onCartPage) {
        var pageRows = document.querySelectorAll('.cart-page .line').length;
        if (pageRows !== wantRows) {
          var diff = pageRows - wantRows;
          if (diff > 0 && orphanRows.filter(function (r) { return r.closest('.cart-page'); }).length === diff) {
            orphanRows.forEach(function (r) { if (r.closest('.cart-page')) r.remove(); });
            try { applyCartFold(); } catch (e) {}
          } else {
            rebuildCartLines();
          }
        }
      }

      /* 抽屉：**只在它真的打开时**才刷新；关闭时留着旧行，openCart 里会 syncDrawerHTML 补上。 */
      if (drawerOn) {
        var drawerRows = document.querySelectorAll('#drawerBody .line').length;
        if (drawerRows !== wantRows) {
          var dDiff = drawerRows - wantRows;
          if (dDiff > 0 && orphanRows.filter(function (r) { return r.closest('#drawerBody'); }).length === dDiff) {
            orphanRows.forEach(function (r) { if (r.closest('#drawerBody')) r.remove(); });
            try { applyDrawerFold(); } catch (e) {}
          } else {
            try { syncDrawerHTML(true); } catch (e) {}
          }
        }
      }
    }
    // 只有「确实是空车」才整页刷新；错误体里 item_count 是 undefined，绝不能当空车处理
    if (cart && cart.item_count === 0) location.reload();
    // CART-DRAWER-SYNC-20261023 兜底：车里有货、但抽屉一行都没有 ⇒ 直接跟服务端对齐，
    // 绝不允许出现「数字有、行没有」这种半坏状态（这是侯哥截图那张的形态）
    if (cart && cart.item_count > 0 &&
        document.querySelectorAll('#drawerBody .line').length === 0) {
      syncDrawerHTML(true);
    }
    /* FIX-CART-FOLD-REMOVE-20261023 追加兜底：行还在、但**一行都看不见**同样是坏态
       （全被 .is-folded 藏掉）。先就地重算折叠，仍看不见才去拉服务端真值。 */
    if (cart && cart.item_count > 0 && document.querySelectorAll('#drawerBody .line').length > 0) {
      var _vis = 0;
      document.querySelectorAll('#drawerBody .line').forEach(function (r) {
        if (r.getBoundingClientRect().height > 0) _vis++;
      });
      if (_vis === 0) { try { applyDrawerFold(); } catch (e) {} }
    }
  }

  /* ---------------- drawer ---------------- */
  /* 覆盖层打开时停掉页面级视频。
     ① 移动端 <video> 会被浏览器抽成【独立原生合成层】，那层永远在 DOM 之上，
        z-index 完全无效（X5 内核、部分 Android 浏览器）——表现为视频盖住抽屉的
        Subtotal / Total / 结算按钮。唯一可靠解法是让元素本身不可见（见 brand.css
        body.drawer-open 那段）。
     ② 顺便省电：抽屉开着还后台解码视频没意义。
     看货器（#reels）里的视频不归这里管。 */
  function pausePageVideos() {
    $$('video').forEach(function (v) {
      if (v.closest('#reels')) return;
      v.dataset.wasPlaying = v.paused ? '0' : '1';
      try { v.pause(); } catch (e) {}
    });
  }
  function resumePageVideos() {
    $$('video').forEach(function (v) {
      if (v.closest('#reels')) return;
      if (v.dataset.wasPlaying === '1') {
        try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
      }
    });
  }

  /* ================= 购物车库存校准 CART-RECONCILE-20261025 =================
     场景：客户昨天把某张卡加了 3 件（当时有货），今天库存只剩 1 件（别的渠道卖掉了）。
     购物车不会自己变小 —— 客户到结账页才被告知「only 1 available」，很挫败。
     这里在**打开抽屉的那一刻**按已知库存把超量的行减到库存，并说明原因。
     库存来源：#bbInvMapCart（购物车页，全店 216 条）→ #bbInvMap（看货器/首页输出的映射）。
     ⚠️ 拿不到库存的行**一律不动** —— 宁可交给 Shopify 结账兜底，也不误改客户的车。
     ================================================================= */
  function invMapAll() {
    var m = {};
    ['bbInvMapCart', 'bbInvMap'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      try {
        var j = JSON.parse(el.textContent || '{}');
        for (var k in j) if (j.hasOwnProperty(k) && k !== '__end') m[k] = j[k];
      } catch (e) {}
    });
    return m;
  }

  var reconPending = false;
  function reconcileCartStock() {
    if (reconPending) return Promise.resolve(false);
    var m = invMapAll();
    var upd = {}, notes = [];
    ((cart && cart.items) || []).forEach(function (it) {
      var h = it.handle;
      if (!h || m[h] === undefined || m[h] === null) return;
      var left = parseInt(m[h], 10);
      if (isNaN(left)) return;
      var target = Math.max(0, Math.min(it.quantity, left));
      if (target === it.quantity) return;
      upd[it.key || it.id] = target;
      notes.push({ title: it.product_title || it.title || h, was: it.quantity, now: target });
    });
    if (!notes.length) return Promise.resolve(false);
    reconPending = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: upd })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        var n = notes[0];
        toast(n.now > 0
          ? 'Only ' + n.now + ' left of ' + n.title + ' — quantity updated'
          : n.title + ' just sold out — removed from your cart');
        return fetchCart(true).then(function () { return true; });
      })
      .catch(function () { return false; })
      .then(function (ok) { reconPending = false; return ok; });
  }

  function openCart() {
    var d = $('#drawer'), o = $('#overlay');
    if (!d) return;
    /* 先按库存校准一次（超量的行减到库存），再开抽屉渲染 —— 客户看到的数量就是能买到的数量。
       失败/无超量时立刻返回 false，不影响开抽屉速度。 */
    reconcileCartStock().then(function (changed) {
      if (changed) { try { syncDrawerHTML(true); } catch (e) {} }
    }).catch(function () {});
    d.classList.add('on'); d.setAttribute('aria-hidden', 'false');
    if (o) o.classList.add('on');
    document.body.classList.add('locked');
    document.body.classList.add('drawer-open');
    pausePageVideos();
    renderCartRecs();
    renderPageRecs();
    pushPanel('cart');
    // CART-DRAWER-SYNC-20261023：1.2s 内刚同步过就跳过（避免打开瞬间闪一下）
    syncDrawerHTML(false);
    // DRAWER-COMPACT-FOLD-20261023：抽屉有确定高度之后才算折叠
    setTimeout(function () { try { applyDrawerFold(); } catch (e) {} }, 60);
  }
  function closeCart(fromPop) {
    var d = $('#drawer'), o = $('#overlay');
    if (!d) return;
    /* 关抽屉解锁推荐区：下次打开按最新购物车重算（加购期间锁住只是为了不重下图片） */
    var _rb = $('#cartRec'); if (_rb) _rb.removeAttribute('data-rec-lock');
    d.classList.remove('on'); d.setAttribute('aria-hidden', 'true');
    if (o) o.classList.remove('on');
    document.body.classList.remove('locked');
    document.body.classList.remove('drawer-open');
    resumePageVideos();
    if (!fromPop) backIfTop('cart');
  }

  /* ---------------- 面板 x 浏览器历史 ----------------
     手机上从屏幕边缘右滑 = 浏览器后退。面板打开时不占一条历史记录，
     一滑就直接退出整个站（预览站踩过这个坑）。规则：
     开面板 push 一条；用户主动关闭 -> history.back() 撤掉；
     浏览器后退（popstate）-> 只关 UI，不再调 history，避免来回弹。 */
  var panelStack = [];
  function pushPanel(name) {
    panelStack.push(name);
    try { history.pushState({ bbPanel: name }, '', location.href); } catch (e) {}
  }
  function backIfTop(name) {
    var i = panelStack.lastIndexOf(name);
    if (i < 0) return;
    panelStack.splice(i, 1);
    if (i === panelStack.length) { try { history.back(); } catch (e) {} }
  }
  function topPanel() { return panelStack[panelStack.length - 1] || null; }

  /* ---------------- 移动端菜单 ---------------- */
  function menuOpen() { var m = $('#mobileNav'); return !!(m && m.classList.contains('on')); }
  function openMenu() {
    var m = $('#mobileNav'), b = $('#menuBtn');
    if (!m) return;
    m.classList.add('on');
    if (b) b.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
    pushPanel('menu');
  }
  function closeMenu(fromPop) {
    var m = $('#mobileNav'), b = $('#menuBtn');
    if (!m) return;
    m.classList.remove('on');
    if (b) b.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    if (!fromPop) backIfTop('menu');
  }

  /* ---------------- 搜索面板（Predictive Search API） ---------------- */
  var searchTimer = null;
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function openSheet() {
    var sh = $('#searchSheet');
    if (!sh) return;
    sh.classList.add('on');
    sh.setAttribute('aria-hidden', 'false');
    document.body.classList.add('locked');
    pushPanel('sheet');
    setTimeout(function () { var i = $('#searchInput'); if (i) i.focus(); }, 120);
  }
  function closeSheet(fromPop) {
    var sh = $('#searchSheet');
    if (!sh) return;
    sh.classList.remove('on');
    sh.setAttribute('aria-hidden', 'true');
    if (!document.body.classList.contains('reels-open')) {
      document.body.classList.remove('locked');
    }
    if (!fromPop) backIfTop('sheet');
  }

  /* ================= SEARCH-FUZZY-20261026 =================
     侯哥（2026-10-26 17:4x）：「搜索不支持模糊搜索，我输入 1144 直接搜不出来」
     ── 实测根因（线上现测，不是猜的）
       · 搜索面板 → `/search/suggest.json`；搜索页 → `/search?q=…`
       · Shopify 原生搜索是**按词（token）前缀匹配**，不认子串：
         商品 `Celebration Pikachu & Friends Y1144`、SKU `Y1144-291`
         被切成 token `y1144` + `291`
         ⇒ 搜 `1144` → total **0**；搜 `Y1144` → total **1**；搜 `y1144-291` → 1
         ⇒ 连字符把 SKU 拆两段，搜 `291` 会命中全店（不只是这一张）
       · 原生接口改不了 ⇒ 只能自建索引在前端做归一化子串匹配。
     ── 修法
       索引：`/collections/all?view=bbindex`（服务端实时渲染 ⇒ 上品/改 SKU 立即生效，
             没有"要重建"这一步）。221 条约 30 KB，内存 + localStorage 缓存 30 分钟。
       ① 搜索面板：原生结果 ∪ 本地模糊结果（本地在前、按卡号吻合度排序、按 handle 去重）
       ② 搜索页 0 结果：本地索引兜底渲染（点卡片照旧开看货器，符合 REELS-EVERYWHERE）
     ⚠️ 归一化必须去掉空格 / 连字符 / 下划线 / 斜杠 —— 否则 `Y1144-291` 永远搜不到 `1144`。
     ========================================================= */
  var BB_IDX = { data: null, promise: null, ts: 0 };
  var BB_IDX_KEY = 'bb_search_index_v1';
  var BB_IDX_TTL = 30 * 60 * 1000;
  var searchSeq = 0;

  function idxNorm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[\s\-_/]+/g, '');
  }

  function idxFetchPage(pg) {
    /* 🔴 别带 Accept: application/json —— Shopify 见它就走 API 分支，`?view=` 失效直接 404
       （2026-10-26 实测：curl 无 Accept 头 200/41KB，浏览器带 Accept 头 404 空体） */
    return fetch('/collections/all?view=bbindex&page=' + pg)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function idxLoad() {
    if (BB_IDX.data && (Date.now() - BB_IDX.ts) < BB_IDX_TTL) return Promise.resolve(BB_IDX.data);
    if (BB_IDX.promise) return BB_IDX.promise;
    try {
      var raw = localStorage.getItem(BB_IDX_KEY);
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.ts && (Date.now() - o.ts) < BB_IDX_TTL && o.items && o.items.length) {
          BB_IDX.data = o.items;
          BB_IDX.ts = o.ts;
          return Promise.resolve(BB_IDX.data);
        }
      }
    } catch (e) {}
    BB_IDX.promise = idxFetchPage(1).then(function (d) {
      if (!d || !d.products) return [];
      var pages = Number(d.pages) || 1;
      if (pages <= 1) return d.products;
      var rest = [];
      for (var i = 2; i <= pages; i++) rest.push(i);
      return Promise.all(rest.map(idxFetchPage)).then(function (arr) {
        var out = d.products.slice();
        arr.forEach(function (x) { if (x && x.products) out = out.concat(x.products); });
        return out;
      });
    }).then(function (items) {
      BB_IDX.data = items || [];
      BB_IDX.ts = Date.now();
      if (BB_IDX.data.length) {
        try { localStorage.setItem(BB_IDX_KEY, JSON.stringify({ ts: BB_IDX.ts, items: BB_IDX.data })); } catch (e) {}
      }
      BB_IDX.promise = null;
      return BB_IDX.data;
    }).catch(function () {
      BB_IDX.promise = null;
      return [];
    });
    return BB_IDX.promise;
  }

  /* 归一化子串匹配 + 打分：
     120 SKU 整体完全相等（y1144-291）/ 110 卡号数字段完全相等（1144）
      95 SKU 前缀 / 90 卡号数字前缀 / 80 SKU 中段（← 搜 1144 命中 y1144 走这条）
      75 卡号数字中段 / 50 句柄 / 30 仅标题
     多词按 AND（每个词都要在 title+sku+handle 里出现过） */
  function idxMatch(q, items, limit) {
    var qn = idxNorm(q);
    if (!qn || qn.length < 2) return [];
    var words = String(q).toLowerCase().split(/\s+/).filter(Boolean);
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.h) continue;
      var tn = idxNorm(it.t);
      var coreRaw = String(it.k || '').split('|')[0] || '';
      var coreN = idxNorm(coreRaw);
      var dm = coreN.match(/^([a-z]*)(\d+)/);
      var coreDigits = dm ? dm[2] : '';
      var hn = idxNorm(it.h);
      var hay = tn + ' ' + coreN + ' ' + hn;
      var ok = true;
      for (var w = 0; w < words.length; w++) {
        if (hay.indexOf(idxNorm(words[w])) < 0) { ok = false; break; }
      }
      if (!ok) continue;
      var score;
      if (coreN && coreN === qn) score = 120;
      else if (coreDigits && coreDigits === qn) score = 110;
      else if (coreN && coreN.indexOf(qn) === 0) score = 95;
      else if (coreDigits && coreDigits.indexOf(qn) === 0) score = 90;
      else if (coreN && coreN.indexOf(qn) > 0) score = 80;
      else if (coreDigits && coreDigits.indexOf(qn) > 0) score = 75;
      else if (hn.indexOf(qn) >= 0) score = 50;
      else score = 30;
      out.push({ it: it, s: score, o: i });
    }
    out.sort(function (a, b) { return b.s - a.s || a.o - b.o; });
    return out.slice(0, limit || 20).map(function (x) { return x.it; });
  }

  function idxMoney(n) {
    var v = Number(n);
    if (!isFinite(v)) return '';
    return '$' + v.toFixed(2);
  }

  /* 索引条目 → 与原搜索面板一模一样的 .sres 结构（样式零新增） */
  function idxSresHTML(it) {
    var h = String(it.h || '');
    var img = it.i ? String(it.i) : '';
    var sku = String(it.k || '').split('|')[0] || '';
    var meta = (it.a === false) ? 'Sold out' : (sku || 'Card');
    return '<a class="sres" href="/products/' + esc(h) + '"'
      + ' data-reels-open="' + esc(h) + '">'
      + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="60" height="60">' : '')
      + '<div><div class="sres__n">' + esc(it.t || '') + '</div>'
      + '<div class="sres__m">' + esc(meta) + '</div></div>'
      + '<div class="sres__p tnum">' + esc(idxMoney(it.p)) + '</div></a>';
  }

  function localIdx(items, q, limit) {
    return Promise.race([
      idxLoad().then(function (all) { return idxMatch(q, all, limit); }),
      new Promise(function (res) { setTimeout(function () { res([]); }, 1600); })
    ]).catch(function () { return []; });
  }

  function doSearch(q) {
    q = (q || '').trim();
    var box = $('#searchResults');
    if (!box) return;
    if (!q) { box.innerHTML = ''; return; }
    var token = ++searchSeq;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product&resources[limit]=8'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,variants.sku';

    var nativeP = fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (((d.resources || {}).results || {}).products) || []; })
      .catch(function () { return []; });

    Promise.all([nativeP, localIdx(null, q, 20)]).then(function (res) {
      if (token !== searchSeq) return;           // 用户已继续输入，丢弃过期结果
      var natives = res[0] || [];
      var locals = res[1] || [];
      var seen = {};
      var cards = [];
      locals.forEach(function (it) {
        if (cards.length >= 8) return;
        var k = it.h;
        if (!k || seen[k]) return;
        seen[k] = 1;
        cards.push(idxSresHTML(it));
      });
      natives.forEach(function (p) {
        if (cards.length >= 8) return;
        var _h = String(p.url || '').split('/products/')[1] || '';
        _h = _h.split('?')[0].split('#')[0];
        if (_h && seen[_h]) return;
        if (_h) seen[_h] = 1;
        var img = '';
        if (p.featured_image) img = (typeof p.featured_image === 'string') ? p.featured_image
          : (p.featured_image.url || '');
        if (!img && p.image) img = (typeof p.image === 'string') ? p.image : (p.image.url || '');
        var meta = (p.available === false) ? 'Sold out' : (p.type || 'Card');
        /* 详情页不作为浏览路径：搜索结果也直接进看货器（handle 从 url 里取） */
        cards.push('<a class="sres" href="' + esc(p.url) + '"' + (_h ? ' data-reels-open="' + esc(_h) + '"' : '') + '>'
          + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="60" height="60">' : '')
          + '<div><div class="sres__n">' + esc(p.title) + '</div>'
          + '<div class="sres__m">' + esc(meta) + '</div></div>'
          + '<div class="sres__p tnum">' + esc(p.price || '') + '</div></a>');
      });
      if (!cards.length) {
        box.innerHTML = '<div class="search__empty">No cards match &ldquo;' + esc(q)
          + '&rdquo;. Try a card number like &ldquo;1144&rdquo;, or a name like &ldquo;Pikachu&rdquo;.</div>';
        return;
      }
      box.innerHTML = cards.join('');
    }).catch(function () {
      if (token !== searchSeq) return;
      box.innerHTML = '<div class="search__empty">Search is unavailable right now.</div>';
    });
  }

  /* ================= 搜索页 0 结果兜底（同一份索引） =================
     搜 `1144` 时 Shopify 服务端 total=0，页面只会给一句 "no results"。
     这里在客户端用索引补出结果，并把标题区的 "0 results" 改成真实命中数。
     点结果照旧开看货器（data-reels-open），不新增任何样式。
     ================================================================ */
  function initSearchFallback() {
    var box = document.getElementById('searchFallback');
    if (!box) return;
    var q = box.getAttribute('data-q') || '';
    if (!q) return;
    idxLoad().then(function (items) {
      var hits = idxMatch(q, items, 36);
      if (!hits.length) return;
      box.innerHTML = '<div class="search__list">' + hits.map(idxSresHTML).join('') + '</div>';
      var empty = document.getElementById('searchEmpty');
      if (empty) empty.style.display = 'none';
      var cnt = document.getElementById('searchCount');
      if (cnt) cnt.textContent = String(hits.length);
    }).catch(function () {});
  }

  /* ---------------- full-screen viewer ---------------- */
  var reelsIdx = 0, reelsMuted = true, lastFocus = null;

  function reelsEl() { return $('#reels'); }
  function feedEl() { return $('#reelsFeed'); }

  /* ================= 2026-10-23 P0：看货器「点 A 看到 B」 =================
     现象：在合集里点任意一张卡，看货器永远显示第 1 张（全店字母序 Alakazam…），
           加车加的也是那一张 —— 客户以为买的是点开的卡。
     根因：reels section 的 feed 是服务端静态渲染的「指定合集 / 全店前 limit 条」，
           点开的卡 99% 不在里面；openReels(handle) 找不到就把 start 留 0。
     修法：点卡时先看 feed 里有没有这张；没有就按它所属系列拉 products.json，
           用同一套类名重建 feed，再跳到这张。（拉不到就只放这一张，绝不错位。）
     ====================================================================== */
  var reelsSeedBusy = false;

  function escHTML(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cdnSize(url, size) {
    return String(url || '').replace(/(\.[A-Za-z]+)(\?|$)/, '_' + size + '$1$2');
  }

/* === BB_REEL_VIDEOS:BEGIN (generated by tools/gen_reel_videos_20261026.py) === */
  /* handle -> {v: mp4 地址, p: 封面}
     为什么要有它：products.json / products.js 都不返回视频地址，
     所以动态拼出来的看货器卡只能靠这张表才知道该不该带 <video>。
     上传新视频后重跑 tools/gen_reel_videos_20261026.py --apply */
  var REEL_VIDEOS = {"charmander-cubone-tag-team-gx-y1101":{"v":"https://cdn.shopify.com/videos/c/vp/06d58b86f3f342529eb79da0c21a51bc/06d58b86f3f342529eb79da0c21a51bc.HD-1080p-7.2Mbps-99693510.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/06d58b86f3f342529eb79da0c21a51bc.thumbnail.0000000000.jpg?v=1793596047","w":810,"h":1080},"lucario-pikachu-tag-team-gx-y1102":{"v":"https://cdn.shopify.com/videos/c/vp/353eaa51960545bb86d340257ccc77fa/353eaa51960545bb86d340257ccc77fa.HD-1080p-7.2Mbps-99693511.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/353eaa51960545bb86d340257ccc77fa.thumbnail.0000000000.jpg?v=1793596006","w":810,"h":1080},"plusle-minun-tag-team-gx-y1103":{"v":"https://cdn.shopify.com/videos/c/vp/bb514aa8ee174c0a893633bf0b2e01c3/bb514aa8ee174c0a893633bf0b2e01c3.HD-1080p-7.2Mbps-99693512.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bb514aa8ee174c0a893633bf0b2e01c3.thumbnail.0000000000.jpg?v=1793596015","w":810,"h":1080},"pikachu-eevee-tag-team-gx-y1104":{"v":"https://cdn.shopify.com/videos/c/vp/10d0a8b34fcf4d8eb24d10189b29e8e7/10d0a8b34fcf4d8eb24d10189b29e8e7.HD-1080p-7.2Mbps-99693513.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/10d0a8b34fcf4d8eb24d10189b29e8e7.thumbnail.0000000000.jpg?v=1793596046","w":810,"h":1080},"pikachu-charizard-tag-team-gx-y1105":{"v":"https://cdn.shopify.com/videos/c/vp/709d0773807d49659dce33b0beb4a0cc/709d0773807d49659dce33b0beb4a0cc.HD-1080p-7.2Mbps-99693514.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/709d0773807d49659dce33b0beb4a0cc.thumbnail.0000000000.jpg?v=1793596020","w":810,"h":1080},"gardevoir-gallade-tag-team-gx-y1106":{"v":"https://cdn.shopify.com/videos/c/vp/bdae71dd6bd346dbb448fade3ba53def/bdae71dd6bd346dbb448fade3ba53def.HD-1080p-7.2Mbps-99693515.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bdae71dd6bd346dbb448fade3ba53def.thumbnail.0000000000.jpg?v=1793595988","w":810,"h":1080},"greninja-decidueye-tag-team-gx-y1107":{"v":"https://cdn.shopify.com/videos/c/vp/84194dd52f9e4c37a4011fa457a24405/84194dd52f9e4c37a4011fa457a24405.HD-1080p-7.2Mbps-99693516.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/84194dd52f9e4c37a4011fa457a24405.thumbnail.0000000000.jpg?v=1793596042","w":810,"h":1080},"mewtwo-mew-tag-team-gx-y1108":{"v":"https://cdn.shopify.com/videos/c/vp/df7f8c35989246edb5c16a3c198348ad/df7f8c35989246edb5c16a3c198348ad.HD-1080p-7.2Mbps-99693517.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/df7f8c35989246edb5c16a3c198348ad.thumbnail.0000000000.jpg?v=1793595995","w":810,"h":1080},"tyranitar-aggron-tag-team-gx-y1109":{"v":"https://cdn.shopify.com/videos/c/vp/fce54192978f40af96805b5dd4d7b897/fce54192978f40af96805b5dd4d7b897.HD-1080p-7.2Mbps-99693518.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/fce54192978f40af96805b5dd4d7b897.thumbnail.0000000000.jpg?v=1793596005","w":810,"h":1080},"clefable-gengar-tag-team-gx-y1110":{"v":"https://cdn.shopify.com/videos/c/vp/1897a4490dab4e08a518e907896782a8/1897a4490dab4e08a518e907896782a8.HD-1080p-7.2Mbps-99693519.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/1897a4490dab4e08a518e907896782a8.thumbnail.0000000000.jpg?v=1793596020","w":810,"h":1080},"greninja-lucario-tag-team-gx-y1111":{"v":"https://cdn.shopify.com/videos/c/vp/724f9f0fac2543e49bd7a472da342593/724f9f0fac2543e49bd7a472da342593.HD-1080p-7.2Mbps-99693520.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/724f9f0fac2543e49bd7a472da342593.thumbnail.0000000000.jpg?v=1793596025","w":810,"h":1080},"ash-greninja-primal-kyogre-tag-team-gx-y1112":{"v":"https://cdn.shopify.com/videos/c/vp/2c8456968c1045928e658bc7951b86cc/2c8456968c1045928e658bc7951b86cc.HD-1080p-7.2Mbps-99693521.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2c8456968c1045928e658bc7951b86cc.thumbnail.0000000000.jpg?v=1793596006","w":810,"h":1080},"randall-mimikyu-tag-team-gx-y1113":{"v":"https://cdn.shopify.com/videos/c/vp/bdd8b3ae14c446319d1200bfa93d3911/bdd8b3ae14c446319d1200bfa93d3911.HD-1080p-7.2Mbps-99693522.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bdd8b3ae14c446319d1200bfa93d3911.thumbnail.0000000000.jpg?v=1793596032","w":810,"h":1080},"phalons-charizard-ceruledge-tag-team-gx-y1114":{"v":"https://cdn.shopify.com/videos/c/vp/0233caaac27143b3b8c067ff30dba0d2/0233caaac27143b3b8c067ff30dba0d2.HD-1080p-7.2Mbps-99693523.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/0233caaac27143b3b8c067ff30dba0d2.thumbnail.0000000000.jpg?v=1793596046","w":810,"h":1080},"kyogre-lugia-tag-team-gx-y1115":{"v":"https://cdn.shopify.com/videos/c/vp/b980941bf46346349fd69224aeb369e0/b980941bf46346349fd69224aeb369e0.HD-1080p-7.2Mbps-99693524.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b980941bf46346349fd69224aeb369e0.thumbnail.0000000000.jpg?v=1793596050","w":810,"h":1080},"xerneas-yveltal-tag-team-gx-y1116":{"v":"https://cdn.shopify.com/videos/c/vp/e89f1c3198704190a3c3906dce4b5204/e89f1c3198704190a3c3906dce4b5204.HD-1080p-7.2Mbps-99693525.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e89f1c3198704190a3c3906dce4b5204.thumbnail.0000000000.jpg?v=1793596033","w":810,"h":1080},"pikachu-mimikyu-tag-team-gx-y1117":{"v":"https://cdn.shopify.com/videos/c/vp/70402f9582414972b90f2ca247aefea7/70402f9582414972b90f2ca247aefea7.HD-1080p-7.2Mbps-99693526.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/70402f9582414972b90f2ca247aefea7.thumbnail.0000000000.jpg?v=1793596025","w":810,"h":1080},"dragonite-ex-y1118":{"v":"https://cdn.shopify.com/videos/c/vp/9703b097c30246a9baac3acbc4a1211b/9703b097c30246a9baac3acbc4a1211b.HD-1080p-7.2Mbps-99693527.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9703b097c30246a9baac3acbc4a1211b.thumbnail.0000000000.jpg?v=1793596021","w":810,"h":1080},"yveltal-ex-y1119":{"v":"https://cdn.shopify.com/videos/c/vp/c7be961d27324a568efcf184a83ee289/c7be961d27324a568efcf184a83ee289.HD-1080p-7.2Mbps-99693528.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c7be961d27324a568efcf184a83ee289.thumbnail.0000000000.jpg?v=1793596030","w":810,"h":1080},"mewtwo-ex-y1120":{"v":"https://cdn.shopify.com/videos/c/vp/8a6229b72d9f44d286d7298572edf91f/8a6229b72d9f44d286d7298572edf91f.HD-1080p-7.2Mbps-99693529.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8a6229b72d9f44d286d7298572edf91f.thumbnail.0000000000.jpg?v=1793596042","w":810,"h":1080},"m-missingno-ex-y1121":{"v":"https://cdn.shopify.com/videos/c/vp/ef08fa565f6849808dc1e7855bc09473/ef08fa565f6849808dc1e7855bc09473.HD-1080p-7.2Mbps-99693530.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ef08fa565f6849808dc1e7855bc09473.thumbnail.0000000000.jpg?v=1793596040","w":810,"h":1080},"mimikyu-vmax-y1122":{"v":"https://cdn.shopify.com/videos/c/vp/a6157f07cc84493ab7f04e6bd17ea201/a6157f07cc84493ab7f04e6bd17ea201.HD-1080p-7.2Mbps-99693532.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a6157f07cc84493ab7f04e6bd17ea201.thumbnail.0000000000.jpg?v=1793596014","w":810,"h":1080},"m-mewtwo-ex-y1123":{"v":"https://cdn.shopify.com/videos/c/vp/bea4893426b1400682a21c053b720c5f/bea4893426b1400682a21c053b720c5f.HD-1080p-7.2Mbps-99693533.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bea4893426b1400682a21c053b720c5f.thumbnail.0000000000.jpg?v=1793596002","w":810,"h":1080},"giratina-ex-y1124":{"v":"https://cdn.shopify.com/videos/c/vp/50b7409a5b6b457094abb2187a7db270/50b7409a5b6b457094abb2187a7db270.HD-1080p-7.2Mbps-99693535.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/50b7409a5b6b457094abb2187a7db270.thumbnail.0000000000.jpg?v=1793595971","w":810,"h":1080},"m-gengar-ex-y1125":{"v":"https://cdn.shopify.com/videos/c/vp/d7a4941bd7e4444c96928cbbd33f9832/d7a4941bd7e4444c96928cbbd33f9832.HD-1080p-7.2Mbps-99693536.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d7a4941bd7e4444c96928cbbd33f9832.thumbnail.0000000000.jpg?v=1793596005","w":810,"h":1080},"m-gengar-ex-y1126":{"v":"https://cdn.shopify.com/videos/c/vp/db9142cd6e154887bd83b3ad7ec24173/db9142cd6e154887bd83b3ad7ec24173.HD-1080p-7.2Mbps-99693537.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/db9142cd6e154887bd83b3ad7ec24173.thumbnail.0000000000.jpg?v=1793596018","w":810,"h":1080},"ashs-charizard-vstar-y1127":{"v":"https://cdn.shopify.com/videos/c/vp/b75781ebbc464a8293430dd0478c5851/b75781ebbc464a8293430dd0478c5851.HD-1080p-7.2Mbps-99693538.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b75781ebbc464a8293430dd0478c5851.thumbnail.0000000000.jpg?v=1793595955","w":810,"h":1080},"m-houndoom-ex-y1128":{"v":"https://cdn.shopify.com/videos/c/vp/bf726ebf6af14433b845ee1b6539c2fe/bf726ebf6af14433b845ee1b6539c2fe.HD-1080p-7.2Mbps-99693539.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bf726ebf6af14433b845ee1b6539c2fe.thumbnail.0000000000.jpg?v=1793595992","w":810,"h":1080},"umbreon-ex-y1129":{"v":"https://cdn.shopify.com/videos/c/vp/9e8a62a7b3044f87ae75fbf30b52c958/9e8a62a7b3044f87ae75fbf30b52c958.HD-1080p-7.2Mbps-99693540.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9e8a62a7b3044f87ae75fbf30b52c958.thumbnail.0000000000.jpg?v=1793596023","w":810,"h":1080},"mimikyu-ex-y1130":{"v":"https://cdn.shopify.com/videos/c/vp/1c6bb3dd15684feb8f85abf62cca140c/1c6bb3dd15684feb8f85abf62cca140c.HD-1080p-7.2Mbps-99693541.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/1c6bb3dd15684feb8f85abf62cca140c.thumbnail.0000000000.jpg?v=1793595968","w":810,"h":1080},"shiny-mega-charizard-ex-y1131":{"v":"https://cdn.shopify.com/videos/c/vp/db4b779056b14aed933b43e5b0791b88/db4b779056b14aed933b43e5b0791b88.HD-1080p-7.2Mbps-99693542.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/db4b779056b14aed933b43e5b0791b88.thumbnail.0000000000.jpg?v=1793596025","w":810,"h":1080},"cyrus-shining-mega-gengar-ex-y1132":{"v":"https://cdn.shopify.com/videos/c/vp/ca644ab38388450ba92fff09bac264c8/ca644ab38388450ba92fff09bac264c8.HD-1080p-7.2Mbps-99693543.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ca644ab38388450ba92fff09bac264c8.thumbnail.0000000000.jpg?v=1793596042","w":810,"h":1080},"m-shadow-mewtwo-ex-y1133":{"v":"https://cdn.shopify.com/videos/c/vp/48034d63002741f3b9a6961d2bda473b/48034d63002741f3b9a6961d2bda473b.HD-1080p-7.2Mbps-99693545.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/48034d63002741f3b9a6961d2bda473b.thumbnail.0000000000.jpg?v=1793595998","w":810,"h":1080},"eevee-ex-y1134":{"v":"https://cdn.shopify.com/videos/c/vp/798f352f62474472a8dbd009c3408d9c/798f352f62474472a8dbd009c3408d9c.HD-1080p-7.2Mbps-99693546.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/798f352f62474472a8dbd009c3408d9c.thumbnail.0000000000.jpg?v=1793596044","w":810,"h":1080},"m-zygarde-ex-y1135":{"v":"https://cdn.shopify.com/videos/c/vp/32c37ce44236427e95b0236362f9c22e/32c37ce44236427e95b0236362f9c22e.HD-1080p-7.2Mbps-99693547.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/32c37ce44236427e95b0236362f9c22e.thumbnail.0000000000.jpg?v=1793596027","w":810,"h":1080},"mistys-psyduck-ex-y1137":{"v":"https://cdn.shopify.com/videos/c/vp/6cb96ad886a345bab2ababd813b92b1e/6cb96ad886a345bab2ababd813b92b1e.HD-1080p-7.2Mbps-99693548.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6cb96ad886a345bab2ababd813b92b1e.thumbnail.0000000000.jpg?v=1793596011","w":810,"h":1080},"m-golisopod-ex-y1138":{"v":"https://cdn.shopify.com/videos/c/vp/b91a20883eab472195ff25001beb9a61/b91a20883eab472195ff25001beb9a61.HD-1080p-7.2Mbps-99693549.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b91a20883eab472195ff25001beb9a61.thumbnail.0000000000.jpg?v=1793596026","w":810,"h":1080},"mewtwo-ex-y1139":{"v":"https://cdn.shopify.com/videos/c/vp/4ed07085ea08461889764ca3025b86db/4ed07085ea08461889764ca3025b86db.HD-1080p-7.2Mbps-99693550.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4ed07085ea08461889764ca3025b86db.thumbnail.0000000000.jpg?v=1793596044","w":810,"h":1080},"mewtwo-vmax-y1140":{"v":"https://cdn.shopify.com/videos/c/vp/ce397d38a4c041e99ee3a0029db917ea/ce397d38a4c041e99ee3a0029db917ea.HD-1080p-7.2Mbps-99693552.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ce397d38a4c041e99ee3a0029db917ea.thumbnail.0000000000.jpg?v=1793595943","w":810,"h":1080},"lugia-vmax-y1141":{"v":"https://cdn.shopify.com/videos/c/vp/c733497d14de4d0fb84dccb245b16fae/c733497d14de4d0fb84dccb245b16fae.HD-1080p-7.2Mbps-99693553.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c733497d14de4d0fb84dccb245b16fae.thumbnail.0000000000.jpg?v=1793596043","w":810,"h":1080},"m-charizard-ex-y1142":{"v":"https://cdn.shopify.com/videos/c/vp/ac20c8f2593e44788f2b92643f5e2fa9/ac20c8f2593e44788f2b92643f5e2fa9.HD-1080p-7.2Mbps-99693554.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ac20c8f2593e44788f2b92643f5e2fa9.thumbnail.0000000000.jpg?v=1793596044","w":810,"h":1080},"m-blastoise-ex-y1143":{"v":"https://cdn.shopify.com/videos/c/vp/1914489431ce4de6bd8fc1e305da2252/1914489431ce4de6bd8fc1e305da2252.HD-1080p-7.2Mbps-99693555.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/1914489431ce4de6bd8fc1e305da2252.thumbnail.0000000000.jpg?v=1793595989","w":810,"h":1080},"celebration-pikachu-friends-y1144":{"v":"https://cdn.shopify.com/videos/c/vp/d19f33ee198f4c69a18117e553071fa3/d19f33ee198f4c69a18117e553071fa3.HD-1080p-7.2Mbps-98891832.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d19f33ee198f4c69a18117e553071fa3.thumbnail.0000000000.jpg?v=1793001391","w":810,"h":1080},"rebellious-pikachu-y1145":{"v":"https://cdn.shopify.com/videos/c/vp/7e96b0dd80684c9ea342ee47890d091c/7e96b0dd80684c9ea342ee47890d091c.HD-1080p-7.2Mbps-99693557.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7e96b0dd80684c9ea342ee47890d091c.thumbnail.0000000000.jpg?v=1793596049","w":810,"h":1080},"pikachu-with-felt-hat-y1146":{"v":"https://cdn.shopify.com/videos/c/vp/83b147adc47743ce907be5ec93d229d3/83b147adc47743ce907be5ec93d229d3.HD-1080p-7.2Mbps-99693558.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/83b147adc47743ce907be5ec93d229d3.thumbnail.0000000000.jpg?v=1793596033","w":810,"h":1080},"pikachu-y1147":{"v":"https://cdn.shopify.com/videos/c/vp/5052f55285c64f38bb176ebcfa61ff9c/5052f55285c64f38bb176ebcfa61ff9c.HD-1080p-7.2Mbps-99693559.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5052f55285c64f38bb176ebcfa61ff9c.thumbnail.0000000000.jpg?v=1793596051","w":810,"h":1080},"shadow-claw-pikachu-y1148":{"v":"https://cdn.shopify.com/videos/c/vp/c414df55c5784e319f4a938ae964193a/c414df55c5784e319f4a938ae964193a.HD-1080p-7.2Mbps-99693560.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c414df55c5784e319f4a938ae964193a.thumbnail.0000000000.jpg?v=1793595981","w":810,"h":1080},"pikachu-y1149":{"v":"https://cdn.shopify.com/videos/c/vp/52cdc5308d79442cbf830777ebed9dbd/52cdc5308d79442cbf830777ebed9dbd.HD-1080p-7.2Mbps-99693561.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/52cdc5308d79442cbf830777ebed9dbd.thumbnail.0000000000.jpg?v=1793596040","w":810,"h":1080},"cubone-y1150":{"v":"https://cdn.shopify.com/videos/c/vp/4bf8a6764a65417b8d04cfd1666142e9/4bf8a6764a65417b8d04cfd1666142e9.HD-1080p-7.2Mbps-99693562.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4bf8a6764a65417b8d04cfd1666142e9.thumbnail.0000000000.jpg?v=1793596025","w":810,"h":1080},"eevee-y1151":{"v":"https://cdn.shopify.com/videos/c/vp/97eb52ab6e18473b88c54083b2d4aa21/97eb52ab6e18473b88c54083b2d4aa21.HD-1080p-7.2Mbps-99693563.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/97eb52ab6e18473b88c54083b2d4aa21.thumbnail.0000000000.jpg?v=1793595989","w":810,"h":1080},"rayquaza-y1152":{"v":"https://cdn.shopify.com/videos/c/vp/5b44249d1897461c86d899333eefa32b/5b44249d1897461c86d899333eefa32b.HD-1080p-7.2Mbps-99693564.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5b44249d1897461c86d899333eefa32b.thumbnail.0000000000.jpg?v=1793596031","w":810,"h":1080},"snorlax-y1153":{"v":"https://cdn.shopify.com/videos/c/vp/5a50c51dca824699a4954d53142d2d32/5a50c51dca824699a4954d53142d2d32.HD-1080p-7.2Mbps-99693565.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5a50c51dca824699a4954d53142d2d32.thumbnail.0000000000.jpg?v=1793595974","w":810,"h":1080},"charmeleon-y1154":{"v":"https://cdn.shopify.com/videos/c/vp/ac952404edbe43ada7602492806e3ec4/ac952404edbe43ada7602492806e3ec4.HD-1080p-7.2Mbps-99693566.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ac952404edbe43ada7602492806e3ec4.thumbnail.0000000000.jpg?v=1793596043","w":810,"h":1080},"giovannis-ambition-y1155":{"v":"https://cdn.shopify.com/videos/c/vp/1a2d98f657b54d93bf7b89998de1b6c1/1a2d98f657b54d93bf7b89998de1b6c1.HD-1080p-7.2Mbps-99693567.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/1a2d98f657b54d93bf7b89998de1b6c1.thumbnail.0000000000.jpg?v=1793595964","w":810,"h":1080},"pikachu-red-gyarados-gx-y1201":{"v":"https://cdn.shopify.com/videos/c/vp/f2dec6ce9a3749a1a42587961ee02544/f2dec6ce9a3749a1a42587961ee02544.HD-1080p-7.2Mbps-99694795.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f2dec6ce9a3749a1a42587961ee02544.thumbnail.0000000000.jpg?v=1793597681","w":810,"h":1080},"pikachu-mimikyu-gx-y1202":{"v":"https://cdn.shopify.com/videos/c/vp/188ab8585a744ba3be34099235a2419c/188ab8585a744ba3be34099235a2419c.HD-1080p-7.2Mbps-99694796.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/188ab8585a744ba3be34099235a2419c.thumbnail.0000000000.jpg?v=1793597661","w":810,"h":1080},"lugia-blacephalon-gx-y1203":{"v":"https://cdn.shopify.com/videos/c/vp/64ae5fb0910e42379166713e2033d979/64ae5fb0910e42379166713e2033d979.HD-1080p-7.2Mbps-99694797.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/64ae5fb0910e42379166713e2033d979.thumbnail.0000000000.jpg?v=1793597717","w":810,"h":1080},"latias-latios-gx-y1204":{"v":"https://cdn.shopify.com/videos/c/vp/76dfa36693044250a5d8cfb1ffa3108a/76dfa36693044250a5d8cfb1ffa3108a.HD-1080p-7.2Mbps-99694798.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/76dfa36693044250a5d8cfb1ffa3108a.thumbnail.0000000000.jpg?v=1793597633","w":810,"h":1080},"gyarados-charizard-gx-y1205":{"v":"https://cdn.shopify.com/videos/c/vp/3dcbd127db284dd5927fd02733b306dc/3dcbd127db284dd5927fd02733b306dc.HD-1080p-7.2Mbps-99694799.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/3dcbd127db284dd5927fd02733b306dc.thumbnail.0000000000.jpg?v=1793597717","w":810,"h":1080},"pikachu-eevee-gx-y1206":{"v":"https://cdn.shopify.com/videos/c/vp/f73ef5bf625a4d21a43cf52e4aa6606a/f73ef5bf625a4d21a43cf52e4aa6606a.HD-1080p-7.2Mbps-99694801.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f73ef5bf625a4d21a43cf52e4aa6606a.thumbnail.0000000000.jpg?v=1793597666","w":810,"h":1080},"charizard-ho-oh-gx-y1207":{"v":"https://cdn.shopify.com/videos/c/vp/742201d05b2643b89196c17e3627c6e1/742201d05b2643b89196c17e3627c6e1.HD-1080p-7.2Mbps-99694802.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/742201d05b2643b89196c17e3627c6e1.thumbnail.0000000000.jpg?v=1793597657","w":810,"h":1080},"greninja-blastoise-gx-y1208":{"v":"https://cdn.shopify.com/videos/c/vp/e885b3c42fd74e47b53d3d9e62609ed6/e885b3c42fd74e47b53d3d9e62609ed6.HD-1080p-7.2Mbps-99694803.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e885b3c42fd74e47b53d3d9e62609ed6.thumbnail.0000000000.jpg?v=1793597708","w":810,"h":1080},"ceruledge-armarouge-gx-y1209":{"v":"https://cdn.shopify.com/videos/c/vp/c99d6b19bf5f4fdfa0e2c83d5596d88e/c99d6b19bf5f4fdfa0e2c83d5596d88e.HD-1080p-7.2Mbps-99694806.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c99d6b19bf5f4fdfa0e2c83d5596d88e.thumbnail.0000000000.jpg?v=1793597712","w":810,"h":1080},"dragonite-gyarados-gx-y1210":{"v":"https://cdn.shopify.com/videos/c/vp/587ae053e13141e094a342f87b77d01d/587ae053e13141e094a342f87b77d01d.HD-1080p-7.2Mbps-99694808.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/587ae053e13141e094a342f87b77d01d.thumbnail.0000000000.jpg?v=1793597643","w":810,"h":1080},"mew-mewtwo-gx-y1211":{"v":"https://cdn.shopify.com/videos/c/vp/bbfe9fe78866415fafad333815fe3ca9/bbfe9fe78866415fafad333815fe3ca9.HD-1080p-7.2Mbps-99694809.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bbfe9fe78866415fafad333815fe3ca9.thumbnail.0000000000.jpg?v=1793597714","w":810,"h":1080},"gengar-dragapult-gx-y1212":{"v":"https://cdn.shopify.com/videos/c/vp/dc76c1b141294632affe8d573380cdde/dc76c1b141294632affe8d573380cdde.HD-1080p-7.2Mbps-99694810.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/dc76c1b141294632affe8d573380cdde.thumbnail.0000000000.jpg?v=1793597717","w":810,"h":1080},"rayquaza-groudon-kyogre-gx-y1213":{"v":"https://cdn.shopify.com/videos/c/vp/7d3b7d8772954489bbe62ded297b7895/7d3b7d8772954489bbe62ded297b7895.HD-1080p-7.2Mbps-99694811.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7d3b7d8772954489bbe62ded297b7895.thumbnail.0000000000.jpg?v=1793597719","w":810,"h":1080},"m-rayquaza-ex-y1215":{"v":"https://cdn.shopify.com/videos/c/vp/95ede9919ca948098dc1dc3489b87255/95ede9919ca948098dc1dc3489b87255.HD-1080p-7.2Mbps-99694812.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/95ede9919ca948098dc1dc3489b87255.thumbnail.0000000000.jpg?v=1793597722","w":810,"h":1080},"tera-mega-charizard-ex-y1216":{"v":"https://cdn.shopify.com/videos/c/vp/d0945c94b1184a329aee210874632654/d0945c94b1184a329aee210874632654.HD-1080p-7.2Mbps-99694813.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d0945c94b1184a329aee210874632654.thumbnail.0000000000.jpg?v=1793597723","w":810,"h":1080},"arceus-ex-y1217":{"v":"https://cdn.shopify.com/videos/c/vp/658a70a81cf142048d59f305a59c36df/658a70a81cf142048d59f305a59c36df.HD-1080p-7.2Mbps-99694814.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/658a70a81cf142048d59f305a59c36df.thumbnail.0000000000.jpg?v=1793597667","w":810,"h":1080},"mega-gengar-ex-y1218":{"v":"https://cdn.shopify.com/videos/c/vp/c84c4029b36748bcbeaeae0ce881c5e0/c84c4029b36748bcbeaeae0ce881c5e0.HD-1080p-7.2Mbps-99694815.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c84c4029b36748bcbeaeae0ce881c5e0.thumbnail.0000000000.jpg?v=1793597686","w":810,"h":1080},"dragonite-ex-y1219":{"v":"https://cdn.shopify.com/videos/c/vp/90b7e2d1d1264dfeb7cd54e1bcf3b911/90b7e2d1d1264dfeb7cd54e1bcf3b911.HD-1080p-7.2Mbps-99694816.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/90b7e2d1d1264dfeb7cd54e1bcf3b911.thumbnail.0000000000.jpg?v=1793597709","w":810,"h":1080},"m-lucario-ex-y1220":{"v":"https://cdn.shopify.com/videos/c/vp/f8e8267537834baeac498bbfa659b627/f8e8267537834baeac498bbfa659b627.HD-1080p-7.2Mbps-99694818.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f8e8267537834baeac498bbfa659b627.thumbnail.0000000000.jpg?v=1793597692","w":810,"h":1080},"mega-charizard-x-ex-y1221":{"v":"https://cdn.shopify.com/videos/c/vp/5bbe46f9278c4476877654c971e5a467/5bbe46f9278c4476877654c971e5a467.HD-1080p-7.2Mbps-99694819.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5bbe46f9278c4476877654c971e5a467.thumbnail.0000000000.jpg?v=1793597566","w":810,"h":1080},"pikachu-v-y1222-1":{"v":"https://cdn.shopify.com/videos/c/vp/8b6daef415a149ba95854f8df934815f/8b6daef415a149ba95854f8df934815f.HD-1080p-7.2Mbps-99694820.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8b6daef415a149ba95854f8df934815f.thumbnail.0000000000.jpg?v=1793597726","w":810,"h":1080},"tera-dragapult-ex-y1223":{"v":"https://cdn.shopify.com/videos/c/vp/5ce0d02ac7cb41899dc37363ff53dba1/5ce0d02ac7cb41899dc37363ff53dba1.HD-1080p-7.2Mbps-99694821.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5ce0d02ac7cb41899dc37363ff53dba1.thumbnail.0000000000.jpg?v=1793597674","w":810,"h":1080},"m-mewtwo-y-ex-y1224":{"v":"https://cdn.shopify.com/videos/c/vp/6c65d1d346da4bf994965011093e5424/6c65d1d346da4bf994965011093e5424.HD-1080p-7.2Mbps-99694822.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6c65d1d346da4bf994965011093e5424.thumbnail.0000000000.jpg?v=1793597620","w":810,"h":1080},"pikachu-vmax-y1225":{"v":"https://cdn.shopify.com/videos/c/vp/e3c87edc05bd4ee8b751b1e0126e832b/e3c87edc05bd4ee8b751b1e0126e832b.HD-1080p-7.2Mbps-99694823.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e3c87edc05bd4ee8b751b1e0126e832b.thumbnail.0000000000.jpg?v=1793597715","w":810,"h":1080},"m-rayquaza-ex-y1226":{"v":"https://cdn.shopify.com/videos/c/vp/d3d410c2736048c4a6090afe549b9215/d3d410c2736048c4a6090afe549b9215.HD-1080p-7.2Mbps-99694824.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d3d410c2736048c4a6090afe549b9215.thumbnail.0000000000.jpg?v=1793597708","w":810,"h":1080},"umbreon-ex-y1227":{"v":"https://cdn.shopify.com/videos/c/vp/2efb317d817147ccb57481d1f0fa5408/2efb317d817147ccb57481d1f0fa5408.HD-1080p-7.2Mbps-99694825.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2efb317d817147ccb57481d1f0fa5408.thumbnail.0000000000.jpg?v=1793597715","w":810,"h":1080},"greninja-ex-y1228":{"v":"https://cdn.shopify.com/videos/c/vp/0bafe46b247743838beb2e07f70b7c08/0bafe46b247743838beb2e07f70b7c08.HD-1080p-7.2Mbps-99694826.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/0bafe46b247743838beb2e07f70b7c08.thumbnail.0000000000.jpg?v=1793597710","w":810,"h":1080},"psyduck-ex-y1229":{"v":"https://cdn.shopify.com/videos/c/vp/b9c6ac3969884d67ba79f1277e42abb4/b9c6ac3969884d67ba79f1277e42abb4.HD-1080p-7.2Mbps-99694827.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b9c6ac3969884d67ba79f1277e42abb4.thumbnail.0000000000.jpg?v=1793597644","w":810,"h":1080},"charizard-ex-y1230":{"v":"https://cdn.shopify.com/videos/c/vp/7d87bb9ed9e347299339d167e78bac45/7d87bb9ed9e347299339d167e78bac45.HD-1080p-7.2Mbps-99694828.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7d87bb9ed9e347299339d167e78bac45.thumbnail.0000000000.jpg?v=1793597673","w":810,"h":1080},"m-mewtwo-x-ex-y1231":{"v":"https://cdn.shopify.com/videos/c/vp/6a367d46cc22497caac9641bef6b0fee/6a367d46cc22497caac9641bef6b0fee.HD-1080p-7.2Mbps-99694829.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6a367d46cc22497caac9641bef6b0fee.thumbnail.0000000000.jpg?v=1793597661","w":810,"h":1080},"mega-rayquaza-ex-y1232":{"v":"https://cdn.shopify.com/videos/c/vp/498a577178d94cc1bcb12d97e597ac28/498a577178d94cc1bcb12d97e597ac28.HD-1080p-7.2Mbps-99694830.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/498a577178d94cc1bcb12d97e597ac28.thumbnail.0000000000.jpg?v=1793597701","w":810,"h":1080},"tera-greninja-ex-y1233":{"v":"https://cdn.shopify.com/videos/c/vp/2e1a24209efe4cacbd9c61b13ab38a2a/2e1a24209efe4cacbd9c61b13ab38a2a.HD-1080p-7.2Mbps-99694831.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2e1a24209efe4cacbd9c61b13ab38a2a.thumbnail.0000000000.jpg?v=1793597653","w":810,"h":1080},"mew-ex-y1234":{"v":"https://cdn.shopify.com/videos/c/vp/66f02408743b4783b06909508eb2de72/66f02408743b4783b06909508eb2de72.HD-1080p-7.2Mbps-99694832.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/66f02408743b4783b06909508eb2de72.thumbnail.0000000000.jpg?v=1793597715","w":810,"h":1080},"gengar-ex-y1235":{"v":"https://cdn.shopify.com/videos/c/vp/80d32aa9088741329c3d93a0288b9de4/80d32aa9088741329c3d93a0288b9de4.HD-1080p-7.2Mbps-99694833.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/80d32aa9088741329c3d93a0288b9de4.thumbnail.0000000000.jpg?v=1793597716","w":810,"h":1080},"tera-pikachu-ex-y1236":{"v":"https://cdn.shopify.com/videos/c/vp/019f44c0528941ce9c71f8f40debf7f6/019f44c0528941ce9c71f8f40debf7f6.HD-1080p-7.2Mbps-99694834.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/019f44c0528941ce9c71f8f40debf7f6.thumbnail.0000000000.jpg?v=1793597699","w":810,"h":1080},"deoxys-ex-y1237":{"v":"https://cdn.shopify.com/videos/c/vp/385d13e6ccd9491b9063dd2461e518c1/385d13e6ccd9491b9063dd2461e518c1.HD-1080p-7.2Mbps-99694835.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/385d13e6ccd9491b9063dd2461e518c1.thumbnail.0000000000.jpg?v=1793597708","w":810,"h":1080},"tera-eevee-ex-y1238":{"v":"https://cdn.shopify.com/videos/c/vp/d5302914a96f4bff90547a7a5c28ee31/d5302914a96f4bff90547a7a5c28ee31.HD-1080p-7.2Mbps-99694836.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d5302914a96f4bff90547a7a5c28ee31.thumbnail.0000000000.jpg?v=1793597715","w":810,"h":1080},"m-chandelure-ex-y1239":{"v":"https://cdn.shopify.com/videos/c/vp/11aa2861af4c4c368c6a667a2dfd84ab/11aa2861af4c4c368c6a667a2dfd84ab.HD-1080p-7.2Mbps-99694837.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/11aa2861af4c4c368c6a667a2dfd84ab.thumbnail.0000000000.jpg?v=1793597638","w":810,"h":1080},"mega-charizard-x-ex-y1240":{"v":"https://cdn.shopify.com/videos/c/vp/a9487c6908de4a3abba634da57801a93/a9487c6908de4a3abba634da57801a93.HD-1080p-7.2Mbps-99694838.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a9487c6908de4a3abba634da57801a93.thumbnail.0000000000.jpg?v=1793597699","w":810,"h":1080},"m-azumarill-ex-y1241":{"v":"https://cdn.shopify.com/videos/c/vp/9e94023d100246c6951144d1a8418c79/9e94023d100246c6951144d1a8418c79.HD-1080p-7.2Mbps-99694839.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9e94023d100246c6951144d1a8418c79.thumbnail.0000000000.jpg?v=1793597641","w":810,"h":1080},"mega-charizard-x-ex-y1242":{"v":"https://cdn.shopify.com/videos/c/vp/86b31c19e99f4ac4a0e16cb99e74ab25/86b31c19e99f4ac4a0e16cb99e74ab25.HD-1080p-7.2Mbps-99694840.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/86b31c19e99f4ac4a0e16cb99e74ab25.thumbnail.0000000000.jpg?v=1793597722","w":810,"h":1080},"charizard-ex-y1243":{"v":"https://cdn.shopify.com/videos/c/vp/31eb0163a7ca4722a476684e9f6e6099/31eb0163a7ca4722a476684e9f6e6099.HD-1080p-7.2Mbps-99694841.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/31eb0163a7ca4722a476684e9f6e6099.thumbnail.0000000000.jpg?v=1793597719","w":810,"h":1080},"m-rayquaza-ex-y1244":{"v":"https://cdn.shopify.com/videos/c/vp/52f09b9a724b4e8c97efee72fc2627ae/52f09b9a724b4e8c97efee72fc2627ae.HD-1080p-7.2Mbps-99694842.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/52f09b9a724b4e8c97efee72fc2627ae.thumbnail.0000000000.jpg?v=1793597723","w":810,"h":1080},"mega-lucario-z-ex-y1245":{"v":"https://cdn.shopify.com/videos/c/vp/f775dba0bf4a4afdbe4981e5a67bfd2a/f775dba0bf4a4afdbe4981e5a67bfd2a.HD-1080p-7.2Mbps-99694843.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f775dba0bf4a4afdbe4981e5a67bfd2a.thumbnail.0000000000.jpg?v=1793597641","w":810,"h":1080},"m-charizard-x-ex-y1246":{"v":"https://cdn.shopify.com/videos/c/vp/723202f0a40e41e3aa5c497841874768/723202f0a40e41e3aa5c497841874768.HD-1080p-7.2Mbps-99694844.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/723202f0a40e41e3aa5c497841874768.thumbnail.0000000000.jpg?v=1793597667","w":810,"h":1080},"m-charizard-ex-y1247":{"v":"https://cdn.shopify.com/videos/c/vp/cd8a86c25b5e4f7e860379400b69a654/cd8a86c25b5e4f7e860379400b69a654.HD-1080p-7.2Mbps-99694845.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/cd8a86c25b5e4f7e860379400b69a654.thumbnail.0000000000.jpg?v=1793597716","w":810,"h":1080},"m-gardevoir-ex-y1248":{"v":"https://cdn.shopify.com/videos/c/vp/71d08c31ee36401db4f3581c06a0a8b1/71d08c31ee36401db4f3581c06a0a8b1.HD-1080p-7.2Mbps-99694846.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/71d08c31ee36401db4f3581c06a0a8b1.thumbnail.0000000000.jpg?v=1793597719","w":810,"h":1080},"mew-with-a-pearl-earring-y1250":{"v":"https://cdn.shopify.com/videos/c/vp/6fdc32ddb2be4c3d9b117e8cffe776b3/6fdc32ddb2be4c3d9b117e8cffe776b3.HD-1080p-7.2Mbps-99694848.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6fdc32ddb2be4c3d9b117e8cffe776b3.thumbnail.0000000000.jpg?v=1793597718","w":810,"h":1080},"surfs-up-pikachu-y1251":{"v":"https://cdn.shopify.com/videos/c/vp/f21da661772c4690ac7f6c172e1e572a/f21da661772c4690ac7f6c172e1e572a.HD-1080p-7.2Mbps-99694849.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f21da661772c4690ac7f6c172e1e572a.thumbnail.0000000000.jpg?v=1793597700","w":810,"h":1080},"team-rockets-mewtwo-y1252":{"v":"https://cdn.shopify.com/videos/c/vp/3b5e43337175478cb20b08e83624ba8b/3b5e43337175478cb20b08e83624ba8b.HD-1080p-7.2Mbps-99694850.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/3b5e43337175478cb20b08e83624ba8b.thumbnail.0000000000.jpg?v=1793597718","w":810,"h":1080},"chef-gengar-y1253":{"v":"https://cdn.shopify.com/videos/c/vp/2458a39e57a4492995f09d6f2199c4fc/2458a39e57a4492995f09d6f2199c4fc.HD-1080p-7.2Mbps-99694852.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2458a39e57a4492995f09d6f2199c4fc.thumbnail.0000000000.jpg?v=1793597614","w":810,"h":1080},"flareon-y1254":{"v":"https://cdn.shopify.com/videos/c/vp/e7c086cbf7a348399088130b3cf1bbf1/e7c086cbf7a348399088130b3cf1bbf1.HD-1080p-7.2Mbps-99694853.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e7c086cbf7a348399088130b3cf1bbf1.thumbnail.0000000000.jpg?v=1793597698","w":810,"h":1080},"mikus-jigglypuff-y1255":{"v":"https://cdn.shopify.com/videos/c/vp/2542c8189da9403e8b4b258246d0ef88/2542c8189da9403e8b4b258246d0ef88.HD-1080p-7.2Mbps-99694854.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2542c8189da9403e8b4b258246d0ef88.thumbnail.0000000000.jpg?v=1793597717","w":810,"h":1080},"caitlin-gothorita-gx-y1001":{"v":"https://cdn.shopify.com/videos/c/vp/273d4523f42c4acc9af0854173b44841/273d4523f42c4acc9af0854173b44841.HD-1080p-7.2Mbps-99691856.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/273d4523f42c4acc9af0854173b44841.thumbnail.0000000000.jpg?v=1793594386","w":810,"h":1080},"latias-reshiram-gx-y1002":{"v":"https://cdn.shopify.com/videos/c/vp/f11495458cdc44aab817c2dbb6453a4f/f11495458cdc44aab817c2dbb6453a4f.HD-1080p-7.2Mbps-99691857.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f11495458cdc44aab817c2dbb6453a4f.thumbnail.0000000000.jpg?v=1793594450","w":810,"h":1080},"psyduck-pikachu-gx-y1003":{"v":"https://cdn.shopify.com/videos/c/vp/5b4695db51034db8848e11675cfed6d8/5b4695db51034db8848e11675cfed6d8.HD-1080p-7.2Mbps-99691859.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5b4695db51034db8848e11675cfed6d8.thumbnail.0000000000.jpg?v=1793594455","w":810,"h":1080},"ash-misty-brock-gx-y1004":{"v":"https://cdn.shopify.com/videos/c/vp/6e8a235886dd4682b419f3729bd2e129/6e8a235886dd4682b419f3729bd2e129.HD-1080p-7.2Mbps-99691860.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6e8a235886dd4682b419f3729bd2e129.thumbnail.0000000000.jpg?v=1793594395","w":810,"h":1080},"mallow-lillie-lana-gx-y1005":{"v":"https://cdn.shopify.com/videos/c/vp/141fe70a69b24727a82783950b11cb5b/141fe70a69b24727a82783950b11cb5b.HD-1080p-7.2Mbps-99691861.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/141fe70a69b24727a82783950b11cb5b.thumbnail.0000000000.jpg?v=1793594446","w":810,"h":1080},"pikachu-psyduck-gx-y1006":{"v":"https://cdn.shopify.com/videos/c/vp/c67c8f150f4043e191e327bbc2c4924c/c67c8f150f4043e191e327bbc2c4924c.HD-1080p-7.2Mbps-99691862.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c67c8f150f4043e191e327bbc2c4924c.thumbnail.0000000000.jpg?v=1793594477","w":810,"h":1080},"magikarp-gyarados-gx-y1007":{"v":"https://cdn.shopify.com/videos/c/vp/a9a35fd2dde449bdaf6690857d3a1195/a9a35fd2dde449bdaf6690857d3a1195.HD-1080p-7.2Mbps-99691863.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a9a35fd2dde449bdaf6690857d3a1195.thumbnail.0000000000.jpg?v=1793594367","w":810,"h":1080},"pikachu-gengar-gx-y1008":{"v":"https://cdn.shopify.com/videos/c/vp/6b2b6cd6f87c42b1b98b79980a79eef4/6b2b6cd6f87c42b1b98b79980a79eef4.HD-1080p-7.2Mbps-99691864.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6b2b6cd6f87c42b1b98b79980a79eef4.thumbnail.0000000000.jpg?v=1793594453","w":810,"h":1080},"dragapult-salamence-gx-y1009":{"v":"https://cdn.shopify.com/videos/c/vp/353b53ac0e694056a0e96cda34028878/353b53ac0e694056a0e96cda34028878.HD-1080p-7.2Mbps-99691866.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/353b53ac0e694056a0e96cda34028878.thumbnail.0000000000.jpg?v=1793594485","w":810,"h":1080},"kyurem-dragonite-drampa-gx-y1010":{"v":"https://cdn.shopify.com/videos/c/vp/a3d836fe56364044b830acb7adc13be8/a3d836fe56364044b830acb7adc13be8.HD-1080p-7.2Mbps-99691867.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a3d836fe56364044b830acb7adc13be8.thumbnail.0000000000.jpg?v=1793594469","w":810,"h":1080},"rayquaza-kyogre-groudon-gx-y1011":{"v":"https://cdn.shopify.com/videos/c/vp/6dfea9213cf346a598c65cd02389f852/6dfea9213cf346a598c65cd02389f852.HD-1080p-7.2Mbps-99691868.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6dfea9213cf346a598c65cd02389f852.thumbnail.0000000000.jpg?v=1793594475","w":810,"h":1080},"lycanroc-mimikyu-gx-y1012":{"v":"https://cdn.shopify.com/videos/c/vp/00b7f3a310e641058531ff1b7fa6b761/00b7f3a310e641058531ff1b7fa6b761.HD-1080p-7.2Mbps-99691869.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/00b7f3a310e641058531ff1b7fa6b761.thumbnail.0000000000.jpg?v=1793594468","w":810,"h":1080},"shaymin-giratina-gx-y1013":{"v":"https://cdn.shopify.com/videos/c/vp/fa3aaee5b5434b5aa7720ecc3116ad6d/fa3aaee5b5434b5aa7720ecc3116ad6d.HD-1080p-7.2Mbps-99691870.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/fa3aaee5b5434b5aa7720ecc3116ad6d.thumbnail.0000000000.jpg?v=1793594443","w":810,"h":1080},"pikachu-zekrom-gx-y1014":{"v":"https://cdn.shopify.com/videos/c/vp/91e53c967ec94d9f98b66dbcbb662646/91e53c967ec94d9f98b66dbcbb662646.HD-1080p-7.2Mbps-99691871.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/91e53c967ec94d9f98b66dbcbb662646.thumbnail.0000000000.jpg?v=1793594446","w":810,"h":1080},"charizard-reshiram-gx-y1015":{"v":"https://cdn.shopify.com/videos/c/vp/75315e8dca9d4b6c96ba72f65ee03970/75315e8dca9d4b6c96ba72f65ee03970.HD-1080p-7.2Mbps-99691872.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/75315e8dca9d4b6c96ba72f65ee03970.thumbnail.0000000000.jpg?v=1793594482","w":810,"h":1080},"snorlax-eevee-gx-y1016":{"v":"https://cdn.shopify.com/videos/c/vp/b74b2e51ad4c49ada095e37f8747e566/b74b2e51ad4c49ada095e37f8747e566.HD-1080p-7.2Mbps-99691873.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b74b2e51ad4c49ada095e37f8747e566.thumbnail.0000000000.jpg?v=1793594459","w":810,"h":1080},"marshadow-machamp-gx-y1017":{"v":"https://cdn.shopify.com/videos/c/vp/b7b464c439cf4388b04a47854dc329b9/b7b464c439cf4388b04a47854dc329b9.HD-1080p-7.2Mbps-99691874.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b7b464c439cf4388b04a47854dc329b9.thumbnail.0000000000.jpg?v=1793594484","w":810,"h":1080},"mewtwo-mew-gx-y1018":{"v":"https://cdn.shopify.com/videos/c/vp/dc57929ccf6543aeb2da99f22d149049/dc57929ccf6543aeb2da99f22d149049.HD-1080p-7.2Mbps-99691875.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/dc57929ccf6543aeb2da99f22d149049.thumbnail.0000000000.jpg?v=1793594357","w":810,"h":1080},"gengar-pikachu-gx-y1019":{"v":"https://cdn.shopify.com/videos/c/vp/82530b4cf20a4fa0bee29c7383152c89/82530b4cf20a4fa0bee29c7383152c89.HD-1080p-7.2Mbps-99691876.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/82530b4cf20a4fa0bee29c7383152c89.thumbnail.0000000000.jpg?v=1793594425","w":810,"h":1080},"mega-gardevoir-pheromosa-gx-y1020":{"v":"https://cdn.shopify.com/videos/c/vp/27d7245735f74b4a8dc2d9e5ce4dff79/27d7245735f74b4a8dc2d9e5ce4dff79.HD-1080p-7.2Mbps-99691877.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/27d7245735f74b4a8dc2d9e5ce4dff79.thumbnail.0000000000.jpg?v=1793594474","w":810,"h":1080},"stakataka-eevee-gx-y1021":{"v":"https://cdn.shopify.com/videos/c/vp/d5aceea4f13b444faa5bdda4e179701c/d5aceea4f13b444faa5bdda4e179701c.HD-1080p-7.2Mbps-99691879.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d5aceea4f13b444faa5bdda4e179701c.thumbnail.0000000000.jpg?v=1793594479","w":810,"h":1080},"sylveon-glaceon-gx-y1022":{"v":"https://cdn.shopify.com/videos/c/vp/5498a6516f8143a8a5999744093b7738/5498a6516f8143a8a5999744093b7738.HD-1080p-7.2Mbps-99691880.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5498a6516f8143a8a5999744093b7738.thumbnail.0000000000.jpg?v=1793594422","w":810,"h":1080},"mew-v-y1023":{"v":"https://cdn.shopify.com/videos/c/vp/6b388035f1ab40a1875563de11bee791/6b388035f1ab40a1875563de11bee791.HD-1080p-7.2Mbps-99691881.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6b388035f1ab40a1875563de11bee791.thumbnail.0000000000.jpg?v=1793594486","w":810,"h":1080},"lucario-ex-y1025":{"v":"https://cdn.shopify.com/videos/c/vp/c891ea20a9c241a0893db6456d7cd23b/c891ea20a9c241a0893db6456d7cd23b.HD-1080p-7.2Mbps-99691883.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c891ea20a9c241a0893db6456d7cd23b.thumbnail.0000000000.jpg?v=1793594398","w":810,"h":1080},"mega-gardevoir-ex-y1026":{"v":"https://cdn.shopify.com/videos/c/vp/f91129d1dcbb4fa5a5371e8ba1e9917a/f91129d1dcbb4fa5a5371e8ba1e9917a.HD-1080p-7.2Mbps-99691884.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f91129d1dcbb4fa5a5371e8ba1e9917a.thumbnail.0000000000.jpg?v=1793594476","w":810,"h":1080},"arceus-gx-y1027":{"v":"https://cdn.shopify.com/videos/c/vp/454024a92f504fbfb3c954e017e8c9af/454024a92f504fbfb3c954e017e8c9af.HD-1080p-7.2Mbps-99691885.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/454024a92f504fbfb3c954e017e8c9af.thumbnail.0000000000.jpg?v=1793594427","w":810,"h":1080},"mega-charizard-vmax-y1028":{"v":"https://cdn.shopify.com/videos/c/vp/9841bcc2d85f4826bde5b29f45efa2ef/9841bcc2d85f4826bde5b29f45efa2ef.HD-1080p-7.2Mbps-99691886.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9841bcc2d85f4826bde5b29f45efa2ef.thumbnail.0000000000.jpg?v=1793594304","w":810,"h":1080},"gigantamax-snorlax-vmax-y1029":{"v":"https://cdn.shopify.com/videos/c/vp/4acfe1af20ff435aa57cbb6afc147813/4acfe1af20ff435aa57cbb6afc147813.HD-1080p-7.2Mbps-99691887.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4acfe1af20ff435aa57cbb6afc147813.thumbnail.0000000000.jpg?v=1793594451","w":810,"h":1080},"giratina-vstar-y1030":{"v":"https://cdn.shopify.com/videos/c/vp/d20d1fa110bc422da0bda929d7b766e9/d20d1fa110bc422da0bda929d7b766e9.HD-1080p-7.2Mbps-99691888.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d20d1fa110bc422da0bda929d7b766e9.thumbnail.0000000000.jpg?v=1793594483","w":810,"h":1080},"rayquaza-ex-y1031":{"v":"https://cdn.shopify.com/videos/c/vp/3cdf800f7ba74af1b8da886a83e98b69/3cdf800f7ba74af1b8da886a83e98b69.HD-1080p-7.2Mbps-99691889.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/3cdf800f7ba74af1b8da886a83e98b69.thumbnail.0000000000.jpg?v=1793594457","w":810,"h":1080},"pikachu-ex-y1032":{"v":"https://cdn.shopify.com/videos/c/vp/29f52158d240416eb85ae24628a7a3f7/29f52158d240416eb85ae24628a7a3f7.HD-1080p-7.2Mbps-99691890.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/29f52158d240416eb85ae24628a7a3f7.thumbnail.0000000000.jpg?v=1793594478","w":810,"h":1080},"terastal-gyarados-ex-y1033":{"v":"https://cdn.shopify.com/videos/c/vp/2695861e09a347b0bbd40a221b8c119e/2695861e09a347b0bbd40a221b8c119e.HD-1080p-7.2Mbps-99691891.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2695861e09a347b0bbd40a221b8c119e.thumbnail.0000000000.jpg?v=1793594450","w":810,"h":1080},"iron-valiant-ex-y1034":{"v":"https://cdn.shopify.com/videos/c/vp/a9b7aae058a04731a5b50cc56bad5979/a9b7aae058a04731a5b50cc56bad5979.HD-1080p-7.2Mbps-99691893.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a9b7aae058a04731a5b50cc56bad5979.thumbnail.0000000000.jpg?v=1793594476","w":810,"h":1080},"gigantamax-charizard-vmax-y1035":{"v":"https://cdn.shopify.com/videos/c/vp/2c0ed850eebe4aea8390b552b070be76/2c0ed850eebe4aea8390b552b070be76.HD-1080p-7.2Mbps-99691894.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2c0ed850eebe4aea8390b552b070be76.thumbnail.0000000000.jpg?v=1793594465","w":810,"h":1080},"single-strike-gigantamax-gengar-vmax-y1036":{"v":"https://cdn.shopify.com/videos/c/vp/a3784d1eb40849e3bfb94a1ef957f50b/a3784d1eb40849e3bfb94a1ef957f50b.HD-1080p-7.2Mbps-99691895.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a3784d1eb40849e3bfb94a1ef957f50b.thumbnail.0000000000.jpg?v=1793594450","w":810,"h":1080},"umbreon-vmax-y1037":{"v":"https://cdn.shopify.com/videos/c/vp/14c752f57cf542e495b6a17e05f75844/14c752f57cf542e495b6a17e05f75844.HD-1080p-7.2Mbps-99691896.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/14c752f57cf542e495b6a17e05f75844.thumbnail.0000000000.jpg?v=1793594484","w":810,"h":1080},"rayquaza-ex-y1038":{"v":"https://cdn.shopify.com/videos/c/vp/57061e7405ef46f187ed31a4ebe59a15/57061e7405ef46f187ed31a4ebe59a15.HD-1080p-7.2Mbps-99691897.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/57061e7405ef46f187ed31a4ebe59a15.thumbnail.0000000000.jpg?v=1793594461","w":810,"h":1080},"mega-charizard-x-ex-y1039":{"v":"https://cdn.shopify.com/videos/c/vp/01b0c036105744749c062aff925467ef/01b0c036105744749c062aff925467ef.HD-1080p-7.2Mbps-99691898.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/01b0c036105744749c062aff925467ef.thumbnail.0000000000.jpg?v=1793594489","w":810,"h":1080},"mew-ex-y1040":{"v":"https://cdn.shopify.com/videos/c/vp/4310d5155c904643946f714e5c4116a2/4310d5155c904643946f714e5c4116a2.HD-1080p-7.2Mbps-99691899.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4310d5155c904643946f714e5c4116a2.thumbnail.0000000000.jpg?v=1793594331","w":810,"h":1080},"miraidon-ex-y1041":{"v":"https://cdn.shopify.com/videos/c/vp/8657b68e31424138a60861c9b4242ad3/8657b68e31424138a60861c9b4242ad3.HD-1080p-7.2Mbps-99691900.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8657b68e31424138a60861c9b4242ad3.thumbnail.0000000000.jpg?v=1793594482","w":810,"h":1080},"pikachu-ex-y1042":{"v":"https://cdn.shopify.com/videos/c/vp/b6d6d5d288d1458785b013ff77ba1ecc/b6d6d5d288d1458785b013ff77ba1ecc.HD-1080p-7.2Mbps-99691901.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b6d6d5d288d1458785b013ff77ba1ecc.thumbnail.0000000000.jpg?v=1793594249","w":810,"h":1080},"pikachu-y1044":{"v":"https://cdn.shopify.com/videos/c/vp/a31b6fab507e4ee7afa7d0887ca8a4cb/a31b6fab507e4ee7afa7d0887ca8a4cb.HD-1080p-7.2Mbps-99691903.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a31b6fab507e4ee7afa7d0887ca8a4cb.thumbnail.0000000000.jpg?v=1793594396","w":810,"h":1080},"gengar-costume-pikachu-y1045":{"v":"https://cdn.shopify.com/videos/c/vp/926b0642bf754960926b88baa393573b/926b0642bf754960926b88baa393573b.HD-1080p-7.2Mbps-99691904.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/926b0642bf754960926b88baa393573b.thumbnail.0000000000.jpg?v=1793594471","w":810,"h":1080},"van-goghs-slowpoke-y1047":{"v":"https://cdn.shopify.com/videos/c/vp/88e926f8fdcd4acdbee4b63119c33e5f/88e926f8fdcd4acdbee4b63119c33e5f.HD-1080p-7.2Mbps-99691906.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/88e926f8fdcd4acdbee4b63119c33e5f.thumbnail.0000000000.jpg?v=1793594487","w":810,"h":1080},"gokus-pikachu-y1048":{"v":"https://cdn.shopify.com/videos/c/vp/234b9c79db1941acaff243090ba78252/234b9c79db1941acaff243090ba78252.HD-1080p-7.2Mbps-99691907.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/234b9c79db1941acaff243090ba78252.thumbnail.0000000000.jpg?v=1793594459","w":810,"h":1080},"eevee-y1049":{"v":"https://cdn.shopify.com/videos/c/vp/d9bd2b3ccdae4198894e89e56dcbf9ac/d9bd2b3ccdae4198894e89e56dcbf9ac.HD-1080p-7.2Mbps-99691908.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d9bd2b3ccdae4198894e89e56dcbf9ac.thumbnail.0000000000.jpg?v=1793594484","w":810,"h":1080},"gengar-y1050":{"v":"https://cdn.shopify.com/videos/c/vp/4613efd0ef9c4f489d33c23632546b88/4613efd0ef9c4f489d33c23632546b88.HD-1080p-7.2Mbps-99691909.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4613efd0ef9c4f489d33c23632546b88.thumbnail.0000000000.jpg?v=1793594484","w":810,"h":1080},"psyduck-y1052":{"v":"https://cdn.shopify.com/videos/c/vp/f6bef500721b457e9cd8ecc83d732ae4/f6bef500721b457e9cd8ecc83d732ae4.HD-1080p-7.2Mbps-99691911.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f6bef500721b457e9cd8ecc83d732ae4.thumbnail.0000000000.jpg?v=1793594486","w":810,"h":1080},"cynthias-resolve-y1053":{"v":"https://cdn.shopify.com/videos/c/vp/23bb4fbfafbf4a37948d29acdc54010a/23bb4fbfafbf4a37948d29acdc54010a.HD-1080p-7.2Mbps-99691912.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/23bb4fbfafbf4a37948d29acdc54010a.thumbnail.0000000000.jpg?v=1793594475","w":810,"h":1080},"lillie-y1054":{"v":"https://cdn.shopify.com/videos/c/vp/4cfcaffcc9e7498cb2123f29fa8fad1d/4cfcaffcc9e7498cb2123f29fa8fad1d.HD-1080p-7.2Mbps-99691913.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4cfcaffcc9e7498cb2123f29fa8fad1d.thumbnail.0000000000.jpg?v=1793594469","w":810,"h":1080},"gatsbys-flex-y1055":{"v":"https://cdn.shopify.com/videos/c/vp/e62f47fc70224795aff83d962a971a9e/e62f47fc70224795aff83d962a971a9e.HD-1080p-7.2Mbps-99691914.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e62f47fc70224795aff83d962a971a9e.thumbnail.0000000000.jpg?v=1793594485","w":810,"h":1080},"dragonite-pikachu-gx-y1301":{"v":"https://cdn.shopify.com/videos/c/vp/726e169be6ad45d993cb9729ca755d9d/726e169be6ad45d993cb9729ca755d9d.HD-1080p-7.2Mbps-99696479.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/726e169be6ad45d993cb9729ca755d9d.thumbnail.0000000000.jpg?v=1793599301","w":810,"h":1080},"rayquaza-groudon-kyogre-gx-y1302":{"v":"https://cdn.shopify.com/videos/c/vp/350dc46c2b994439b482af12d65284ed/350dc46c2b994439b482af12d65284ed.HD-1080p-7.2Mbps-99696481.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/350dc46c2b994439b482af12d65284ed.thumbnail.0000000000.jpg?v=1793599349","w":810,"h":1080},"gengar-shadow-lugia-gx-y1303":{"v":"https://cdn.shopify.com/videos/c/vp/8950d4f6e80f453b8543c61e6a409303/8950d4f6e80f453b8543c61e6a409303.HD-1080p-7.2Mbps-99696483.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8950d4f6e80f453b8543c61e6a409303.thumbnail.0000000000.jpg?v=1793599360","w":810,"h":1080},"espeon-deoxys-gx-y1304":{"v":"https://cdn.shopify.com/videos/c/vp/9aad407b74794604a9e1bca20cb8dad5/9aad407b74794604a9e1bca20cb8dad5.HD-1080p-7.2Mbps-99696484.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9aad407b74794604a9e1bca20cb8dad5.thumbnail.0000000000.jpg?v=1793599081","w":810,"h":1080},"charizard-mega-charizard-x-gx-y1305":{"v":"https://cdn.shopify.com/videos/c/vp/885a74ceb06f401895afdcf984f3ffef/885a74ceb06f401895afdcf984f3ffef.HD-1080p-7.2Mbps-99696486.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/885a74ceb06f401895afdcf984f3ffef.thumbnail.0000000000.jpg?v=1793599358","w":810,"h":1080},"mimikyu-sylveon-gx-y1306":{"v":"https://cdn.shopify.com/videos/c/vp/cbae4e8f25484289b8ba1bdb598448ea/cbae4e8f25484289b8ba1bdb598448ea.HD-1080p-7.2Mbps-99696487.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/cbae4e8f25484289b8ba1bdb598448ea.thumbnail.0000000000.jpg?v=1793599273","w":810,"h":1080},"greninja-gyarados-gx-y1307":{"v":"https://cdn.shopify.com/videos/c/vp/29cb1b97d27e47a8aa76cef5d2de7de1/29cb1b97d27e47a8aa76cef5d2de7de1.HD-1080p-7.2Mbps-99696489.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/29cb1b97d27e47a8aa76cef5d2de7de1.thumbnail.0000000000.jpg?v=1793599368","w":810,"h":1080},"mega-mewtwo-x-y-gx-y1308":{"v":"https://cdn.shopify.com/videos/c/vp/65ac52a9c2704bc5b2af9e715de4064d/65ac52a9c2704bc5b2af9e715de4064d.HD-1080p-7.2Mbps-99696493.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/65ac52a9c2704bc5b2af9e715de4064d.thumbnail.0000000000.jpg?v=1793599314","w":810,"h":1080},"holiday-pikachu-eevee-gx-y1309":{"v":"https://cdn.shopify.com/videos/c/vp/8d91cf82a9c84844a6fc76a4f808c796/8d91cf82a9c84844a6fc76a4f808c796.HD-1080p-7.2Mbps-99696494.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8d91cf82a9c84844a6fc76a4f808c796.thumbnail.0000000000.jpg?v=1793599352","w":810,"h":1080},"gengar-ralts-gotenks-gx-y1310":{"v":"https://cdn.shopify.com/videos/c/vp/202aece8f4804b23a98dc6bd7c0e4433/202aece8f4804b23a98dc6bd7c0e4433.HD-1080p-7.2Mbps-99696496.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/202aece8f4804b23a98dc6bd7c0e4433.thumbnail.0000000000.jpg?v=1793599258","w":810,"h":1080},"gardevoir-milotic-gx-y1311":{"v":"https://cdn.shopify.com/videos/c/vp/1982d70f263748798019b73b8475f414/1982d70f263748798019b73b8475f414.HD-1080p-7.2Mbps-99696498.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/1982d70f263748798019b73b8475f414.thumbnail.0000000000.jpg?v=1793599320","w":810,"h":1080},"mew-hoopa-gx-y1312":{"v":"https://cdn.shopify.com/videos/c/vp/577affc1c641464ab3868222d7c2751c/577affc1c641464ab3868222d7c2751c.HD-1080p-7.2Mbps-99696499.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/577affc1c641464ab3868222d7c2751c.thumbnail.0000000000.jpg?v=1793599209","w":810,"h":1080},"mew-shiny-mew-gx-y1313":{"v":"https://cdn.shopify.com/videos/c/vp/422b2f64b83a4f7ea99cce231ea7e023/422b2f64b83a4f7ea99cce231ea7e023.HD-1080p-7.2Mbps-99696502.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/422b2f64b83a4f7ea99cce231ea7e023.thumbnail.0000000000.jpg?v=1793599346","w":810,"h":1080},"mewtwo-pikachu-gx-y1314":{"v":"https://cdn.shopify.com/videos/c/vp/4df55b82329241319927801f1854dcc0/4df55b82329241319927801f1854dcc0.HD-1080p-7.2Mbps-99696503.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4df55b82329241319927801f1854dcc0.thumbnail.0000000000.jpg?v=1793599358","w":810,"h":1080},"pikachu-gengar-gx-y1315":{"v":"https://cdn.shopify.com/videos/c/vp/c63418064e274bfd85e97c5ee2470c76/c63418064e274bfd85e97c5ee2470c76.HD-1080p-7.2Mbps-99696506.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c63418064e274bfd85e97c5ee2470c76.thumbnail.0000000000.jpg?v=1793599369","w":810,"h":1080},"pikachu-zekrom-gx-y1316":{"v":"https://cdn.shopify.com/videos/c/vp/9248af8dd942457fa37efb35f5375672/9248af8dd942457fa37efb35f5375672.HD-1080p-7.2Mbps-99696507.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9248af8dd942457fa37efb35f5375672.thumbnail.0000000000.jpg?v=1793599371","w":810,"h":1080},"sylveon-mega-gardevoir-gx-y1317":{"v":"https://cdn.shopify.com/videos/c/vp/bdbcde328a864d2d946e419ee023cde3/bdbcde328a864d2d946e419ee023cde3.HD-1080p-7.2Mbps-99696509.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bdbcde328a864d2d946e419ee023cde3.thumbnail.0000000000.jpg?v=1793599323","w":810,"h":1080},"umbreon-sylveon-gx-y1318":{"v":"https://cdn.shopify.com/videos/c/vp/e47cfe245dd94fda9498ff72c6ce3af0/e47cfe245dd94fda9498ff72c6ce3af0.HD-1080p-7.2Mbps-99696511.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e47cfe245dd94fda9498ff72c6ce3af0.thumbnail.0000000000.jpg?v=1793599376","w":810,"h":1080},"latias-latios-gx-y1319":{"v":"https://cdn.shopify.com/videos/c/vp/848c478a276c49dfa470cff6149ce0da/848c478a276c49dfa470cff6149ce0da.HD-1080p-7.2Mbps-99696512.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/848c478a276c49dfa470cff6149ce0da.thumbnail.0000000000.jpg?v=1793599258","w":810,"h":1080},"ash-greninja-mega-charizard-x-gx-y1320":{"v":"https://cdn.shopify.com/videos/c/vp/8a4d7c23ad824a069968814a269b59c2/8a4d7c23ad824a069968814a269b59c2.HD-1080p-7.2Mbps-99696514.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8a4d7c23ad824a069968814a269b59c2.thumbnail.0000000000.jpg?v=1793599313","w":810,"h":1080},"gengar-mimikyu-gx-y1321":{"v":"https://cdn.shopify.com/videos/c/vp/4df54f9e8b93446da56ba24c38d6f567/4df54f9e8b93446da56ba24c38d6f567.HD-1080p-7.2Mbps-99696515.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4df54f9e8b93446da56ba24c38d6f567.thumbnail.0000000000.jpg?v=1793599186","w":810,"h":1080},"dondozo-tatsugiri-gx-y1322":{"v":"https://cdn.shopify.com/videos/c/vp/3b4f5a913133447cb2912a88f41de471/3b4f5a913133447cb2912a88f41de471.HD-1080p-7.2Mbps-99696517.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/3b4f5a913133447cb2912a88f41de471.thumbnail.0000000000.jpg?v=1793599359","w":810,"h":1080},"umbreon-absol-gx-y1323":{"v":"https://cdn.shopify.com/videos/c/vp/5adba687517348fe996c84f81e05b0ea/5adba687517348fe996c84f81e05b0ea.HD-1080p-7.2Mbps-99696519.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5adba687517348fe996c84f81e05b0ea.thumbnail.0000000000.jpg?v=1793599360","w":810,"h":1080},"gengar-mimikyu-gx-y1324":{"v":"https://cdn.shopify.com/videos/c/vp/05b6b7c5af3a4916b8a4a268638d92c5/05b6b7c5af3a4916b8a4a268638d92c5.HD-1080p-7.2Mbps-99696521.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/05b6b7c5af3a4916b8a4a268638d92c5.thumbnail.0000000000.jpg?v=1793599363","w":810,"h":1080},"alolan-ninetales-vmax-y1326":{"v":"https://cdn.shopify.com/videos/c/vp/66156b0abea84f84b3dc23c9d04b48a3/66156b0abea84f84b3dc23c9d04b48a3.HD-1080p-7.2Mbps-99696525.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/66156b0abea84f84b3dc23c9d04b48a3.thumbnail.0000000000.jpg?v=1793599360","w":810,"h":1080},"umbreon-ex-y1327":{"v":"https://cdn.shopify.com/videos/c/vp/a3c0d4db81774c41b31527066de41cd2/a3c0d4db81774c41b31527066de41cd2.HD-1080p-7.2Mbps-99696527.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a3c0d4db81774c41b31527066de41cd2.thumbnail.0000000000.jpg?v=1793599340","w":810,"h":1080},"lucario-vmax-y1329":{"v":"https://cdn.shopify.com/videos/c/vp/78a2326f62b14c0e9b91fa727d669f9f/78a2326f62b14c0e9b91fa727d669f9f.HD-1080p-7.2Mbps-99696530.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/78a2326f62b14c0e9b91fa727d669f9f.thumbnail.0000000000.jpg?v=1793599321","w":810,"h":1080},"shiny-charizard-vmax-y1330":{"v":"https://cdn.shopify.com/videos/c/vp/eafcdfbc053c4e91bac6cddffd7d1b2c/eafcdfbc053c4e91bac6cddffd7d1b2c.HD-1080p-7.2Mbps-99696532.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/eafcdfbc053c4e91bac6cddffd7d1b2c.thumbnail.0000000000.jpg?v=1793599275","w":810,"h":1080},"rayquaza-vmax-y1331":{"v":"https://cdn.shopify.com/videos/c/vp/8da0a2d9d520467a8a7819b66ac68576/8da0a2d9d520467a8a7819b66ac68576.HD-1080p-7.2Mbps-99696533.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8da0a2d9d520467a8a7819b66ac68576.thumbnail.0000000000.jpg?v=1793599315","w":810,"h":1080},"mimikyu-ex-y1332":{"v":"https://cdn.shopify.com/videos/c/vp/1ea9d51b564349798474d4164df00fa1/1ea9d51b564349798474d4164df00fa1.HD-1080p-7.2Mbps-99696534.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/1ea9d51b564349798474d4164df00fa1.thumbnail.0000000000.jpg?v=1793599337","w":810,"h":1080},"mewtwo-ex-y1333":{"v":"https://cdn.shopify.com/videos/c/vp/5e9112a826aa4a48b44a6ff251b7bba5/5e9112a826aa4a48b44a6ff251b7bba5.HD-1080p-7.2Mbps-99696535.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5e9112a826aa4a48b44a6ff251b7bba5.thumbnail.0000000000.jpg?v=1793599324","w":810,"h":1080},"gengar-ex-y1334":{"v":"https://cdn.shopify.com/videos/c/vp/2ab55de0a4e64d5994be30d8a1bccbbf/2ab55de0a4e64d5994be30d8a1bccbbf.HD-1080p-7.2Mbps-99696537.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2ab55de0a4e64d5994be30d8a1bccbbf.thumbnail.0000000000.jpg?v=1793599190","w":810,"h":1080},"snorlax-vstar-y1335":{"v":"https://cdn.shopify.com/videos/c/vp/98c93abddf2c4df7b3d42dc3ab41be2c/98c93abddf2c4df7b3d42dc3ab41be2c.HD-1080p-7.2Mbps-99696538.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/98c93abddf2c4df7b3d42dc3ab41be2c.thumbnail.0000000000.jpg?v=1793599329","w":810,"h":1080},"charizard-vmax-y1336":{"v":"https://cdn.shopify.com/videos/c/vp/8890b50388f9435da8ab505b52c80a37/8890b50388f9435da8ab505b52c80a37.HD-1080p-7.2Mbps-99696539.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8890b50388f9435da8ab505b52c80a37.thumbnail.0000000000.jpg?v=1793599357","w":810,"h":1080},"m-gengar-ex-y1338":{"v":"https://cdn.shopify.com/videos/c/vp/ad0724d88eb2418eb06a98927d2cb76e/ad0724d88eb2418eb06a98927d2cb76e.HD-1080p-7.2Mbps-99696541.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ad0724d88eb2418eb06a98927d2cb76e.thumbnail.0000000000.jpg?v=1793599312","w":810,"h":1080},"m-gardevoir-ex-y1339":{"v":"https://cdn.shopify.com/videos/c/vp/03bd89e25d5342ad912b23b415c8e3ff/03bd89e25d5342ad912b23b415c8e3ff.HD-1080p-7.2Mbps-99696542.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/03bd89e25d5342ad912b23b415c8e3ff.thumbnail.0000000000.jpg?v=1793599189","w":810,"h":1080},"m-gyarados-ex-y1340":{"v":"https://cdn.shopify.com/videos/c/vp/14fbf69c188e40259709b3e04ad4542a/14fbf69c188e40259709b3e04ad4542a.HD-1080p-7.2Mbps-99696543.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/14fbf69c188e40259709b3e04ad4542a.thumbnail.0000000000.jpg?v=1793599235","w":810,"h":1080},"mega-rayquaza-ex-y1341":{"v":"https://cdn.shopify.com/videos/c/vp/60bd15363a884e09ad6f1c7fd7821cdf/60bd15363a884e09ad6f1c7fd7821cdf.HD-1080p-7.2Mbps-99696544.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/60bd15363a884e09ad6f1c7fd7821cdf.thumbnail.0000000000.jpg?v=1793599126","w":810,"h":1080},"m-zeraora-ex-y1342":{"v":"https://cdn.shopify.com/videos/c/vp/1b3e9d27487a4f15a2a4b686b8b64d46/1b3e9d27487a4f15a2a4b686b8b64d46.HD-1080p-7.2Mbps-99696545.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/1b3e9d27487a4f15a2a4b686b8b64d46.thumbnail.0000000000.jpg?v=1793599206","w":810,"h":1080},"mega-dragonite-ex-y1343":{"v":"https://cdn.shopify.com/videos/c/vp/252512f0c7874996ae8b43bed1b1eeed/252512f0c7874996ae8b43bed1b1eeed.HD-1080p-7.2Mbps-99696546.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/252512f0c7874996ae8b43bed1b1eeed.thumbnail.0000000000.jpg?v=1793599361","w":810,"h":1080},"charizard-v-y1344":{"v":"https://cdn.shopify.com/videos/c/vp/c6d6b60ee78345f8a90e41e9efddc9d7/c6d6b60ee78345f8a90e41e9efddc9d7.HD-1080p-7.2Mbps-99696547.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c6d6b60ee78345f8a90e41e9efddc9d7.thumbnail.0000000000.jpg?v=1793599253","w":810,"h":1080},"m-charizard-ex-y1345":{"v":"https://cdn.shopify.com/videos/c/vp/61003880f345408495c72d948fb867ad/61003880f345408495c72d948fb867ad.HD-1080p-7.2Mbps-99696548.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/61003880f345408495c72d948fb867ad.thumbnail.0000000000.jpg?v=1793599335","w":810,"h":1080},"m-evolution-ex-mega-gengar-y1346":{"v":"https://cdn.shopify.com/videos/c/vp/4962677bda2c4d83ad1af7a3bc02614c/4962677bda2c4d83ad1af7a3bc02614c.HD-1080p-7.2Mbps-99696549.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4962677bda2c4d83ad1af7a3bc02614c.thumbnail.0000000000.jpg?v=1793599341","w":810,"h":1080},"m-rayquaza-ex-y1347":{"v":"https://cdn.shopify.com/videos/c/vp/00d6ad55ba4247d49a62cba78c5c5848/00d6ad55ba4247d49a62cba78c5c5848.HD-1080p-7.2Mbps-99696550.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/00d6ad55ba4247d49a62cba78c5c5848.thumbnail.0000000000.jpg?v=1793599362","w":810,"h":1080},"m-lucario-z-ex-y1349":{"v":"https://cdn.shopify.com/videos/c/vp/6559a324594e4ba8bade17c984b17528/6559a324594e4ba8bade17c984b17528.HD-1080p-7.2Mbps-99696552.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6559a324594e4ba8bade17c984b17528.thumbnail.0000000000.jpg?v=1793599241","w":810,"h":1080},"primal-kyogre-ex-y1350":{"v":"https://cdn.shopify.com/videos/c/vp/bd0e1efb8bc245cb96a21996ddefe8db/bd0e1efb8bc245cb96a21996ddefe8db.HD-1080p-7.2Mbps-99696553.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bd0e1efb8bc245cb96a21996ddefe8db.thumbnail.0000000000.jpg?v=1793599367","w":810,"h":1080},"mega-lucario-z-ex-y1351":{"v":"https://cdn.shopify.com/videos/c/vp/892da4966c634c5aa74c66987e15f895/892da4966c634c5aa74c66987e15f895.HD-1080p-7.2Mbps-99696554.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/892da4966c634c5aa74c66987e15f895.thumbnail.0000000000.jpg?v=1793599247","w":810,"h":1080},"zekrom-ex-y1352":{"v":"https://cdn.shopify.com/videos/c/vp/be2f824b42ca4f1a94231f5464049c3a/be2f824b42ca4f1a94231f5464049c3a.HD-1080p-7.2Mbps-99696555.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/be2f824b42ca4f1a94231f5464049c3a.thumbnail.0000000000.jpg?v=1793599338","w":810,"h":1080},"m-charizard-ex-y1353":{"v":"https://cdn.shopify.com/videos/c/vp/cfe79848dc8e4731a8235db6e33a1f2b/cfe79848dc8e4731a8235db6e33a1f2b.HD-1080p-7.2Mbps-99696556.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/cfe79848dc8e4731a8235db6e33a1f2b.thumbnail.0000000000.jpg?v=1793599356","w":810,"h":1080},"mewtwo-ex-y1354":{"v":"https://cdn.shopify.com/videos/c/vp/28de772a5d94454e87d077e31adbdac3/28de772a5d94454e87d077e31adbdac3.HD-1080p-7.2Mbps-99696557.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/28de772a5d94454e87d077e31adbdac3.thumbnail.0000000000.jpg?v=1793599338","w":810,"h":1080},"m-charizard-ex-y1355":{"v":"https://cdn.shopify.com/videos/c/vp/6ba06fc93ff54980ad4c36a1d9cb3f1b/6ba06fc93ff54980ad4c36a1d9cb3f1b.HD-1080p-7.2Mbps-99696558.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6ba06fc93ff54980ad4c36a1d9cb3f1b.thumbnail.0000000000.jpg?v=1793599372","w":810,"h":1080},"mega-charizard-x-ex-y1356":{"v":"https://cdn.shopify.com/videos/c/vp/867a47b1d5b44d7aa0ad59e24e07e147/867a47b1d5b44d7aa0ad59e24e07e147.HD-1080p-7.2Mbps-99696559.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/867a47b1d5b44d7aa0ad59e24e07e147.thumbnail.0000000000.jpg?v=1793599363","w":810,"h":1080},"mega-lucario-z-ex-y1357":{"v":"https://cdn.shopify.com/videos/c/vp/f43c620622ab4c2cbeadce17615f803f/f43c620622ab4c2cbeadce17615f803f.HD-1080p-7.2Mbps-99696561.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f43c620622ab4c2cbeadce17615f803f.thumbnail.0000000000.jpg?v=1793599358","w":810,"h":1080},"shiny-sylveon-vmax-y1358":{"v":"https://cdn.shopify.com/videos/c/vp/9d8c028f61014b10ad1ad4040041ba22/9d8c028f61014b10ad1ad4040041ba22.HD-1080p-7.2Mbps-99696562.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9d8c028f61014b10ad1ad4040041ba22.thumbnail.0000000000.jpg?v=1793599377","w":810,"h":1080},"eevee-ex-y1359":{"v":"https://cdn.shopify.com/videos/c/vp/32351817a33c4b8982cd1cecae08dcf9/32351817a33c4b8982cd1cecae08dcf9.HD-1080p-7.2Mbps-99696563.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/32351817a33c4b8982cd1cecae08dcf9.thumbnail.0000000000.jpg?v=1793599355","w":810,"h":1080},"pikachu-ex-y1360":{"v":"https://cdn.shopify.com/videos/c/vp/767a6d57763349119e598c75e3cd7f85/767a6d57763349119e598c75e3cd7f85.HD-1080p-7.2Mbps-99696564.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/767a6d57763349119e598c75e3cd7f85.thumbnail.0000000000.jpg?v=1793599287","w":810,"h":1080},"ashs-greninja-ex-y1361":{"v":"https://cdn.shopify.com/videos/c/vp/7ea0e412290548fda2a70c4575d1b2a1/7ea0e412290548fda2a70c4575d1b2a1.HD-1080p-7.2Mbps-99696566.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7ea0e412290548fda2a70c4575d1b2a1.thumbnail.0000000000.jpg?v=1793599211","w":810,"h":1080},"sylveon-ex-y1362":{"v":"https://cdn.shopify.com/videos/c/vp/8590df5f239b4c2e87c4a1d3ea75bbea/8590df5f239b4c2e87c4a1d3ea75bbea.HD-1080p-7.2Mbps-99696567.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8590df5f239b4c2e87c4a1d3ea75bbea.thumbnail.0000000000.jpg?v=1793599321","w":810,"h":1080},"mewtwo-ex-y1363":{"v":"https://cdn.shopify.com/videos/c/vp/99974d4d5f664c8c8824aa1a312dd891/99974d4d5f664c8c8824aa1a312dd891.HD-1080p-7.2Mbps-99696568.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/99974d4d5f664c8c8824aa1a312dd891.thumbnail.0000000000.jpg?v=1793599288","w":810,"h":1080},"pikachu-v-y1364":{"v":"https://cdn.shopify.com/videos/c/vp/55717e9f0f26426f97ded209b0220939/55717e9f0f26426f97ded209b0220939.HD-1080p-7.2Mbps-99696570.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/55717e9f0f26426f97ded209b0220939.thumbnail.0000000000.jpg?v=1793599173","w":810,"h":1080},"m-gengar-ex-y1365":{"v":"https://cdn.shopify.com/videos/c/vp/ad5d0c32e6b94011a1692fba89c91a66/ad5d0c32e6b94011a1692fba89c91a66.HD-1080p-7.2Mbps-99696571.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ad5d0c32e6b94011a1692fba89c91a66.thumbnail.0000000000.jpg?v=1793599337","w":810,"h":1080},"necrozma-ex-y1366":{"v":"https://cdn.shopify.com/videos/c/vp/0da656bb6a1849668178fddb9df5d465/0da656bb6a1849668178fddb9df5d465.HD-1080p-7.2Mbps-99696572.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/0da656bb6a1849668178fddb9df5d465.thumbnail.0000000000.jpg?v=1793599237","w":810,"h":1080},"psyduck-ex-y1367":{"v":"https://cdn.shopify.com/videos/c/vp/9288a52cfaf2474c92b29fecc2943c24/9288a52cfaf2474c92b29fecc2943c24.HD-1080p-7.2Mbps-99696573.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9288a52cfaf2474c92b29fecc2943c24.thumbnail.0000000000.jpg?v=1793599365","w":810,"h":1080},"m-lucario-ex-y1368":{"v":"https://cdn.shopify.com/videos/c/vp/2ba808b9fe3049b980771e39873d80fa/2ba808b9fe3049b980771e39873d80fa.HD-1080p-7.2Mbps-99696574.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2ba808b9fe3049b980771e39873d80fa.thumbnail.0000000000.jpg?v=1793599346","w":810,"h":1080},"sylveon-ex-y1370":{"v":"https://cdn.shopify.com/videos/c/vp/970fee80671a4b5e95ef3afb519deea1/970fee80671a4b5e95ef3afb519deea1.HD-1080p-7.2Mbps-99696576.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/970fee80671a4b5e95ef3afb519deea1.thumbnail.0000000000.jpg?v=1793599357","w":810,"h":1080},"dark-charizard-v-y1371":{"v":"https://cdn.shopify.com/videos/c/vp/960231f63fd44faaacc7a8f8412414f8/960231f63fd44faaacc7a8f8412414f8.HD-1080p-7.2Mbps-99696578.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/960231f63fd44faaacc7a8f8412414f8.thumbnail.0000000000.jpg?v=1793599289","w":810,"h":1080},"pikachu-v-y1373":{"v":"https://cdn.shopify.com/videos/c/vp/7957ecd2f80c4fe18cc6e039cdf9f5e1/7957ecd2f80c4fe18cc6e039cdf9f5e1.HD-1080p-7.2Mbps-99696580.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7957ecd2f80c4fe18cc6e039cdf9f5e1.thumbnail.0000000000.jpg?v=1793599325","w":810,"h":1080},"mew-ex-y1374":{"v":"https://cdn.shopify.com/videos/c/vp/60ba1304d2aa496bbbdf979bda64558e/60ba1304d2aa496bbbdf979bda64558e.HD-1080p-7.2Mbps-99696581.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/60ba1304d2aa496bbbdf979bda64558e.thumbnail.0000000000.jpg?v=1793599364","w":810,"h":1080},"pikachu-ex-y1375":{"v":"https://cdn.shopify.com/videos/c/vp/974b2b0163344059ae81d9aca3a0371d/974b2b0163344059ae81d9aca3a0371d.HD-1080p-7.2Mbps-99696583.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/974b2b0163344059ae81d9aca3a0371d.thumbnail.0000000000.jpg?v=1793599262","w":810,"h":1080},"m-lucario-ex-y1376":{"v":"https://cdn.shopify.com/videos/c/vp/9cb8d0bf991e405a9f4456ab2aafeb9a/9cb8d0bf991e405a9f4456ab2aafeb9a.HD-1080p-7.2Mbps-99696584.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9cb8d0bf991e405a9f4456ab2aafeb9a.thumbnail.0000000000.jpg?v=1793599366","w":810,"h":1080},"m-greninja-ex-y1377":{"v":"https://cdn.shopify.com/videos/c/vp/2d1ad7e174204b6dab205d8a0d4fc40a/2d1ad7e174204b6dab205d8a0d4fc40a.HD-1080p-7.2Mbps-99696585.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2d1ad7e174204b6dab205d8a0d4fc40a.thumbnail.0000000000.jpg?v=1793599314","w":810,"h":1080},"m-mewtwo-y-ex-y1378":{"v":"https://cdn.shopify.com/videos/c/vp/8d2806e2b89e45daa6672e569baf0b84/8d2806e2b89e45daa6672e569baf0b84.HD-1080p-7.2Mbps-99696586.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8d2806e2b89e45daa6672e569baf0b84.thumbnail.0000000000.jpg?v=1793599251","w":810,"h":1080},"gengar-ex-y1380":{"v":"https://cdn.shopify.com/videos/c/vp/289420a8aaa548e0a728259a45fc6d1b/289420a8aaa548e0a728259a45fc6d1b.HD-1080p-7.2Mbps-99696588.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/289420a8aaa548e0a728259a45fc6d1b.thumbnail.0000000000.jpg?v=1793599368","w":810,"h":1080},"mewtwo-ex-y1381":{"v":"https://cdn.shopify.com/videos/c/vp/7a4bd80fe0194cbc9921684ddc8fcc4a/7a4bd80fe0194cbc9921684ddc8fcc4a.HD-1080p-7.2Mbps-99696591.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7a4bd80fe0194cbc9921684ddc8fcc4a.thumbnail.0000000000.jpg?v=1793599157","w":810,"h":1080},"m-greninja-ex-y1382":{"v":"https://cdn.shopify.com/videos/c/vp/107b7651026f4f63a954a6c4b8e9f7dc/107b7651026f4f63a954a6c4b8e9f7dc.HD-1080p-7.2Mbps-99696593.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/107b7651026f4f63a954a6c4b8e9f7dc.thumbnail.0000000000.jpg?v=1793599367","w":810,"h":1080},"m-rayquaza-ex-y1383":{"v":"https://cdn.shopify.com/videos/c/vp/e073ce1e7eb54710b3434b03d5267904/e073ce1e7eb54710b3434b03d5267904.HD-1080p-7.2Mbps-99696594.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e073ce1e7eb54710b3434b03d5267904.thumbnail.0000000000.jpg?v=1793599357","w":810,"h":1080},"pikachu-with-a-pearl-earring-y1384":{"v":"https://cdn.shopify.com/videos/c/vp/ca7ab889c2414a91ace4f56d00ad7e56/ca7ab889c2414a91ace4f56d00ad7e56.HD-1080p-7.2Mbps-99696595.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ca7ab889c2414a91ace4f56d00ad7e56.thumbnail.0000000000.jpg?v=1793599323","w":810,"h":1080},"van-goghs-gengar-y1385":{"v":"https://cdn.shopify.com/videos/c/vp/19743eeea0444c1eaf8ebb7726184014/19743eeea0444c1eaf8ebb7726184014.HD-1080p-7.2Mbps-99696596.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/19743eeea0444c1eaf8ebb7726184014.thumbnail.0000000000.jpg?v=1793599207","w":810,"h":1080},"hancock-s-slowbro-y1386":{"v":"https://cdn.shopify.com/videos/c/vp/7ea55b2d7f514fd186a96794605c3814/7ea55b2d7f514fd186a96794605c3814.HD-1080p-7.2Mbps-99696597.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7ea55b2d7f514fd186a96794605c3814.thumbnail.0000000000.jpg?v=1793599362","w":810,"h":1080},"pikachu-y1387":{"v":"https://cdn.shopify.com/videos/c/vp/fcae3123879340738b5cdf37d620c961/fcae3123879340738b5cdf37d620c961.HD-1080p-7.2Mbps-99696598.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/fcae3123879340738b5cdf37d620c961.thumbnail.0000000000.jpg?v=1793599351","w":810,"h":1080},"pikachu-y1389":{"v":"https://cdn.shopify.com/videos/c/vp/b6967d95cf24474fb8382dfa3fb58aa1/b6967d95cf24474fb8382dfa3fb58aa1.HD-1080p-7.2Mbps-99696600.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b6967d95cf24474fb8382dfa3fb58aa1.thumbnail.0000000000.jpg?v=1793599271","w":810,"h":1080},"mimikyu-y1390":{"v":"https://cdn.shopify.com/videos/c/vp/22bc2e55f93b4033aaf8d986fd9b4095/22bc2e55f93b4033aaf8d986fd9b4095.HD-1080p-7.2Mbps-99696601.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/22bc2e55f93b4033aaf8d986fd9b4095.thumbnail.0000000000.jpg?v=1793599248","w":810,"h":1080},"mew-y1391":{"v":"https://cdn.shopify.com/videos/c/vp/aa911756f0904d298829b7d3f4c0062f/aa911756f0904d298829b7d3f4c0062f.HD-1080p-7.2Mbps-99696602.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/aa911756f0904d298829b7d3f4c0062f.thumbnail.0000000000.jpg?v=1793599326","w":810,"h":1080},"psyduck-y1392":{"v":"https://cdn.shopify.com/videos/c/vp/aa2a502e23454bb0ac8f53bf3474daad/aa2a502e23454bb0ac8f53bf3474daad.HD-1080p-7.2Mbps-99696603.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/aa2a502e23454bb0ac8f53bf3474daad.thumbnail.0000000000.jpg?v=1793599352","w":810,"h":1080},"psyduck-y1393":{"v":"https://cdn.shopify.com/videos/c/vp/9568c0a112184048ab14c40da63229fa/9568c0a112184048ab14c40da63229fa.HD-1080p-7.2Mbps-99696604.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9568c0a112184048ab14c40da63229fa.thumbnail.0000000000.jpg?v=1793599317","w":810,"h":1080},"eevee-y1394":{"v":"https://cdn.shopify.com/videos/c/vp/029088199b844ba1927e9aa9925e4590/029088199b844ba1927e9aa9925e4590.HD-1080p-7.2Mbps-99696606.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/029088199b844ba1927e9aa9925e4590.thumbnail.0000000000.jpg?v=1793599305","w":810,"h":1080},"snorlax-y1395":{"v":"https://cdn.shopify.com/videos/c/vp/91906a6566704db8b056a415e3f14f80/91906a6566704db8b056a415e3f14f80.HD-1080p-7.2Mbps-99696607.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/91906a6566704db8b056a415e3f14f80.thumbnail.0000000000.jpg?v=1793599322","w":810,"h":1080},"n-s-zekrom-y1397":{"v":"https://cdn.shopify.com/videos/c/vp/4b9cc83e9f71482796b8a3188414529e/4b9cc83e9f71482796b8a3188414529e.HD-1080p-7.2Mbps-99696609.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4b9cc83e9f71482796b8a3188414529e.thumbnail.0000000000.jpg?v=1793599244","w":810,"h":1080},"eevee-y1398":{"v":"https://cdn.shopify.com/videos/c/vp/b19cf2e56f47401aa68b62434a1cdd7d/b19cf2e56f47401aa68b62434a1cdd7d.HD-1080p-7.2Mbps-99696610.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b19cf2e56f47401aa68b62434a1cdd7d.thumbnail.0000000000.jpg?v=1793599338","w":810,"h":1080},"pikachu-ho-oh-gx-y1401":{"v":"https://cdn.shopify.com/videos/c/vp/963ae278d27d4fd8b06281592b5f3334/963ae278d27d4fd8b06281592b5f3334.HD-1080p-7.2Mbps-99701423.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/963ae278d27d4fd8b06281592b5f3334.thumbnail.0000000000.jpg?v=1793603506","w":810,"h":1080},"gengar-mimikyu-costume-pikachu-gx-y1402":{"v":"https://cdn.shopify.com/videos/c/vp/3616e011c9fc43aca48258b4a9b725d4/3616e011c9fc43aca48258b4a9b725d4.HD-1080p-7.2Mbps-99701424.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/3616e011c9fc43aca48258b4a9b725d4.thumbnail.0000000000.jpg?v=1793603431","w":810,"h":1080},"charizard-ho-oh-gx-y1403":{"v":"https://cdn.shopify.com/videos/c/vp/51d88dfa84354e839c88a726b3348984/51d88dfa84354e839c88a726b3348984.HD-1080p-7.2Mbps-99701425.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/51d88dfa84354e839c88a726b3348984.thumbnail.0000000000.jpg?v=1793603418","w":810,"h":1080},"gengar-bonsly-gx-y1404":{"v":"https://cdn.shopify.com/videos/c/vp/bd016fa64819461e8349d567b2025de2/bd016fa64819461e8349d567b2025de2.HD-1080p-7.2Mbps-99701426.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bd016fa64819461e8349d567b2025de2.thumbnail.0000000000.jpg?v=1793603480","w":810,"h":1080},"mewtwo-mew-gx-y1405":{"v":"https://cdn.shopify.com/videos/c/vp/444c60e38f494e6a99e55e7a9cb48935/444c60e38f494e6a99e55e7a9cb48935.HD-1080p-7.2Mbps-99701427.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/444c60e38f494e6a99e55e7a9cb48935.thumbnail.0000000000.jpg?v=1793603493","w":810,"h":1080},"pikachu-lucario-gx-y1406":{"v":"https://cdn.shopify.com/videos/c/vp/9b3eb738f7ab495388556c1cc55f9b98/9b3eb738f7ab495388556c1cc55f9b98.HD-1080p-7.2Mbps-99701428.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9b3eb738f7ab495388556c1cc55f9b98.thumbnail.0000000000.jpg?v=1793603505","w":810,"h":1080},"mewtwo-red-gyarados-gx-y1407":{"v":"https://cdn.shopify.com/videos/c/vp/825a178a879a493099267c2eab210ebf/825a178a879a493099267c2eab210ebf.HD-1080p-7.2Mbps-99701429.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/825a178a879a493099267c2eab210ebf.thumbnail.0000000000.jpg?v=1793603499","w":810,"h":1080},"raichu-alolan-raichu-gx-y1408":{"v":"https://cdn.shopify.com/videos/c/vp/7e005d6a27d1483287a0acb5c93da4ac/7e005d6a27d1483287a0acb5c93da4ac.HD-1080p-7.2Mbps-99701430.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7e005d6a27d1483287a0acb5c93da4ac.thumbnail.0000000000.jpg?v=1793603505","w":810,"h":1080},"knuckles-shadow-gx-y1409":{"v":"https://cdn.shopify.com/videos/c/vp/e0dea66728f44a8a8f37726d33bb3a2d/e0dea66728f44a8a8f37726d33bb3a2d.HD-1080p-7.2Mbps-99701431.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e0dea66728f44a8a8f37726d33bb3a2d.thumbnail.0000000000.jpg?v=1793603386","w":810,"h":1080},"lugia-sylveon-gx-y1410":{"v":"https://cdn.shopify.com/videos/c/vp/ddd3eca20b174539a01950007ec15f84/ddd3eca20b174539a01950007ec15f84.HD-1080p-7.2Mbps-99701433.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ddd3eca20b174539a01950007ec15f84.thumbnail.0000000000.jpg?v=1793603475","w":810,"h":1080},"umbreon-espeon-gx-y1411":{"v":"https://cdn.shopify.com/videos/c/vp/52cbf3df4ab54b91ad9b3db3ec4e8837/52cbf3df4ab54b91ad9b3db3ec4e8837.HD-1080p-7.2Mbps-99701434.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/52cbf3df4ab54b91ad9b3db3ec4e8837.thumbnail.0000000000.jpg?v=1793603499","w":810,"h":1080},"jigglypuff-eevee-gx-y1412":{"v":"https://cdn.shopify.com/videos/c/vp/58dc088b59214b288d1dd31d5c141e54/58dc088b59214b288d1dd31d5c141e54.HD-1080p-7.2Mbps-99701435.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/58dc088b59214b288d1dd31d5c141e54.thumbnail.0000000000.jpg?v=1793603513","w":810,"h":1080},"gardevoir-sylveon-gx-y1413":{"v":"https://cdn.shopify.com/videos/c/vp/e34eccdf67614c1383ac95afeadd39ca/e34eccdf67614c1383ac95afeadd39ca.HD-1080p-7.2Mbps-99701436.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e34eccdf67614c1383ac95afeadd39ca.thumbnail.0000000000.jpg?v=1793603507","w":810,"h":1080},"sylveon-pikachu-gx-y1414":{"v":"https://cdn.shopify.com/videos/c/vp/2719168e12ae4fe08ef8e8e5af89ab49/2719168e12ae4fe08ef8e8e5af89ab49.HD-1080p-7.2Mbps-99701437.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2719168e12ae4fe08ef8e8e5af89ab49.thumbnail.0000000000.jpg?v=1793603234","w":810,"h":1080},"gengar-mimikyu-gx-y1415":{"v":"https://cdn.shopify.com/videos/c/vp/c6985fd7838842abac9579abb5a6e899/c6985fd7838842abac9579abb5a6e899.HD-1080p-7.2Mbps-99701438.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c6985fd7838842abac9579abb5a6e899.thumbnail.0000000000.jpg?v=1793603428","w":810,"h":1080},"rayquaza-deoxys-gx-y1416":{"v":"https://cdn.shopify.com/videos/c/vp/b3c15e25ac9a40f59ce33936dd2ab8ac/b3c15e25ac9a40f59ce33936dd2ab8ac.HD-1080p-7.2Mbps-99701439.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b3c15e25ac9a40f59ce33936dd2ab8ac.thumbnail.0000000000.jpg?v=1793603507","w":810,"h":1080},"charizard-charizard-gx-y1417":{"v":"https://cdn.shopify.com/videos/c/vp/01b4e2aa3b924173a91e0f19a04e7191/01b4e2aa3b924173a91e0f19a04e7191.HD-1080p-7.2Mbps-99701440.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/01b4e2aa3b924173a91e0f19a04e7191.thumbnail.0000000000.jpg?v=1793603491","w":810,"h":1080},"dragonite-pikachu-gx-y1418":{"v":"https://cdn.shopify.com/videos/c/vp/394612057ccd4ad48bdf9e82d07ee108/394612057ccd4ad48bdf9e82d07ee108.HD-1080p-7.2Mbps-99701441.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/394612057ccd4ad48bdf9e82d07ee108.thumbnail.0000000000.jpg?v=1793603365","w":810,"h":1080},"pikachu-psyduck-gx-y1423":{"v":"https://cdn.shopify.com/videos/c/vp/31683d2ce8b4445982a669b360c2e2b0/31683d2ce8b4445982a669b360c2e2b0.HD-1080p-7.2Mbps-99706970.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/31683d2ce8b4445982a669b360c2e2b0.thumbnail.0000000000.jpg?v=1793606739","w":810,"h":1080},"wukong-infernape-buddha-pikachu-gx-y1420":{"v":"https://cdn.shopify.com/videos/c/vp/77331719660e477785c36b3a825ee167/77331719660e477785c36b3a825ee167.HD-1080p-7.2Mbps-99701443.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/77331719660e477785c36b3a825ee167.thumbnail.0000000000.jpg?v=1793603293","w":810,"h":1080},"gengar-haunter-gastly-gx-y1421":{"v":"https://cdn.shopify.com/videos/c/vp/dee7e9be8ce943dbaef3bbb8df501d4c/dee7e9be8ce943dbaef3bbb8df501d4c.HD-1080p-7.2Mbps-99701445.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/dee7e9be8ce943dbaef3bbb8df501d4c.thumbnail.0000000000.jpg?v=1793603289","w":810,"h":1080},"clefable-gengar-gx-y1422":{"v":"https://cdn.shopify.com/videos/c/vp/7df6c4e476a847d9bebad065c8d059ff/7df6c4e476a847d9bebad065c8d059ff.HD-1080p-7.2Mbps-99701446.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7df6c4e476a847d9bebad065c8d059ff.thumbnail.0000000000.jpg?v=1793603401","w":810,"h":1080},"mega-gengar-gengar-haunter-gastly-gx-y1419":{"v":"https://cdn.shopify.com/videos/c/vp/6904d74119444091af6f35d766b974e5/6904d74119444091af6f35d766b974e5.HD-1080p-7.2Mbps-99707079.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6904d74119444091af6f35d766b974e5.thumbnail.0000000000.jpg?v=1793606796","w":810,"h":1080},"mewtwo-mew-gx-y1424":{"v":"https://cdn.shopify.com/videos/c/vp/c5045a9bc0e1431699276df349f202e2/c5045a9bc0e1431699276df349f202e2.HD-1080p-7.2Mbps-99701448.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/c5045a9bc0e1431699276df349f202e2.thumbnail.0000000000.jpg?v=1793603344","w":810,"h":1080},"gengar-pikachu-gx-y1425":{"v":"https://cdn.shopify.com/videos/c/vp/f342187b0f53490194585d868915ae6d/f342187b0f53490194585d868915ae6d.HD-1080p-7.2Mbps-99701450.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f342187b0f53490194585d868915ae6d.thumbnail.0000000000.jpg?v=1793603501","w":810,"h":1080},"van-gogh-s-pikachu-rayquaza-gx-y1426":{"v":"https://cdn.shopify.com/videos/c/vp/4048a56ec3e34d35a926c226a2b20118/4048a56ec3e34d35a926c226a2b20118.HD-1080p-7.2Mbps-99701452.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4048a56ec3e34d35a926c226a2b20118.thumbnail.0000000000.jpg?v=1793603466","w":810,"h":1080},"magikarp-gyarados-gx-y1427":{"v":"https://cdn.shopify.com/videos/c/vp/22c20d5a273d4ad1b0cf614094981ecf/22c20d5a273d4ad1b0cf614094981ecf.HD-1080p-7.2Mbps-99701453.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/22c20d5a273d4ad1b0cf614094981ecf.thumbnail.0000000000.jpg?v=1793603190","w":810,"h":1080},"slowpoke-psyduck-gx-y1428":{"v":"https://cdn.shopify.com/videos/c/vp/60067d4d2fff42e29e60f8d600d996d6/60067d4d2fff42e29e60f8d600d996d6.HD-1080p-7.2Mbps-99701454.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/60067d4d2fff42e29e60f8d600d996d6.thumbnail.0000000000.jpg?v=1793603184","w":810,"h":1080},"luffy-s-pikachu-ex-y1430":{"v":"https://cdn.shopify.com/videos/c/vp/b1f825eaf40c44388159c96534cff571/b1f825eaf40c44388159c96534cff571.HD-1080p-7.2Mbps-99701456.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b1f825eaf40c44388159c96534cff571.thumbnail.0000000000.jpg?v=1793603438","w":810,"h":1080},"reshiram-vmax-y1431":{"v":"https://cdn.shopify.com/videos/c/vp/95f29a965e854971a4a0ac65bec5f19d/95f29a965e854971a4a0ac65bec5f19d.HD-1080p-7.2Mbps-99701457.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/95f29a965e854971a4a0ac65bec5f19d.thumbnail.0000000000.jpg?v=1793603158","w":810,"h":1080},"mewtwo-ex-y1432":{"v":"https://cdn.shopify.com/videos/c/vp/bc98391ffcf84180afd6ba56768bf523/bc98391ffcf84180afd6ba56768bf523.HD-1080p-7.2Mbps-99701458.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bc98391ffcf84180afd6ba56768bf523.thumbnail.0000000000.jpg?v=1793603434","w":810,"h":1080},"charizard-ex-y1433":{"v":"https://cdn.shopify.com/videos/c/vp/d35401ea40c04525873a8afb698dea7e/d35401ea40c04525873a8afb698dea7e.HD-1080p-7.2Mbps-99701459.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d35401ea40c04525873a8afb698dea7e.thumbnail.0000000000.jpg?v=1793603464","w":810,"h":1080},"pikachu-vmax-y1434":{"v":"https://cdn.shopify.com/videos/c/vp/2f10b3892af24edcb4e5d67fb8aa8781/2f10b3892af24edcb4e5d67fb8aa8781.HD-1080p-7.2Mbps-99701460.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2f10b3892af24edcb4e5d67fb8aa8781.thumbnail.0000000000.jpg?v=1793603249","w":810,"h":1080},"charmander-v-y1435":{"v":"https://cdn.shopify.com/videos/c/vp/554cb1b5157e4aa79ea5e9fdf5f6c6d3/554cb1b5157e4aa79ea5e9fdf5f6c6d3.HD-1080p-7.2Mbps-99701461.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/554cb1b5157e4aa79ea5e9fdf5f6c6d3.thumbnail.0000000000.jpg?v=1793603322","w":810,"h":1080},"m-charizard-ex-y1436":{"v":"https://cdn.shopify.com/videos/c/vp/159dfc58b0e846768cda36e7f31afb37/159dfc58b0e846768cda36e7f31afb37.HD-1080p-7.2Mbps-99701462.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/159dfc58b0e846768cda36e7f31afb37.thumbnail.0000000000.jpg?v=1793603456","w":810,"h":1080},"mimikyu-y1437":{"v":"https://cdn.shopify.com/videos/c/vp/0ef1fcf74cf94205b7e7c8eed2d2fedf/0ef1fcf74cf94205b7e7c8eed2d2fedf.HD-1080p-7.2Mbps-99701463.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/0ef1fcf74cf94205b7e7c8eed2d2fedf.thumbnail.0000000000.jpg?v=1793603420","w":810,"h":1080},"mew-vmax-y1438":{"v":"https://cdn.shopify.com/videos/c/vp/d4ab08cb05954af5a8c48a26435a1d3a/d4ab08cb05954af5a8c48a26435a1d3a.HD-1080p-7.2Mbps-99701464.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d4ab08cb05954af5a8c48a26435a1d3a.thumbnail.0000000000.jpg?v=1793603418","w":810,"h":1080},"charizard-vmax-y1439":{"v":"https://cdn.shopify.com/videos/c/vp/09a02c3e71bd4742bdf21ec4edaa2414/09a02c3e71bd4742bdf21ec4edaa2414.HD-1080p-7.2Mbps-99701465.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/09a02c3e71bd4742bdf21ec4edaa2414.thumbnail.0000000000.jpg?v=1793603344","w":810,"h":1080},"mega-rayquaza-ex-y1441":{"v":"https://cdn.shopify.com/videos/c/vp/ebdcc16a3a694d55a76f2d5352eb6360/ebdcc16a3a694d55a76f2d5352eb6360.HD-1080p-7.2Mbps-99701466.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/ebdcc16a3a694d55a76f2d5352eb6360.thumbnail.0000000000.jpg?v=1793603508","w":810,"h":1080},"mew-ex-y1442":{"v":"https://cdn.shopify.com/videos/c/vp/0c2c495e5fa843a2b4d150ca08c29282/0c2c495e5fa843a2b4d150ca08c29282.HD-1080p-7.2Mbps-99701468.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/0c2c495e5fa843a2b4d150ca08c29282.thumbnail.0000000000.jpg?v=1793603415","w":810,"h":1080},"pikachu-vmax-y1443":{"v":"https://cdn.shopify.com/videos/c/vp/77712158ba8b403ba4d1ec6f7c448f13/77712158ba8b403ba4d1ec6f7c448f13.HD-1080p-7.2Mbps-99701471.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/77712158ba8b403ba4d1ec6f7c448f13.thumbnail.0000000000.jpg?v=1793603182","w":810,"h":1080},"mew-ex-y1444":{"v":"https://cdn.shopify.com/videos/c/vp/cfb8c2139744425a9211a5f98a4978bc/cfb8c2139744425a9211a5f98a4978bc.HD-1080p-7.2Mbps-99701472.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/cfb8c2139744425a9211a5f98a4978bc.thumbnail.0000000000.jpg?v=1793603284","w":810,"h":1080},"team-rocket-s-meowth-ex-y1445":{"v":"https://cdn.shopify.com/videos/c/vp/7da8a4573f274380beb38d13be1fa283/7da8a4573f274380beb38d13be1fa283.HD-1080p-7.2Mbps-99701474.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7da8a4573f274380beb38d13be1fa283.thumbnail.0000000000.jpg?v=1793603473","w":810,"h":1080},"snorlax-v-y1446":{"v":"https://cdn.shopify.com/videos/c/vp/789985aac1214e4d8ce9ed1a97c1de2a/789985aac1214e4d8ce9ed1a97c1de2a.HD-1080p-7.2Mbps-99701475.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/789985aac1214e4d8ce9ed1a97c1de2a.thumbnail.0000000000.jpg?v=1793603395","w":810,"h":1080},"m-rayquaza-ex-y1447":{"v":"https://cdn.shopify.com/videos/c/vp/00dee68e977e483893880cde6412f361/00dee68e977e483893880cde6412f361.HD-1080p-7.2Mbps-99701476.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/00dee68e977e483893880cde6412f361.thumbnail.0000000000.jpg?v=1793603293","w":810,"h":1080},"reshiram-ex-y1448":{"v":"https://cdn.shopify.com/videos/c/vp/5c7f2828c9f840338cb7c08e2c671b2e/5c7f2828c9f840338cb7c08e2c671b2e.HD-1080p-7.2Mbps-99701477.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/5c7f2828c9f840338cb7c08e2c671b2e.thumbnail.0000000000.jpg?v=1793603506","w":810,"h":1080},"m-charizard-ex-y1449":{"v":"https://cdn.shopify.com/videos/c/vp/fe2b62332ca840d9a0090e25bf3900ea/fe2b62332ca840d9a0090e25bf3900ea.HD-1080p-7.2Mbps-99701478.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/fe2b62332ca840d9a0090e25bf3900ea.thumbnail.0000000000.jpg?v=1793603475","w":810,"h":1080},"m-mewtwo-y-ex-y1450":{"v":"https://cdn.shopify.com/videos/c/vp/e88dd352a2574bb2859182ac692448e9/e88dd352a2574bb2859182ac692448e9.HD-1080p-7.2Mbps-99701479.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e88dd352a2574bb2859182ac692448e9.thumbnail.0000000000.jpg?v=1793603401","w":810,"h":1080},"psyduck-vmax-y1451":{"v":"https://cdn.shopify.com/videos/c/vp/d905359289b84d9db1c83945b1dbd185/d905359289b84d9db1c83945b1dbd185.HD-1080p-7.2Mbps-99701480.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/d905359289b84d9db1c83945b1dbd185.thumbnail.0000000000.jpg?v=1793603493","w":810,"h":1080},"m-rayquaza-ex-y1452":{"v":"https://cdn.shopify.com/videos/c/vp/01150ab78d294db7aa8a4625c23ac2a7/01150ab78d294db7aa8a4625c23ac2a7.HD-1080p-7.2Mbps-99701481.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/01150ab78d294db7aa8a4625c23ac2a7.thumbnail.0000000000.jpg?v=1793603389","w":810,"h":1080},"mew-gx-y1453":{"v":"https://cdn.shopify.com/videos/c/vp/6a8ea3121f7142868356c1c352391187/6a8ea3121f7142868356c1c352391187.HD-1080p-7.2Mbps-99701482.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/6a8ea3121f7142868356c1c352391187.thumbnail.0000000000.jpg?v=1793603422","w":810,"h":1080},"m-blastoise-ex-y1454":{"v":"https://cdn.shopify.com/videos/c/vp/3ef02e52c7fe4fda91869c76bc3df0a1/3ef02e52c7fe4fda91869c76bc3df0a1.HD-1080p-7.2Mbps-99701483.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/3ef02e52c7fe4fda91869c76bc3df0a1.thumbnail.0000000000.jpg?v=1793603513","w":810,"h":1080},"m-charizard-ex-y1455":{"v":"https://cdn.shopify.com/videos/c/vp/f859e0ee52fa4f7f9352a4f89eba931e/f859e0ee52fa4f7f9352a4f89eba931e.HD-1080p-7.2Mbps-99701484.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f859e0ee52fa4f7f9352a4f89eba931e.thumbnail.0000000000.jpg?v=1793603410","w":810,"h":1080},"greninja-ex-y1458":{"v":"https://cdn.shopify.com/videos/c/vp/9f50ea585d534238a8bd11784b623573/9f50ea585d534238a8bd11784b623573.HD-1080p-7.2Mbps-99701486.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9f50ea585d534238a8bd11784b623573.thumbnail.0000000000.jpg?v=1793603467","w":810,"h":1080},"shiny-rayquaza-ex-y1459":{"v":"https://cdn.shopify.com/videos/c/vp/7e298ed4e647425988e80d228992fa90/7e298ed4e647425988e80d228992fa90.HD-1080p-7.2Mbps-99701487.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/7e298ed4e647425988e80d228992fa90.thumbnail.0000000000.jpg?v=1793603494","w":810,"h":1080},"m-slowbro-ex-y1460":{"v":"https://cdn.shopify.com/videos/c/vp/457f001d8ca246bf8a8486feb41d2438/457f001d8ca246bf8a8486feb41d2438.HD-1080p-7.2Mbps-99701488.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/457f001d8ca246bf8a8486feb41d2438.thumbnail.0000000000.jpg?v=1793603481","w":810,"h":1080},"magearna-ex-y1461":{"v":"https://cdn.shopify.com/videos/c/vp/57c0ac8bb8034cd1ab214d28e0c1e894/57c0ac8bb8034cd1ab214d28e0c1e894.HD-1080p-7.2Mbps-99701489.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/57c0ac8bb8034cd1ab214d28e0c1e894.thumbnail.0000000000.jpg?v=1793603446","w":810,"h":1080},"m-diancie-ex-y1462":{"v":"https://cdn.shopify.com/videos/c/vp/26a84efdb416431892d8e17dcf200efd/26a84efdb416431892d8e17dcf200efd.HD-1080p-7.2Mbps-99701490.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/26a84efdb416431892d8e17dcf200efd.thumbnail.0000000000.jpg?v=1793603509","w":810,"h":1080},"m-gengar-ex-y1463":{"v":"https://cdn.shopify.com/videos/c/vp/b3e19b9fbe0245de88f40be30d5379ac/b3e19b9fbe0245de88f40be30d5379ac.HD-1080p-7.2Mbps-99701492.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b3e19b9fbe0245de88f40be30d5379ac.thumbnail.0000000000.jpg?v=1793603323","w":810,"h":1080},"m-absol-ex-y1464":{"v":"https://cdn.shopify.com/videos/c/vp/bf832078806a4afe87a9879103a5d063/bf832078806a4afe87a9879103a5d063.HD-1080p-7.2Mbps-99701493.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bf832078806a4afe87a9879103a5d063.thumbnail.0000000000.jpg?v=1793603503","w":810,"h":1080},"m-alakazam-ex-y1465":{"v":"https://cdn.shopify.com/videos/c/vp/f24f87710bd24f7abbe23927fee99973/f24f87710bd24f7abbe23927fee99973.HD-1080p-7.2Mbps-99701494.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f24f87710bd24f7abbe23927fee99973.thumbnail.0000000000.jpg?v=1793603484","w":810,"h":1080},"mega-lucario-z-ex-y1466":{"v":"https://cdn.shopify.com/videos/c/vp/8c4d95c2de2c42048f60ca217660d50e/8c4d95c2de2c42048f60ca217660d50e.HD-1080p-7.2Mbps-99701495.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/8c4d95c2de2c42048f60ca217660d50e.thumbnail.0000000000.jpg?v=1793603489","w":810,"h":1080},"ash-greninja-v-y1467":{"v":"https://cdn.shopify.com/videos/c/vp/322e6c97658e43dcaa59f3ad20316ac9/322e6c97658e43dcaa59f3ad20316ac9.HD-1080p-7.2Mbps-99701496.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/322e6c97658e43dcaa59f3ad20316ac9.thumbnail.0000000000.jpg?v=1793603499","w":810,"h":1080},"gengar-ex-y1468":{"v":"https://cdn.shopify.com/videos/c/vp/39c22afe667d4052aa98a78f61b3fee9/39c22afe667d4052aa98a78f61b3fee9.HD-1080p-7.2Mbps-99701497.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/39c22afe667d4052aa98a78f61b3fee9.thumbnail.0000000000.jpg?v=1793603190","w":810,"h":1080},"gengar-ex-y1469":{"v":"https://cdn.shopify.com/videos/c/vp/78d61ac239e145518362fcf334b129a4/78d61ac239e145518362fcf334b129a4.HD-1080p-7.2Mbps-99701499.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/78d61ac239e145518362fcf334b129a4.thumbnail.0000000000.jpg?v=1793603337","w":810,"h":1080},"blastoise-vmax-y1470":{"v":"https://cdn.shopify.com/videos/c/vp/80ba5404ce0b4b8cbf1a3ab82ca33a96/80ba5404ce0b4b8cbf1a3ab82ca33a96.HD-1080p-7.2Mbps-99701500.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/80ba5404ce0b4b8cbf1a3ab82ca33a96.thumbnail.0000000000.jpg?v=1793603369","w":810,"h":1080},"shiny-m-gengar-ex-y1471":{"v":"https://cdn.shopify.com/videos/c/vp/36d3dfc7206b471f91d7daec080ebdc1/36d3dfc7206b471f91d7daec080ebdc1.HD-1080p-7.2Mbps-99701501.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/36d3dfc7206b471f91d7daec080ebdc1.thumbnail.0000000000.jpg?v=1793603508","w":810,"h":1080},"venusaur-vmax-y1472":{"v":"https://cdn.shopify.com/videos/c/vp/0f0172ffead44ad59e03aa50b22c1e76/0f0172ffead44ad59e03aa50b22c1e76.HD-1080p-7.2Mbps-99701502.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/0f0172ffead44ad59e03aa50b22c1e76.thumbnail.0000000000.jpg?v=1793603404","w":810,"h":1080},"ampharos-ex-y1473":{"v":"https://cdn.shopify.com/videos/c/vp/359a3a73c030445c81119745fdf6b8be/359a3a73c030445c81119745fdf6b8be.HD-1080p-7.2Mbps-99701503.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/359a3a73c030445c81119745fdf6b8be.thumbnail.0000000000.jpg?v=1793603444","w":810,"h":1080},"deoxys-ex-y1474":{"v":"https://cdn.shopify.com/videos/c/vp/0df1327d3eee4423918e152e6364ce0b/0df1327d3eee4423918e152e6364ce0b.HD-1080p-7.2Mbps-99701504.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/0df1327d3eee4423918e152e6364ce0b.thumbnail.0000000000.jpg?v=1793603414","w":810,"h":1080},"shadow-lugia-ex-y1475":{"v":"https://cdn.shopify.com/videos/c/vp/a592b79d152e4becbc427975637f8e32/a592b79d152e4becbc427975637f8e32.HD-1080p-7.2Mbps-99701505.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a592b79d152e4becbc427975637f8e32.thumbnail.0000000000.jpg?v=1793603407","w":810,"h":1080},"m-hawlucha-ex-y1476":{"v":"https://cdn.shopify.com/videos/c/vp/9417b05015924c2493f19a14ba706f5e/9417b05015924c2493f19a14ba706f5e.HD-1080p-7.2Mbps-99701506.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9417b05015924c2493f19a14ba706f5e.thumbnail.0000000000.jpg?v=1793603387","w":810,"h":1080},"giratina-ex-y1477":{"v":"https://cdn.shopify.com/videos/c/vp/a2491cca32cf474883dfc439060a62d6/a2491cca32cf474883dfc439060a62d6.HD-1080p-7.2Mbps-99701507.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/a2491cca32cf474883dfc439060a62d6.thumbnail.0000000000.jpg?v=1793603401","w":810,"h":1080},"m-banette-ex-y1478":{"v":"https://cdn.shopify.com/videos/c/vp/f7c77564660e4d2f93aa38d3be2e8a46/f7c77564660e4d2f93aa38d3be2e8a46.HD-1080p-7.2Mbps-99701508.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f7c77564660e4d2f93aa38d3be2e8a46.thumbnail.0000000000.jpg?v=1793603275","w":810,"h":1080},"starmie-vmax-y1479":{"v":"https://cdn.shopify.com/videos/c/vp/f662687e529847e187d48be60a1f3810/f662687e529847e187d48be60a1f3810.HD-1080p-7.2Mbps-99701509.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/f662687e529847e187d48be60a1f3810.thumbnail.0000000000.jpg?v=1793603476","w":810,"h":1080},"gengar-ex-y1480":{"v":"https://cdn.shopify.com/videos/c/vp/00c41369222e40ed9fb4354c54e02dbf/00c41369222e40ed9fb4354c54e02dbf.HD-1080p-7.2Mbps-99701511.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/00c41369222e40ed9fb4354c54e02dbf.thumbnail.0000000000.jpg?v=1793603335","w":810,"h":1080},"gengar-vmax-y1481":{"v":"https://cdn.shopify.com/videos/c/vp/9f33cf5fbf284d4bb0a791b9e9020230/9f33cf5fbf284d4bb0a791b9e9020230.HD-1080p-7.2Mbps-99701512.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/9f33cf5fbf284d4bb0a791b9e9020230.thumbnail.0000000000.jpg?v=1793603499","w":810,"h":1080},"charizard-ex-y1482":{"v":"https://cdn.shopify.com/videos/c/vp/2bb92d4a2d404455a558204d0bc7f229/2bb92d4a2d404455a558204d0bc7f229.HD-1080p-7.2Mbps-99701513.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2bb92d4a2d404455a558204d0bc7f229.thumbnail.0000000000.jpg?v=1793603191","w":810,"h":1080},"eevee-vmax-y1483":{"v":"https://cdn.shopify.com/videos/c/vp/99e3b4a7308843c19ec2e85e0d631bf8/99e3b4a7308843c19ec2e85e0d631bf8.HD-1080p-7.2Mbps-99701514.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/99e3b4a7308843c19ec2e85e0d631bf8.thumbnail.0000000000.jpg?v=1793603277","w":810,"h":1080},"luffys-pikachu-ex-y1484":{"v":"https://cdn.shopify.com/videos/c/vp/b6efcf4a509f458aadc2d0927ac4b926/b6efcf4a509f458aadc2d0927ac4b926.HD-1080p-7.2Mbps-99701515.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/b6efcf4a509f458aadc2d0927ac4b926.thumbnail.0000000000.jpg?v=1793603504","w":810,"h":1080},"charizard-v-y1485":{"v":"https://cdn.shopify.com/videos/c/vp/73d8c38af69e4177a510a0c703481da3/73d8c38af69e4177a510a0c703481da3.HD-1080p-7.2Mbps-99701516.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/73d8c38af69e4177a510a0c703481da3.thumbnail.0000000000.jpg?v=1793603317","w":810,"h":1080},"pikachu-y1486":{"v":"https://cdn.shopify.com/videos/c/vp/bd25cb4162fc448d87fc9983b0fe1c95/bd25cb4162fc448d87fc9983b0fe1c95.HD-1080p-7.2Mbps-99701517.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/bd25cb4162fc448d87fc9983b0fe1c95.thumbnail.0000000000.jpg?v=1793603490","w":810,"h":1080},"snorlax-poncho-pikachu-y1487":{"v":"https://cdn.shopify.com/videos/c/vp/16baa800e4fe46209b8a25fb790083e9/16baa800e4fe46209b8a25fb790083e9.HD-1080p-7.2Mbps-99701518.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/16baa800e4fe46209b8a25fb790083e9.thumbnail.0000000000.jpg?v=1793603406","w":810,"h":1080},"jedi-pikachu-y1488":{"v":"https://cdn.shopify.com/videos/c/vp/202a70976aa847fe8d3c027e8d313bf9/202a70976aa847fe8d3c027e8d313bf9.HD-1080p-7.2Mbps-99701519.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/202a70976aa847fe8d3c027e8d313bf9.thumbnail.0000000000.jpg?v=1793603499","w":810,"h":1080},"van-goghs-pikachu-y1489":{"v":"https://cdn.shopify.com/videos/c/vp/67f07bf817b2405da1a2872ac1d6fda6/67f07bf817b2405da1a2872ac1d6fda6.HD-1080p-7.2Mbps-99701520.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/67f07bf817b2405da1a2872ac1d6fda6.thumbnail.0000000000.jpg?v=1793603486","w":810,"h":1080},"cosplay-pikachu-y1490":{"v":"https://cdn.shopify.com/videos/c/vp/927be2e4a89b4c2fbd1ee8a6e0d4d7dd/927be2e4a89b4c2fbd1ee8a6e0d4d7dd.HD-1080p-7.2Mbps-99701521.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/927be2e4a89b4c2fbd1ee8a6e0d4d7dd.thumbnail.0000000000.jpg?v=1793603512","w":810,"h":1080},"meowth-y1491":{"v":"https://cdn.shopify.com/videos/c/vp/cb041dd9043a4f379c0675968df21603/cb041dd9043a4f379c0675968df21603.HD-1080p-7.2Mbps-99701522.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/cb041dd9043a4f379c0675968df21603.thumbnail.0000000000.jpg?v=1793603506","w":810,"h":1080},"psyduck-y1492":{"v":"https://cdn.shopify.com/videos/c/vp/238dabf1e30b49ed8ecfa089293b55e9/238dabf1e30b49ed8ecfa089293b55e9.HD-1080p-7.2Mbps-99701523.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/238dabf1e30b49ed8ecfa089293b55e9.thumbnail.0000000000.jpg?v=1793603504","w":810,"h":1080},"pikachu-y1493":{"v":"https://cdn.shopify.com/videos/c/vp/4ed5979c9afe4f5dba46e35f80ba2b64/4ed5979c9afe4f5dba46e35f80ba2b64.HD-1080p-7.2Mbps-99701524.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/4ed5979c9afe4f5dba46e35f80ba2b64.thumbnail.0000000000.jpg?v=1793603395","w":810,"h":1080},"umbreon-y1494":{"v":"https://cdn.shopify.com/videos/c/vp/2b850e0d2ee44d5e8c6d45f240b2e86c/2b850e0d2ee44d5e8c6d45f240b2e86c.HD-1080p-7.2Mbps-99701525.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/2b850e0d2ee44d5e8c6d45f240b2e86c.thumbnail.0000000000.jpg?v=1793603508","w":810,"h":1080},"van-goghs-luigi-pikachu-y1495":{"v":"https://cdn.shopify.com/videos/c/vp/32381c115e0846498259f0a411773f1a/32381c115e0846498259f0a411773f1a.HD-1080p-7.2Mbps-99701526.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/32381c115e0846498259f0a411773f1a.thumbnail.0000000000.jpg?v=1793603500","w":810,"h":1080},"pikachu-charizard-jurassic-escape-y1496":{"v":"https://cdn.shopify.com/videos/c/vp/672238593c6b4159ac7527f5e5a7118e/672238593c6b4159ac7527f5e5a7118e.HD-1080p-7.2Mbps-99701527.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/672238593c6b4159ac7527f5e5a7118e.thumbnail.0000000000.jpg?v=1793603470","w":810,"h":1080},"slowpoke-y1497":{"v":"https://cdn.shopify.com/videos/c/vp/e75ad950234e4ff89861b3e239bc4fd6/e75ad950234e4ff89861b3e239bc4fd6.HD-1080p-7.2Mbps-99701528.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/e75ad950234e4ff89861b3e239bc4fd6.thumbnail.0000000000.jpg?v=1793603345","w":810,"h":1080},"pikachu-y1498":{"v":"https://cdn.shopify.com/videos/c/vp/3c8484533cda43a4b649bf631aba34ef/3c8484533cda43a4b649bf631aba34ef.HD-1080p-7.2Mbps-99701529.mp4","p":"https://cdn.shopify.com/s/files/1/0601/3970/0357/files/preview_images/3c8484533cda43a4b649bf631aba34ef.thumbnail.0000000000.jpg?v=1793603404","w":810,"h":1080}};
  /* === BB_REEL_VIDEOS:END === */

  /* REELS-VIDEO-VISIBLE-20261026：动态拼出来的看货器卡补 <video>。
     标记和 reels.liquid 里静态渲染的那段**逐属性一致**（class / muted / loop / playsinline /
     x5 三件套 / preload=none），所以静态首屏和动态喂进来的卡长得一模一样。 */
  /* 动态卡（seedReelFeed 现拼的）也要有 VIDEO / PHOTO 那对缩略图，
     标记与 reels.liquid 里静态渲染的那段一致。没视频的卡直接返回空串。 */
  function reelTabsHTML(handle, src) {
    var m = (typeof REEL_VIDEOS !== 'undefined') && REEL_VIDEOS && REEL_VIDEOS[handle];
    if (!m || !m.v) return '';
    var vp = m.p ? cdnSize(m.p, '124x124') : cdnSize(src, '124x124');
    return '<div class="reel__tabs" data-reel-tabs>'
      + '<button class="reel__tab on" type="button" data-reel-tab="video"><img src="' + vp + '" alt="" width="124" height="124" loading="lazy"><span>Video</span></button>'
      + '<button class="reel__tab" type="button" data-reel-tab="photo"><img src="' + cdnSize(src, '124x124') + '" alt="" width="124" height="124" loading="lazy"><span>Photo</span></button>'
      + '</div>';
  }

  function reelVideoTag(handle) {
    var m = (typeof REEL_VIDEOS !== 'undefined') && REEL_VIDEOS && REEL_VIDEOS[handle];
    if (!m || !m.v) return '';
    /* SLIM-20261102：表里通常只存 v(1080p) 和 p(封面)，m/l 由 URL 派生 ——
       Shopify 同一段视频的三档 mp4 只差文件名中间那段，其余同源同 id
       （…<uuid>.HD-1080p-7.2Mbps-<id>.mp4 / …HD-720p-4.5Mbps-<id>.mp4 / …SD-480p-1.5Mbps-<id>.mp4）。
       实测全站 341/341 都有三档；素材真少档时生成器会把真实地址写进 m/l，这里优先用它。 */
    var HD = 'HD-1080p-7.2Mbps';
    var mid = m.m || (m.v.indexOf(HD) >= 0 ? m.v.replace(HD, 'HD-720p-4.5Mbps') : '');
    var lo = m.l || (m.v.indexOf(HD) >= 0 ? m.v.replace(HD, 'SD-480p-1.5Mbps') : '');
    return '<video class="reel__vid" src="' + m.v + '"'
      + (mid && mid !== m.v ? ' data-src-mid="' + mid + '"' : '')
      + (lo && lo !== m.v ? ' data-src-lo="' + lo + '"' : '')
      + ' poster="' + (m.p || '') + '"'
      + ' muted loop playsinline webkit-playsinline preload="none"'
      + ' x5-video-player-type="h5-page" x5-video-player-fullscreen="false" x5-playsinline="true"'
      + ' disablepictureinpicture disableremoteplayback></video>';
  }

  /* REEL-FOL-DYNAMIC-20261029（侯哥 02:26「为什么搜索进来这个看货器没有关注按钮」）
     根因：`.reel__fol` 只存在于 Liquid 静态渲染的那批卡；凡 seedReelFeed 现拼的卡
     （搜索页进入 / 合集切换 / 续拉）模板里没有这个按钮 ⇒ innerHTML 一换就全没了。
     修法：抓一份静态卡的按钮 outerHTML 当模板（连后台配的头像/字母一起），动态卡复用。
     静态卡没有该节点（follow_enabled 关）= 模板空串，行为与从前完全一致。 */
  var reelFolTplHTML = null;
  function reelFolTpl() {
    if (reelFolTplHTML !== null) return reelFolTplHTML;
    var n = document.querySelector('#reelsFeed .reel__fol');
    reelFolTplHTML = n ? n.outerHTML : '';
    return reelFolTplHTML;
  }

  function reelSlideHTML(p, i) {
    var v = (p.variants && p.variants[0]) || {};
    /* ⚠️ /collections/x/products.json 的 featured_image 是【对象】{src,width,height}，
       /products/x.js 的是【字符串】—— 两种都要吃。
       第一版直接当字符串用 ⇒ data-src="[object Object]" ⇒ 浏览器按相对路径解析成
       /collections/[object Object] 的 404 图片请求（线上实测抓到）。 */
    var _fi = p.featured_image;
    var src = (typeof _fi === 'string') ? _fi
      : (_fi && _fi.src) ? _fi.src
        : (p.images && p.images[0]) ? ((typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || ''))
          : '';
    var avail = (typeof p.available === 'boolean') ? p.available : (v.available !== false);
  /* 2026-10-24：公开 JSON 不返回 inventory_quantity，现拼的卡拿不到库存 ⇒ 先吃静态 Liquid 渲染时
     留在 data-inv 上的真值（同一批商品都在静态 feed 里），拿不到才退回 In stock。 */
  var _inv = (reelInv && reelInv[p.handle] != null) ? reelInv[p.handle] : (v.inventory_quantity > 0 ? v.inventory_quantity : 0);
    /* 🔴 REEL-PRICE-20261023（2026-10-23 07:5x 顺手挖到的既有 bug）：
       /products/x.js 的 variants[].price 是【数字·分】(990)；
       /collections/x/products.json 的 variants[].price 是【字符串·美元】("9.90")。
       原来只吃 number ⇒ 凡是由 seedReelFeed 动态喂进看货器的卡，价格全渲染成 $0.00
       （从购物车推荐点进去就能看到）。这里两种都要吃。 */
    var price;
    if (typeof v.price === 'number') price = v.price;
    else {
      var _pf = parseFloat(v.price);
      price = isFinite(_pf) ? Math.round(_pf * 100) : 0;
    }
    var addLabel = avail ? 'Add to cart' : 'Sold out';
    /* REELS-FULLVIDEO-20261026：动态拼的卡也要能全屏播视频。
       比例取 REEL_VIDEOS 里的真实宽高，写进 --vr，与 Liquid 静态卡同一套样式。 */
    var _rvinfo = (typeof REEL_VIDEOS !== 'undefined' && REEL_VIDEOS) ? REEL_VIDEOS[p.handle] : null;
    var _vratio = (_rvinfo && _rvinfo.w && _rvinfo.h) ? (_rvinfo.w / _rvinfo.h) : 0;
    /* REEL-FRAME-ALL-20261028：动态拼出来的卡也统一画框（原来没视频就只有 1:1 方框） */
    return '<section class="reel is-vid' + (_rvinfo ? '' : ' is-novid') + '" data-i="' + i + '" data-handle="' + escHTML(p.handle) + '"'
      + ' data-variant-id="' + (v.id || '') + '" data-price="' + price + '" data-name="' + escHTML(p.title) + '"'
      + ' data-pub="' + (p.pub || 0) + '">'
      
      + '<div class="reel__media">'
      /* REEL-MEDIA-20261101：底色图与卡片图同 URL ⇒ 复用同一份缓存，不再多下一次 */
      + '<img class="reel__bg" data-src="' + cdnSize(src, '600x600') + '" alt="" aria-hidden="true" width="600" height="600" decoding="async">'
      + '<div class="reel__card"' + (_vratio ? ' style="--vr:' + _vratio.toFixed(4) + '"' : '') + '><img data-src="' + cdnSize(src, '600x600') + '" alt="' + escHTML(p.title) + '" width="600" height="600" decoding="async">'
      + reelVideoTag(p.handle) + '</div>'
      + reelTabsHTML(p.handle, src)
      + '</div><div class="reel__scrim"></div>'
      + '<button class="reel__tap" aria-label="Play or pause"></button>'
      /* REEL-MUTE-CARD-20261103：动态 seed 出来的卡**原本没有静音键**（只有服务端直出的那份有），
         侯哥 13:16 要求把静音键挪到卡片右上角 —— 这些卡连按钮都没有，改了等于看不见。
         这里按 snippets/icon.liquid 的 muted 同一份 SVG（viewBox 15 / stroke 1.3 / 16px）补上。
         判断用 _rvinfo.v（真有视频地址），不是只看表里有没有条目。 */
      + ((_rvinfo && _rvinfo.v) ? '<button class="reel__mute" data-mute-reel aria-label="Toggle sound"><svg width="16" height="16" viewBox="0 0 15 15" fill="none" aria-hidden="true"><path d="M2.5 5.6h2.2L7.6 3v9L4.7 9.4H2.5V5.6z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M10 5.8l2.8 2.8M12.8 5.8L10 8.6" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg></button>' : '')
      + '<div class="reel__ui"><div>'
      + '<div class="reel__series">' + escHTML(p.type || p.product_type || '') + '</div>'
      + '<div class="reel__name">' + escHTML(p.title) + '</div>'
      + '<div class="reel__prow"><span class="reel__price tnum">' + money(price) + '</span>'
      /* 2026-10-24：价格旁要显示**真实库存数量**。公开 JSON 一般不返回 inventory_quantity，
         所以这里是有就用、没有才退回 In stock —— 现在静态已渲染整个合集，绝大多数屏走 Liquid 分支。 */
      + (avail ? '<span class="reel__stock"' + ((_inv > 0) ? (' data-bbs-key="' + escHTML(p.handle) + '" data-bbs-qty="' + _inv + '"') : '') + '>'
                 + ((_inv > 0) ? (window.BBStock ? BBStock.text(p.handle, _inv, true) : (_inv + ' in stock')) : 'In stock') + '</span>'
               : '<span class="reel__stock">Sold out</span>')
      + '</div></div>'
      + '<div class="reel__row"><button class="reel__add" type="button" data-reel-add' + (avail ? '' : ' disabled') + '>' + addLabel + '</button></div>'
      + '<button type="button" class="reel__go" data-reel-checkout data-reel-opencart>'
      + '<span class="reel__go-sum"><b data-reel-count>0 items</b><span class="reel__go-dot">\u00b7</span>'
      + '<i data-reel-total>$0.00</i><span class="reel__go-ship" data-reel-ship></span></span>'
      + '<span class="reel__go-ck"><span class="reel__go-ck-t">View cart</span></span></button>'
      + '</div>' + reelFolTpl() + '</section>';
  }

  function findReelSlide(handle) {
    var slides = $$('.reel', feedEl());
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-handle') === handle) return i;
    }
    return -1;
  }

  var reelInv = null;
  function buildReelInv() {
    var m = {};
    /* ① 先读服务端输出的全店映射（BB_INV_MAP-20261024）—— 从别的合集/搜索/推荐点进来也查得到 */
    var tag = document.getElementById('bbInvMap');
    if (tag) {
      try {
        var j = JSON.parse(tag.textContent || '{}');
        for (var k in j) if (j.hasOwnProperty(k)) m[k] = j[k];
      } catch (e) {}
    }
    /* ② 再用静态 slide 上的 data-inv 覆盖（同一个真值，但保证不依赖 JSON 块） */
    $$('.reel[data-handle]', feedEl()).forEach(function (el) {
      var q = el.getAttribute('data-inv');
      if (q !== null && q !== '') m[el.getAttribute('data-handle')] = parseInt(q, 10);
    });
    reelInv = m;
    return m;
  }

  /* ================= 2026-10-24 12:4x REELS-FEED-20261024 =================
     侯哥 12:30 截图：「点主图进去只能上下刷四张就刷不动了，上面 3/50 这个显示也有问题，
     这个标签里面有五百多张图，这五十是哪里来」
     实测（tools/_diag_reels_seed_20261024.js）：
       · 点的是 Eevee（handle eevee-y155），它属于 char-eevee 合集（共 24 个商品），
         但在合集里排第 23 位 ⇒ 老的 slice(idx-2, idx-2+40) 只剩 **4 张** ⇒ 刷 4 张到底。
       · 分母 50 = Liquid `items.size`（collections 单次迭代硬上限），跟 feed 真实张数无关。
     修法：① build 尾部 clamp（够长就补满 40）；② 分母读真实 slide 数；
           ③ 滚到倒数第 4 张自动续拉下一页（每批只插 40 张，避免一次 250 屏把主线程打死）。
     ====================================================================== */
  /* src: 'collection' | 'search'
     search = 搜索页点进来的上下文，数据源是 templates/search.bbjson.liquid（537 个结果全都能刷） */
  var reelFeedState = { src: '', key: '', page: 1, pages: 0, total: 0, loading: false, done: false, queue: [], seen: {} };
  window.__reelFeed = reelFeedState;   /* 排查用：控制台 __reelFeed 直接看数据源/页数/总数 */

  /* 当前是不是从搜索页进来的（看货器要沿用这 537 个结果，而不是商品的所属合集那 24 个） */
  function reelsSearchQuery() {
    if (location.pathname !== '/search') return '';
    try {
      var q = new URLSearchParams(location.search).get('q');
      return q ? q.trim() : '';
    } catch (e) { return ''; }
  }

  /* 搜索 JSON 的一项 → 与 /collections/x/products.json 同构，直接喂 reelSlideHTML */
  /* 合集上下文统一走 templates/collection.bbjson.liquid：
     它比 /collections/x/products.json 多的就是 **all_products_count（真实总数）**，
     而 products.json 永远不返回总数 ⇒ 分母只能瞎猜（侯哥看到的 10/40 就是这么来的）。 */
  function fetchCollectionJSON(pcol, page) {
    return fetch('/collections/' + encodeURIComponent(pcol || 'all') + '?view=bbjson&page=' + page)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(0); });
  }

  function mapSearchProduct(j) {
    return {
      /* REEL-SOCIAL-AGING-20261029：必须带上上架时间，社交数字全靠它算年龄 */
      pub: (typeof j.pub === 'number' && j.pub) ? j.pub
        : (j.published_at ? Math.floor(Date.parse(j.published_at) / 1000) || 0 : 0),
      handle: j.handle, title: j.title, type: j.type || j.product_type,
      featured_image: j.image,
      available: !!j.available,
      variants: [{ id: j.variant_id, price: String(j.price), available: !!j.available, inventory_quantity: j.inv }]
    };
  }

  function reelSeenMark(handle) { if (handle) reelFeedState.seen[handle] = 1; }

  function seedReelFeed(pcol, handle, done) {
    buildReelInv();   // ⚠️ 必须在 innerHTML 被替换之前抓，否则静态卡上的 data-inv 就没了
    /* ⭐ 搜索页进入：直接吃搜索结果（侯哥 12:30：这个标签里有五百多张图，不能只给 24 张） */
    var _q = reelsSearchQuery();
    if (_q && handle) { seedReelFromSearch(_q, handle, done); return; }
    seedReelFromCollection(pcol, handle, done);
  }

  /* 续拉：把队列里剩下的按 40 张一批插到 feed 末尾 */
  /* ==========================================================================
     REEL-DEDUPE-20261031（侯哥 2026-10-31 06:5x：「上下滑动出现两个这个商品」）
     --------------------------------------------------------------------------
     实测：数据源是干净的（/collections/all 500 张 handle 全唯一、主图零复用），
     但喂卡路径有四条 —— Liquid 静态 50 张 / seedReelFromCollection / seedReelFromSearch /
     drainReelQueue 续拉，**去重只有续拉那一条做了**（reelFeedState.seen）。
     任何一条把同一 handle 塞第二遍，买家就会看到两张一模一样的卡，计数器也跟着乱。
     这里补最后一道硬闸：保留第一次出现的那张，同 handle 的后续节点整块删掉，再重排 data-i。
     ⚠️ 删节点会让后续下标平移，所以必须重排 data-i（openReels / updateCounter 都靠它）。
     ========================================================================== */
  function reelDedupeDOM() {
    var feed = feedEl(); if (!feed) return 0;
    var seen = {}, kill = [];
    $$('.reel', feed).forEach(function (el) {
      var h = el.getAttribute('data-handle');
      if (!h) return;
      if (seen[h]) { kill.push(el); return; }
      seen[h] = 1;
    });
    if (!kill.length) return 0;
    kill.forEach(function (el) { el.parentNode && el.parentNode.removeChild(el); });
    $$('.reel', feed).forEach(function (el, i) { el.setAttribute('data-i', i); });
    return kill.length;
  }

  function drainReelQueue() {
    var feed = feedEl(); if (!feed) return false;
    var batch = reelFeedState.queue.splice(0, 40);
    if (!batch.length) return false;
    var startI = $$('.reel', feed).length;
    try {
      feed.insertAdjacentHTML('beforeend', batch.map(function (p, i) { return reelSlideHTML(p, startI + i); }).join(''));
      reelDedupeDOM();
      layoutReels();
      updateCounter();
    } catch (e) {
      /* 插不进去就别静默吞掉（第一版就是这里抛错被 Promise.catch 吞成「到底了」） */
      console.warn('[reels] drain failed:', e && e.message);
      return false;
    }
    return true;
  }

  /* 合集上下文的首屏：page=1 起逐页找 handle（最多 3 页），总数取 all_products_count */
  function seedReelFromCollection(pcol, handle, done) {
    var tried = 0;
    function step(page) {
      tried++;
      fetchCollectionJSON(pcol, page)
        .then(function (d) {
          var list = (d.products || []).map(mapSearchProduct);
          var has = !handle || list.some(function (x) { return x.handle === handle; });
          if (!has && page < (d.pages || 1) && tried < 3) { step(page + 1); return; }
          if (!list.length) { done(false); return; }
          function render(arr) {
            feedEl().innerHTML = arr.map(function (p, i) { return reelSlideHTML(p, i); }).join('');
            reelDedupeDOM();
            reelsIdx = 0;
            reelFeedState.src = 'collection';
            reelFeedState.key = pcol || 'all';
            reelFeedState.page = page;
            reelFeedState.pages = d.pages || 1;
            reelFeedState.total = d.total || arr.length;   /* 真实总数 */
            reelFeedState.done = page >= (d.pages || 1);
            reelFeedState.queue = [];
            reelFeedState.seen = {};
            arr.forEach(function (p) { reelSeenMark(p.handle); });
            done(true);
          }
          if (has) { render(list); return; }
          /* 🔴 3 页内都没找到这张卡：绝不能「点 A 看 B」——
             把点开的商品单独拉到最前面，后面照旧接列表。 */
          fetch('/products/' + encodeURIComponent(handle) + '.js')
            .then(function (r) { return r.ok ? r.json() : Promise.reject(0); })
            .then(function (one) {
              var mapped = { pub: one.published_at ? Math.floor(Date.parse(one.published_at) / 1000) || 0 : 0,
                handle: one.handle, title: one.title, type: one.type || one.product_type,
                featured_image: one.featured_image, available: one.available,
                variants: [{ id: (one.variants && one.variants[0] || {}).id,
                             price: (one.variants && one.variants[0] || {}).price,
                             available: one.available,
                             inventory_quantity: (one.variants && one.variants[0] || {}).inventory_quantity }] };
              render([mapped].concat(list.filter(function (x) { return x.handle !== handle; })));
            })
            .catch(function () { render(list); });
        })
        .catch(function () { done(false); });
    }
    step(1);
  }

  /* 搜索上下文的首屏：拉 page=1 起，逐页找点开的那个 handle（最多 3 页，别让买家等） */
  function seedReelFromSearch(q, handle, done) {
    var base = '/search?q=' + encodeURIComponent(q) + '&type=product&view=bbjson&page=';
    var tried = 0;
    function step(page) {
      tried++;
      fetch(base + page)
        .then(function (r) { return r.ok ? r.json() : Promise.reject(0); })
        .then(function (d) {
          var list = (d.products || []).map(mapSearchProduct);
          var has = list.some(function (x) { return x.handle === handle; });
          if (!has && page < (d.pages || 1) && tried < 3) { step(page + 1); return; }
          if (!list.length) { done(false); return; }
          feedEl().innerHTML = list.map(function (p, i) { return reelSlideHTML(p, i); }).join('');
          reelDedupeDOM();
          reelsIdx = 0;
          reelFeedState.src = 'search';
          reelFeedState.key = q;
          reelFeedState.page = page;
          reelFeedState.pages = d.pages || 1;
          reelFeedState.total = d.total || 0;
          reelFeedState.done = page >= (d.pages || 1);
          reelFeedState.queue = [];
          reelFeedState.seen = {};
          list.forEach(function (p) { reelSeenMark(p.handle); });
          done(true);
        })
        .catch(function () { done(false); });
    }
    step(1);
  }

  function appendReelPage() {
    reelDedupeDOM();   // 每次续拉前先清一遍重复（滚到底才走到这里，成本可忽略）
    if (reelFeedState.loading) return;
    if (drainReelQueue()) return;                 // 队列还有货，先插
    if (reelFeedState.done) return;
    if (!reelFeedState.key) return;
    reelFeedState.loading = true;
    var next = reelFeedState.page + 1;
    var isSearch = reelFeedState.src === 'search';
    var url = isSearch
      ? '/search?q=' + encodeURIComponent(reelFeedState.key) + '&type=product&view=bbjson&page=' + next
      : '/collections/' + encodeURIComponent(reelFeedState.key) + '?view=bbjson&page=' + next;
    fetch(url)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(0); })
      .then(function (d) {
        var raw = d.products || [];
        /* REEL-DEDUPE-20261031：原来 collection 分支不 map ⇒ bbjson 的 image/variant_id/price(字符串)
           进不了 reelSlideHTML（它只认 featured_image/variants）⇒ 续拉的卡没主图、价格 $0.00。
           而「新卡」（Y14xx/Y149x）按字母序在最后几页，只能靠续拉看到 —— 就是这条。 */
        var list = raw.map(mapSearchProduct);
        reelFeedState.loading = false;
        if (!list.length) { reelFeedState.done = true; return; }
        reelFeedState.page = next;
        if (next >= (d.pages || 1)) reelFeedState.done = true;
        if (!isSearch && d.total) reelFeedState.total = d.total;   /* 合集总数（真实） */
        var fresh = list.filter(function (p) { return p && p.handle && !reelFeedState.seen[p.handle]; });
        fresh.forEach(function (p) { reelSeenMark(p.handle); });
        reelFeedState.queue = reelFeedState.queue.concat(fresh);
        drainReelQueue();
      })
      .catch(function (e) {
        console.warn('[reels] append page failed:', e && (e.message || e));
        reelFeedState.loading = false;
        reelFeedState.done = true;
      });
  }

  /* ============================================================================
     REELS-TAP-GUARD-20261026（侯哥 20:0x：从搜索点商品，第一下会穿到详情页，等一下再点才是看货器）
     ----------------------------------------------------------------------------
     根因：brand.js 是 defer，首屏还在下载/解析时，<a data-reels-open> 的点击没人拦
          ⇒ 浏览器按 href 原生跳到 /products/xxx。等脚本就绪后再点才进看货器。
     两层修：
       ① theme.liquid <head> 里一段内联抢占脚本（不等任何外部文件）：就绪前拦下点击，
          把目标记进 window.__bbPendingReel，并把卡片压一下给即时反馈。
       ② 这里做 busy 排队：seed 还在跑的时候再点别的卡，不再 return 丢掉，而是记下来等前一个完事。
     ============================================================================ */
  var pendingReelHandle = null, pendingReelHref = null;

  function openReelsForHandle(handle, href) {
    if (!handle) return;

    /* 🔴 REELS-COUNT-SYNC-20261026（侯哥 20:2x：搜索进来显示 `7 / 1`）
       根因：分子是**静态 feed（全集前 50）里的下标**，分母被改成**搜索命中数**，
             两套集合不是一回事 ⇒ `7 / 1` 这种鬼数字。
       修法：搜索上下文下，先把 feed 重建成「搜索结果」这一套，再定位打开。
            这样分子分母同一集合：搜出 1 张就是 1 / 1，搜出 152 张就是 x / 152。
            ⚠️ 只在 `reelFeedState.src !== 'search'` 时重建，避免每次翻都重拉。
       ⚠️ feed 重建完要重新算 findReelSlide —— 旧 DOM 已经没了。 */
    var _q = reelsSearchQuery();
    if (_q && reelFeedState.src !== 'search') {
      if (reelsSeedBusy) { pendingReelHandle = handle; pendingReelHref = href || null; return; }
      reelsSeedBusy = true;
      seedReelFeed('', handle, function (ok) {
        reelsSeedBusy = false;
        if (ok) openReels(handle);
        else if (href) location.href = href;
        var pq = pendingReelHandle; pendingReelHandle = null;
        if (pq) openReelsForHandle(pq, pendingReelHref);
      });
      return;
    }

    if (findReelSlide(handle) >= 0) { openReels(handle); return; }
    /* 上一张还在 seed ⇒ 记下来排队，别丢（原来直接 return，用户点了没反应） */
    if (reelsSeedBusy) { pendingReelHandle = handle; pendingReelHref = href || null; return; }
    reelsSeedBusy = true;
    var host = document.querySelector('[data-reels-open="' + handle + '"]');
    var hostBox = host && host.closest('[data-pcol]');
    var pcol = hostBox ? (hostBox.getAttribute('data-pcol') || '') : '';
    seedReelFeed(pcol, handle, function (ok) {
      reelsSeedBusy = false;
      // 喂不进 feed 就别开一个「内容不对」的看货器，老老实实跳商品页
      if (ok) openReels(handle);
      else if (href) location.href = href;
      var q = pendingReelHandle; pendingReelHandle = null;
      if (q) openReelsForHandle(q, pendingReelHref);
    });
  }

  function openReels(handle) {
    var box = reelsEl(); if (!box) return;
    reelFolTpl();   /* 预热：此刻静态卡还在 DOM 里，先抓一份当模板 */
    lastFocus = document.activeElement;
    box.classList.add('on');
    box.setAttribute('aria-hidden', 'false');
    document.body.classList.add('locked', 'reels-open');

    reelDedupeDOM();
    var slides = $$('.reel', feedEl());
    var start = 0;
    if (handle) {
      slides.forEach(function (el, i) {
        if (el.getAttribute('data-handle') === handle) start = i;
      });
    }
    feedEl().scrollTop = start * feedEl().clientHeight;
    reelsIdx = start;
    /* 静态 feed 的分页起点：pcol 从 section 根节点读（data-pcol），静态只渲染了前 50 张，
       滚到底可以继续往后拉。seedReelFeed 已经接管过的就别覆盖。 */
    if (!reelFeedState.src) {
      var _pc = box.getAttribute('data-pcol') || 'all';
      var _q2 = reelsSearchQuery();
      /* 静态 feed 直接打开时也认搜索上下文：后续续拉照样按搜索词走 */
      reelFeedState.src = _q2 ? 'search' : 'collection';
      reelFeedState.key = _q2 || _pc;
      /* 🔴 REELS-SCOPE-20261025 第二个 bug（实测皮卡丘只翻到 70/94）：
         静态 feed 只渲染了 24 条，而 bbjson 每页 48 条 —— 从 page=1 起步续拉，
         等于把"静态 24 条"当成整页，page 1 剩下那 24 条永远不会被拉 ⇒ 总数永远差一页。
         改成 page=0 起步（下一次拉 page=1），重复的靠 reelSeenMark 去重，不会出现两张一样的卡。 */
      reelFeedState.page = 0;
      reelFeedState.pages = 0;
      /* 🔴 REELS-COUNT-FIX-20261026（侯哥 20:0x：搜索进去计数一直是 7/50）：
         原来搜索上下文硬写 0，updateCounter 只能退化成「已渲染张数」（静态最大 50）
         ⇒ 分母永远 50。现在 data-ptotal 由 Liquid 按上下文给真数：
         搜索页 = search.results_count，合集页 = all_products_count。直接吃即可。 */
      reelFeedState.total = parseInt(box.getAttribute('data-ptotal'), 10) || 0;
      reelFeedState.done = false;
      $$('.reel', feedEl()).forEach(function (el) { reelSeenMark(el.getAttribute('data-handle')); });
    }
    mountReelInfo();
    watchReelInfo();
    /* FLASH-FIX2-20261029（侯哥 00:51「详情页还是会闪一下」）：
       面板是**第一次点击时才 createElement 并插入**的，插入那一帧样式还没生效，
       里面的 .ri__ph-img img 会按原始 600² 画一下 = 整屏闪一张主图。
       提前建好（此时 aria-hidden + 未 .on，完全不可见），首次打开就没有这一帧了。 */
    try { reelInfoBuild(); } catch (e) {}
    hydrateAround(start);
    playReelAt(start);
    updateCounter();
    paintCart();
    pushPanel('reels');
    layoutReels();
  }

  function closeReels(fromPop) {
    var box = reelsEl(); if (!box) return;
    box.classList.remove('on');
    box.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('locked', 'reels-open');
    $$('video', feedEl()).forEach(function (v) { v.pause(); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    if (!fromPop) backIfTop('reels');
  }


  /* ==========================================================================
     REEL-INFO-20261028（侯哥 2026-10-28 12:2x：「在这个位置加一个叫产品介绍的大卡，
     点开不要跳转，是关于产品的详细的情况介绍等具体信息」）
     · 有视频的卡：入口＝缩略图行第三个子项（横条），与两个 62px 缩略图齐平
     · 没视频的卡：入口＝信息块右上角 Info 小胶囊，绝对定位、零高度影响
     · 点开＝站内面板，不跳 PDP（2026-10-22 定的「详情页不作为浏览路径」不变）
     · 数据只吃 slide 上已有的 data-* ＋ 站点设置；加购直接复用本卡 [data-reel-add]
     · 入口由 mountReelInfo 统一注入 ⇒ Liquid 静态卡与 seedReelFeed 现拼的动态卡走同一实现
     ========================================================================== */
  var REEL_INFO_IC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7.6v.9"/></svg>';
  var REEL_INFO_CHEV = '<svg class="reel__info-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
  var REEL_INFO_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 7h11v9H2z"/><path d="M13 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>';
  var reelInfoEl = null, reelInfoSlide = null, reelInfoObs = null;

  function reelInfoBuild() {
    if (reelInfoEl) return reelInfoEl;
    var box = reelsEl(); if (!box) return null;
    var d = document.createElement('div');
    d.className = 'ri';
    d.id = 'reelInfo';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML =
      '<div class="ri__scrim"></div>'
      + '<section class="ri__sheet" role="dialog" aria-modal="true" aria-label="Product info">'
      + '<div class="ri__grab"></div>'
      + '<div class="ri__hd"><h3></h3>'
      + '<button class="ri__x" type="button" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>'
      + '<div class="ri__body">'
      + '<div class="ri__ph"><span class="ri__ph-img"><img alt=""></span>'
      + '<span class="ri__ph-t"><b></b><small></small></span></div>'
      + '<div class="ri__blk"><h4>About this card</h4><p class="ri__about"></p></div>'
      + '<div class="ri__blk"><h4>Specs</h4><dl class="ri__specs"></dl></div>'
      + '<div class="ri__blk"><h4>Shipping</h4><div class="ri__ship"></div></div>'
      + '<p class="ri__fine"></p>'
      + '</div>'
      + '<div class="ri__ft"><button class="ri__add" type="button"></button></div>'
      + '</section>';
    box.appendChild(d);
    reelInfoEl = d;
    d.querySelector('.ri__scrim').addEventListener('click', function () { reelInfoClose(); });
    d.querySelector('.ri__x').addEventListener('click', function () { reelInfoClose(); });
    d.querySelector('.ri__add').addEventListener('click', function () {
      var s = reelInfoSlide;
      reelInfoClose();
      if (!s) return;
      var b = s.querySelector('[data-reel-add]');
      if (b && !b.disabled) b.click();
    });
    return d;
  }

  function reelInfoOpen(slide) {
    var d = reelInfoBuild(); if (!d || !slide) return;
    reelInfoSlide = slide;
    var box = reelsEl();
    /* REEL-INFO-EDITABLE-20261028：面板所有文案都从 #reels 的 data-info-* 读（后台 section 设置），
       商品级 metafield 覆盖从 #bbInfoMap 查。代码里不再留任何写死的文案。 */
    var cfg = {
      title: (box && box.getAttribute('data-info-title')) || 'Product info',
      sub: (box && box.getAttribute('data-info-sub')) || 'Specs \u00b7 Shipping',
      about: (box && box.getAttribute('data-info-about')) || '',
      specs: (box && box.getAttribute('data-info-specs')) || '',
      ship: (box && box.getAttribute('data-info-ship-lines')) || '',
      fine: (box && box.getAttribute('data-info-fine')) || '',
      btn: (box && box.getAttribute('data-info-btn')) || 'Add to cart',
      days: (box && box.getAttribute('data-info-days')) || '',
      threshold: (box && box.getAttribute('data-info-threshold')) || '',
      show: ((box && box.getAttribute('data-info-show')) || '1,1,1').split(',')
    };
    var name = slide.getAttribute('data-name') || '';
    var price = parseInt(slide.getAttribute('data-price'), 10) || 0;
    /* 实测 2026-10-28：全店 metafields.custom.card_number 都是空的（线上 data-cardno 全是 ""），
       而卡号确实印在标题里（... Friends Y1144）⇒ 先从标题取「字母+数字」那个词兜底。
       等后台把 card_number 补齐，这条会自动被 data-cardno 抢先生效，不用改代码。 */
    var cardno = slide.getAttribute('data-cardno') || '';
    if (!cardno) {
      var mcard = /(?:^|\s)([A-Z]{1,2}\d{3,5})(?:\s|$)/.exec(name);
      if (mcard) cardno = mcard[1];
    }
    var seriesEl = slide.querySelector('.reel__series');
    var seriesRaw = seriesEl ? String(seriesEl.textContent || '').replace(/\s+/g, ' ').trim() : '';
    /* 后台把系列存成 "11rd ed"（错别字，应为 11th）；显示层统一成 Series N，
       不在前台暴露错字，也不改后台数据。 */
    var mnum = /(\d+)/.exec(seriesRaw);
    var series = mnum ? ('Series ' + mnum[1]) : seriesRaw.replace(/\s*\u00b7.*$/, '').trim();
    var stockEl = slide.querySelector('.reel__stock');
    var stock = stockEl ? String(stockEl.textContent || '').trim() : '';
    var img = slide.querySelector('.reel__card img');
    var src = img ? (img.getAttribute('src') || img.getAttribute('data-src') || '') : '';
    var soldOut = !!slide.querySelector('[data-reel-add][disabled]');

    var im = d.querySelector('.ri__ph-img img');
    if (im) {
      if (src) {
        im.setAttribute('src', src);
        /* 给死尺寸：没有 width/height 时，图片解码完成的那一帧可能按原始尺寸（600²）画出来 */
        if (!im.getAttribute('width')) { im.setAttribute('width', '58'); im.setAttribute('height', '58'); }
        im.setAttribute('decoding', 'sync');
      } else im.removeAttribute('src');
      im.setAttribute('alt', name);
    }
    d.querySelector('.ri__ph-t b').textContent = name;
    var sub = [];
    if (cardno) sub.push('Card ' + cardno);
    sub.push(money(price));
    if (stock) sub.push(stock);
    d.querySelector('.ri__ph-t small').textContent = sub.join(' \u00b7 ');

    /* 商品级覆盖：metafield 有值就用它，否则吃全局 */
    var ov = null;
    var mt = document.getElementById('bbInfoMap');
    if (mt) {
      try {
        var jm = JSON.parse(mt.textContent || '{}');
        ov = jm[slide.getAttribute('data-handle')] || null;
      } catch (e) {}
    }
    var vars = {
      series: series || '',
      card: cardno || '',
      title: name,
      price: money(price),
      stock: stock || '',
      days: cfg.days,
      threshold: cfg.threshold
    };
    function fillTpl(t) {
      return String(t == null ? '' : t).replace(/\{(\w+)\}/g, function (m, k) {
        return (vars[k] != null && vars[k] !== '') ? vars[k] : m;
      });
    }

    var aboutTxt = fillTpl((ov && ov.a) ? ov.a : cfg.about).replace(/^[.\s\u00b7]+/, '').trim();
    d.querySelector('.ri__about').textContent = aboutTxt;

    var specs = [];
    if (cfg.show[0] === '1' && cardno) specs.push(['Card no.', cardno]);
    if (cfg.show[1] === '1' && series) specs.push(['Series', series]);
    var specLines = fillTpl((ov && ov.s) ? ov.s : cfg.specs).split('\n');
    for (var si = 0; si < specLines.length; si++) {
      var line = specLines[si].replace(/\s+$/, '').replace(/^\s+/, '');
      if (!line) continue;
      var ci = line.indexOf(':');
      if (ci > 0) specs.push([line.slice(0, ci).trim(), line.slice(ci + 1).trim()]);
      else specs.push(['', line]);
    }
    if (cfg.show[2] === '1' && stock) specs.push(['Availability', stock]);
    var dl = d.querySelector('.ri__specs');
    dl.innerHTML = '';
    for (var i = 0; i < specs.length; i++) {
      var row = document.createElement('div'); row.className = 'ri__spec';
      var dt = document.createElement('dt'); dt.textContent = specs[i][0];
      var dd = document.createElement('dd'); dd.textContent = specs[i][1];
      row.appendChild(dt); row.appendChild(dd); dl.appendChild(row);
    }

    var sw = d.querySelector('.ri__ship');
    sw.innerHTML = '';
    var shipLines = [];
    var _sl = fillTpl(cfg.ship).split('\n');
    for (var li = 0; li < _sl.length; li++) {
      var _l2 = _sl[li].replace(/^\s+|\s+$/g, '');
      if (_l2) shipLines.push(_l2);
    }
    for (var j = 0; j < shipLines.length; j++) {
      var sr = document.createElement('div'); sr.className = 'ri__ship-row';
      sr.innerHTML = REEL_INFO_TRUCK;
      var sp = document.createElement('span'); sp.textContent = shipLines[j];
      sr.appendChild(sp); sw.appendChild(sr);
    }

    var ab = d.querySelector('.ri__add');
    ab.textContent = soldOut ? 'Sold out' : (cfg.btn + ' \u00b7 ' + money(price));
    ab.disabled = soldOut;

    d.querySelector('.ri__hd h3').textContent = cfg.title;
    var _fineEl = d.querySelector('.ri__fine');
    if (_fineEl) {
      var _ft = fillTpl(cfg.fine).replace(/^\s+|\s+$/g, '');
      _fineEl.textContent = _ft;
      _fineEl.style.display = _ft ? '' : 'none';
    }

    var body = d.querySelector('.ri__body');
    if (body) body.scrollTop = 0;
    d.classList.add('on');
    d.setAttribute('aria-hidden', 'false');
  }

  function reelInfoClose() {
    if (!reelInfoEl) return;
    reelInfoEl.classList.remove('on');
    reelInfoEl.setAttribute('aria-hidden', 'true');
    reelInfoSlide = null;
  }

  function mountReelInfo(scope) {
    var slides = $$('.reel', scope || feedEl());
    for (var i = 0; i < slides.length; i++) {
      (function (s) {
        if (s.getAttribute('data-info') === '1') return;
        s.setAttribute('data-info', '1');
        var tabs = s.querySelector('.reel__tabs');
        if (!tabs) {
          /* REEL-FRAME-ALL-20261028：没视频的卡也要有这一行（侯哥要「全部按这个渲染效果」）。
             只放一张 PHOTO，图直接复用画框里那张现成的（data-src 还没 hydrate 也能取到），
             不额外请求新图 —— 同一张 600w 缩略图，浏览器直接吃缓存。 */
          tabs = document.createElement('div');
          tabs.className = 'reel__tabs';
          tabs.setAttribute('data-reel-tabs', '');
          var _img0 = s.querySelector('.reel__card img');
          var _src0 = _img0 ? (_img0.getAttribute('src') || _img0.getAttribute('data-src') || '') : '';
          tabs.innerHTML = '<button class="reel__tab on" type="button" data-reel-tab="photo">'
            + '<img src="' + escHTML(_src0) + '" alt="" width="124" height="124" loading="lazy">'
            + '<span>Photo</span></button>';
          s.appendChild(tabs);
          s.classList.add('is-photo');
          /* 画框上下留白处铺一层这张图自己的模糊版（同一 URL，直接吃缓存） */
          var _card0 = s.querySelector('.reel__card');
          if (_card0 && _src0) _card0.style.setProperty('--shot', 'url("' + _src0 + '")');
        }
        var _rb = reelsEl();
        var _tT = (_rb && _rb.getAttribute('data-info-title')) || 'Product info';
        var _tS = (_rb && _rb.getAttribute('data-info-sub')) || 'Specs \u00b7 Shipping';
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'reel__info';
        b.innerHTML = '<span class="reel__info-ic">' + REEL_INFO_IC + '</span>'
          + '<span class="reel__info-tx"><b>' + escHTML(_tT) + '</b><small>' + escHTML(_tS) + '</small></span>'
          + REEL_INFO_CHEV;
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation(); reelInfoOpen(s);
        });
        tabs.appendChild(b);
      })(slides[i]);
    }
  }

  /* seedReelFeed 续拉新卡、切换分类重建 feed 都要自动补入口 ⇒ 用 Observer 兜住，
     不依赖调用方记得再调一次 mountReelInfo。 */
  function watchReelInfo() {
    var feed = feedEl();
    if (!feed || reelInfoObs || typeof MutationObserver === 'undefined') return;
    reelInfoObs = new MutationObserver(function () { mountReelInfo(feed); });
    reelInfoObs.observe(feed, { childList: true });
  }

  /* 看货器图片按需加载（2026-10-22）
     浮层是 display:none，lazy 图片永远不会触发加载；普通 src 又会让首屏白下几百 KB。
     做法：data-src / data-srcset，打开和切页时对「当前 ±1」赋值。 */
  /* REEL-HIRES-20261101（侯哥 00:1x，底线原则）：卡片图必须给到屏幕真实像素。
     商品原图 1024×1024，卡片显示宽 ~350pt，dpr 3 的手机需要 ~1050 px ⇒
     原来固定 width=600 等于把图拉大 1.75 倍，是糊的。
     这里按 dpr 选真实宽度：≥2.5 → 1024｜≥1.5 → 800｜其余 600。
     ⚠️ 只改「取多大」，不改版式；降级链见 bbCandidates。 */
  function bbRetina(src) {
    try {
      var dpr = window.devicePixelRatio || 1;
      var w = dpr >= 2.5 ? 1024 : (dpr >= 1.5 ? 800 : 0);
      if (!w) return src;
      var out = src.replace(/_600x600/g, '_' + w + 'x' + w)
                   .replace(/([?&])width=600(?![0-9])/g, '$1width=' + w);
      return out;
    } catch (e) { return src; }
  }
  /* 候选链：高清 → 600（原标记值）→ 300。
     弱网/被掐断时顺着往下走，依次降档，不比原来差。 */
  function bbCandidates(src) {
    var list = [], hi = bbRetina(src);
    if (hi !== src) list.push(hi);
    list.push(src);
    var lo = src.replace(/([?&])width=\d+/, '$1width=300');
    if (lo === src) lo = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=300';
    if (lo !== src && list.indexOf(lo) < 0) list.push(lo);
    return list;
  }
  function hydrateReel(el) {
    if (!el) return;
    var imgs = el.querySelectorAll('img[data-src], img[data-srcset]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('src')) continue;
      var ss = img.getAttribute('data-srcset');
      var src = img.getAttribute('data-src');
      if (ss) img.setAttribute('srcset', ss);
      if (src) bbImgLoad(img, bbCandidates(src), 0, 0);
    }
  }
  /* REEL-IMG-RETRY-20261101：一次失败就永久白板的修法。
     每一档失败先重试 2 次（0.6s / 1.2s 退避，带 _r 破缓存），再降下一档；
     全档都用尽才 is-err（保持半透明，不弹破图图标）。 */
  function bbImgLoad(img, list, i, n) {
    var src = list[i];
    img.onload = function () {
      img.classList.remove('is-err');
      img.classList.add('is-loaded');
    };
    img.onerror = function () {
      if (n < 2) {
        var t = n + 1;
        setTimeout(function () { bbImgLoad(img, list, i, t); }, 600 * t);
        return;
      }
      if (i + 1 < list.length) { bbImgLoad(img, list, i + 1, 0); return; }
      img.classList.add('is-err');
    };
    img.setAttribute('src', n ? src + (src.indexOf('?') >= 0 ? '&' : '?') + '_r=' + n : src);
  }

  /* 旋屏 / 地址栏收了 / 字体重新排版都要重算 */
  window.addEventListener('resize', function () { setTimeout(syncVidFrames, 120); });
  window.addEventListener('orientationchange', function () { setTimeout(syncVidFrames, 260); });

  function hydrateAround(i) {
    var slides = $$('.reel', feedEl());
    [i - 1, i, i + 1].forEach(function (k) { if (slides[k]) hydrateReel(slides[k]); });
  }

  /* REELS-FULLVIDEO-20261026：有视频的卡要「铺满顶栏→信息块之间的画框」。
     画框高度必须减掉信息块真实高度 —— 各机型差很多（实测 140~236），写死必错位，
     所以每切一屏量一次写进 --uiH；同时按视频比例判断该 cover 还是 contain。 */
  function syncVidFrame(el) {
    if (!el || !el.classList.contains('is-vid')) return;
    var ui = el.querySelector('.reel__ui');
    var box = el.querySelector('.reel__card');
    var v = el.querySelector('video');
    if (!ui || !box) return;

    if (v && !v.dataset.fitHooked) {
      v.dataset.fitHooked = '1';
      v.addEventListener('loadedmetadata', function () { syncVidFrame(el); }, { once: true });
    }

    /* 卡片宽（已左右各留 20px，REELS-PDP-RADIUS-20261026 由 14 加到 20），不是整屏宽 */
    var W = Math.round(box.getBoundingClientRect().width) || (window.innerWidth - 40);
    var ratio = (v && v.videoWidth && v.videoHeight)
      ? (v.videoWidth / v.videoHeight)
      : (parseFloat(getComputedStyle(el).getPropertyValue('--vr')) || 0.75);
    var TOP = 88;
    var innerH = window.innerHeight;

    el.style.setProperty('--uiH', 'auto');
    var hUI = Math.round(ui.getBoundingClientRect().height) || 224;
    var padB = Math.max(224, hUI);            /* 信息块保底 224，放得下缩略图+标题+加购 */

    /* 🔴 REELS-FRAME-FIXED-20261026（侯哥 21:0x）
       「加购一下会直接上顶压缩到视频画面」—— 原来画面高度 = innerH - TOP - padB，
       而 padB 是**现量**的信息块高度：加购后信息块多一行免邮进度条 ⇒ padB 变大 ⇒ 画面被压。
       现在画面高度**只由视频比例决定**（W / ratio），给信息块预留一个**固定**的 RESERVE。
       加购、进度条出现、文案变化，全部只压缩信息块，画面尺寸一像素不动。
       ⚠️ 不要把 RESERVE 改成现量的 padB —— 那就退回老 bug 了。 */
    var RESERVE = 268;                        /* 信息块固定预留（实测 266 够，留 2px 余量） */
    var natH = Math.round(W / ratio);         /* 画面自然高：视频比例算出，不掺任何其它东西 */
    var capH = Math.round(innerH - TOP - RESERVE);
    var cardH = Math.max(240, Math.min(natH, capH));

    el.style.setProperty('--fitW', W + 'px');
    el.style.setProperty('--cardH', cardH + 'px');           /* CSS 圆角卡片/缩略图都吃这个 */
    el.style.setProperty('--fitH', cardH + 'px');            /* 兼容旧引用 */
    el.style.setProperty('--uiH', Math.max(padB, innerH - TOP - cardH) + 'px');
    el.dataset.fitPad = String(padB);

    if (v && v.videoWidth && box.clientWidth) {
      var need = box.clientWidth / ratio;
      /* 门槛 0.80 → 0.62：0.80 太松，卡片被压扁 20% 就退回 contain（上下白边）。
         现在卡片高度本身已经取 min(可用高, 视频自然高)，正常情况下永远不会触发；
         只有 9:16 这种超长视频 + 矮屏才会真的需要 contain。 */
      el.classList.toggle('fit-contain', box.clientHeight < need * 0.62);
    }
  }
  /* REELS-DIAG-20261026：地址栏加 ?diag=1 时，在屏幕顶部打一行真实读数。
     目的：不再靠猜 —— 客户/侯哥截一张图，就能看到他的视口、卡片真实尺寸、圆角、
     以及当前加载的 brand.js 版本号，一眼定位是缓存旧版还是布局算错。 */
  function reelDiag() {
    if (!/[?&]diag=1/.test(location.search)) return;
    var s = document.querySelector('.reel.is-vid');
    var box = s && s.querySelector('.reel__card');
    var cs = box && getComputedStyle(box);
    var scr = document.querySelector('script[src*="brand.js"]');
    var ver = scr ? (scr.src.match(/[?&]v=([a-z0-9]+)/) || [,'?'])[1] : '?';
    var r = box ? box.getBoundingClientRect() : { width: 0, height: 0, left: 0, top: 0 };
    var txt = 'VW ' + innerWidth + '×' + innerHeight + ' dpr' + (window.devicePixelRatio || 1).toFixed(2)
      + ' | CARD ' + Math.round(r.width) + '×' + Math.round(r.height)
      + ' (' + (r.height ? (r.width / r.height).toFixed(3) : '-') + ')'
      + ' left' + Math.round(r.left) + ' top' + Math.round(r.top)
      + ' | r' + (cs ? cs.borderRadius : '?')
      + ' | vr' + (cs ? cs.getPropertyValue('--vr').trim() : '?')
      + ' | js' + ver
      + ' | ' + (document.documentElement.getAttribute('data-bbguard') || 'no-guard')
      + (document.getElementById('bbReelsCardFix') ? ' | 样式已自愈注入' : '');
    var d = document.createElement('div');
    d.setAttribute('data-reel-diag', '1');
    d.style.cssText = 'position:fixed;left:0;right:0;top:0;z-index:99999;background:#111;color:#0f0;'
      + 'font:11px/1.5 ui-monospace,monospace;padding:6px 8px;white-space:pre-wrap;word-break:break-all';
    d.textContent = txt;
    document.body.appendChild(d);
  }

  function syncVidFrames() {
    var feed = feedEl();
    if (!feed) return;
    $$('.reel.is-vid', feed).forEach(syncVidFrame);
  }

  /* REEL-MEDIA-20261101：视频也只给「当前 ±1」放开预加载。
     满屏 preload=metadata 时，DOM 里每个视频都会发一次请求（mp4 的 moov 好几百 KB），
     翻到第 50 张就等于几十个视频在抢同一条带宽。 */
  function videoWindow(i) {
    var slides = $$('.reel', feedEl());
    for (var k = 0; k < slides.length; k++) {
      var v = slides[k].querySelector('video');
      if (!v) continue;
      var want = k === i ? 'auto' : (Math.abs(k - i) === 1 ? 'metadata' : 'none');
      if (v.getAttribute('preload') !== want) v.setAttribute('preload', want);
    }
  }

  function playReelAt(i) {
    hydrateAround(i);
    videoWindow(i);
    var slides = $$('.reel', feedEl());
    syncVidFrame(slides[i]);
    try { setTimeout(reelDiag, 300); } catch (e) {}
    slides.forEach(function (el, k) {
      var v = el.querySelector('video');
      if (!v) return;
      if (k === i) {
        v.muted = reelsMuted;
        /* 重新进入这一屏时回到 VIDEO（客户滑走了再回来，默认还是看视频） */
        if (el.classList.contains('is-photo')) {
          el.classList.remove('is-photo');
          var _tb = el.querySelector('[data-reel-tab="video"]');
          var _ts = el.querySelectorAll('[data-reel-tab]');
          for (var _j = 0; _j < _ts.length; _j++) _ts[_j].classList.toggle('on', _ts[_j] === _tb);
        }
        v.classList.add('on');
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        /* REEL-VIDEO-BITRATE-20261026：弱网兜底降码率。
           720p 在只有几十 KB/s 的移动网络下喂不饱 ⇒ play() 之后 readyState 长期 0，
           画面永远停在 poster 上，用户看到的就是「视频定格」。
           这里盯 3 秒：还没拿到任何画面数据（readyState < 2）就换 data-src-lo（480p）重试一次。
           只降一次（data-loDone 打标），且只在有兜底源时生效。 */
        /* 🟢 QUALITY-LADDER-20261027（侯哥 17:5x：「720 没有 1080 清晰，我要客户看到最佳显示效果，
           不能牺牲压缩画质为代价」）：
           **主源永远是最高画质（1080p）**，只有真的喂不动才逐级降一档：1080 → 720（data-src-mid）
           → 480（data-src-lo），最多降两档。这样强网客户看到的是 1080p，弱网客户也不至于盯着 poster。

           同时去掉原来的 `canplay → clearTimeout`：它会在「刚缓冲一点、canplay 就触发」时取消检查，
           结果卡死也不降档（线上实测 currentTime 停在 0.81s、8 秒不动，就是不降）。
           现在改成每级给 3 秒，currentTime 跑不到 1.2s 才降一级。 */
        (function (vv) {
          if (!vv || vv.dataset.loHooked) return;
          vv.dataset.loHooked = '1';
          var ladder = [vv.getAttribute('data-src-mid'), vv.getAttribute('data-src-lo')];
          var step = 0, done = false;
          function playIt() { var q = vv.play(); if (q && q.catch) q.catch(function () {}); }
          function later(ms, fn) { setTimeout(function () { if (!done) { try { fn(); } catch (e) {} } }, ms); }
          function settle() { done = true; }
          /* REEL-MEDIA-20261101：与图片同一个病 —— 原来只盯「喂不动」（3 秒没起播），
             完全没接 error。请求被掐断/404 时 play() 不会 reject、也不会再试，
             客户就永远盯着 poster。这里 error 直接走降档，档位用尽就切 PHOTO 标签。 */
          vv.addEventListener('error', function () {
            if (done) return;
            if (step < ladder.length) { downgrade(); return; }
            var el2 = vv.closest && vv.closest('.reel');
            var ph = el2 && el2.querySelector('[data-reel-tab="photo"]');
            if (ph) {
              el2.classList.add('is-photo');
              var tabs = el2.querySelectorAll('[data-reel-tab]');
              for (var z = 0; z < tabs.length; z++) tabs[z].classList.toggle('on', tabs[z] === ph);
            }
            done = true;
          });
          function downgrade() {
            if (step >= ladder.length) { settle(); return; }
            var next = ladder[step++];
            if (!next) { settle(); return; }
            vv.setAttribute('src', next);
            vv.load();
            playIt();
            later(3000, function () { if (vv.currentTime < 1.2) downgrade(); else settle(); });
          }
          /* 第一道：3 秒内跑不到 1.2s ⇒ 明确喂不动，立刻降一档 */
          later(3000, function () {
            if (vv.currentTime < 1.2) { downgrade(); return; }
            var t3 = vv.currentTime;
            /* 第二道：3 秒能起播，但网络可能刚好卡在临界点（能起播、喂不满）——
               这时不降档的话客户会一直顿。再等 5 秒（累计 8 秒），
               平均推进速度不到实时的 85% 才降一档。85% 是为了别误伤正常网络。 */
            later(5000, function () {
              /* ⚠️ 防短素材误判：视频 loop 过的话 currentTime 会跳回 0，
                 按 8 秒均值算必然 <85% ⇒ 白白降档。比 3 秒时还小就当它播得飞快。 */
              if (vv.currentTime < t3) { settle(); return; }
              if (vv.currentTime / 8 < 0.85) { downgrade(); return; }
              settle();
            });
          });
        })(v);
      } else {
        v.pause();
        v.classList.remove('on');
      }
    });
  }

  function updateCounter() {
    var c = $('#reelsIdx');
    if (c) c.textContent = reelsIdx + 1;
    /* REELS-FEED-20261024：分母必须是 feed 里真实 slide 数。
       原来显示 Liquid 的 items.size（固定 50）⇒「4 / 50」这种假数。 */
    var t = document.getElementById('reelsTotal');
    if (t) {
      /* 分母优先用「真实总数」：搜索上下文 = search.results_count（536/537 这种真数）；
         合集上下文拿不到总数 ⇒ 退化成「已加载张数」，续拉后会跟着涨。 */
      var n = reelFeedState.total || $$('.reel', feedEl()).length;
      if (n) t.textContent = n;
    }
  }

  /* REELS-FIT-20261024 —— 看货器的纵向构图不再用百分比钉死。
     原来 .reel__card 是 top:43%，视口一变就往下坠：站内浏览器可视高 ~620 时
     图与文字块重叠 71px、~528 时图还钻到顶栏底下（实测见 tools/_reels_fit_harness_20261024.js）。
     现在按「顶栏下沿 → 文字块上沿」这条带子实测算：图在带子里居中，高度取
     min(96.5% 宽 × 1.25, 带宽)，任何视口都不会压到文字、也不会压到顶栏。
     四个值只写 CSS 变量，样式仍然全在 brand.css 里（--rd-cardtop/w/h、--rd-hinty）。 */
  function layoutReels() {
    var box = reelsEl(); if (!box) return;
    var stage = box.querySelector('.reels__stage') || box;
    var top = box.querySelector('.reels__top');
    var W = stage.clientWidth || window.innerWidth;
    var H = stage.clientHeight || window.innerHeight;
    var topB = top ? Math.round(top.getBoundingClientRect().bottom) : 52;
    var slides = $$('.reel', feedEl());
    if (!slides.length) return;

    /* REELS-FRAME-20261024（侯哥 10:0x：「主图区域过长，购物车/翻页显示压住了主图，
       灰色背景框底色漏出，和下面文字区割裂」）
       ------------------------------------------------------------------
       根因：原来图**底边对齐文字块**（top0 = uiTop − ch），所以购物车里有货时
       uiH 变大 → ch 变小 → top0 掉到 9px，图整个钻到顶栏底下（图标压在图上）；
       购物车空时 top0 又变成 86px（顶栏下面露出一条 86px 的灰底）—— 同一个页面两种状态，
       一个压图、一个漏底。
       现在：图**顶边固定在顶栏下方 10px**，高度 = min(可用高度, 0.66×屏宽, 0.66×屏高)。
         · 顶栏永远在图上方 ⇒ 不再压图，也不会在顶上漏一条灰底；
         · 0.66H 上限把「过长」压住（844 屏最多 557px）；
         · 底部留 12px 呼吸 + 圆角 + 投影，跟文字区是「浮起的卡片」而不是硬切一刀。 */
    /* REEL-GEOM-20261029（手机+平板全尺寸布局统一）
       ---------------------------------------------------------------
       原来卡片高度、缩略图行位置各算一套：
         · 卡片高 = min(100vw-106, im-h*0.71429)/0.71429（纯按宽度推）
         · 缩略图行 = 屏幕底往上 --im-ui（纯按屏幕推）
       两套在手机上撞车（360 时缩略图行压在卡图下半部 48px），在平板上又贴死（0~10px）。
       现在全部由**信息区实际高度**反推，并且用内联 !important 写死（brand.css 是 preload 注入的，
       同特异性或更低的选择器会被它反过来压，纯 CSS 改不动）：
         · 信息区高度 = auto（按内容），先量出来
         · 卡片可用高 = 信息区顶 - 10 - 卡片顶
         · 卡宽 = min(屏宽-106, 可用高*5/7)，卡高 = 卡宽/5*7
         · 缩略图行 = 卡片底 + 10
       这样「卡片底 → 缩略图行 → 标题」的间距在 360/375/412/768/820/1024 全部常量。 */
    /* ==========================================================================
       REEL-GAP-STABLE-20261030（侯哥 2026-10-30 21:0x 两张截图）
       「主图底 → 标题区顶」的间距会变：刚进看货器紧（~107），滑过几张回来又松（~185）。
       同一个页面两种构图。
       --------------------------------------------------------------------------
       真因：这个间距从来没被定义过，它是两套「贴屏幕底」算法相减的副作用：
         · 卡片位置 = 顶栏下 + 剩余高度/2（随视口高居中）
         · 信息区用 CSS bottom:0 贴屏幕底
       而移动浏览器地址栏在「刚进（未滑动）」与「滑过几张后」相差 84~155px
       ⇒ 同一张卡的间距 107 ↔ 149 ↔ 185 来回跳（实测 390x760/844/915）。
       把间隙常数改小也没用，视口一变照样跳 —— 问题不在数值，在「谁在决定这个间距」。
       修法：把间距变成**常量**，「卡片 + 缩略图行 + 信息区」打成一个整体块，
       在顶栏以下的区域里垂直居中。视口变高只能改变块上/下的留白，块内间距恒定。
         · 缩略图行 = 卡片底 + 10
         · 信息区   = 缩略图行底 + 88（常量，取自 844 视口下的观感值）
         · 卡片高 = min(可用高, (屏宽-106)/0.71429)，矮屏时卡片让位（而不是拿间距开刀）
       ⚠️ 信息区必须从 bottom:0 改成内联 top，否则它永远贴屏底，间距又会跟着视口跑。
       ⚠️ 社交栏（.rsoc）钉在卡片内右下角（bottom:8px 相对 .reel__card），卡片一动它跟着动。
       验收：390x760/844/915 三档间距恒为 146、卡片尺寸不变、信息区不出屏。
       ========================================================================== */
    var GAP_CARD_TABS = 10;   /* 卡片底 → 缩略图行顶 */
    /* 侯哥 2026-10-30 21:3x：「标题离上方缩略图还是太远，要和『标题-价格』『价格-按钮』相对均衡」
       48 → 16。现在三处：缩略图行→标题 16｜标题→价格 12｜价格→按钮 12（后两个在 reels.liquid 的
       REEL-UI-BALANCE 块里）。标题有行高留白，所以 16 视觉上略大于 12 是正好的。 */
    var GAP_TABS_UI = 16;     /* 缩略图行底 → 信息区顶（常量：这就是要「不变」的那个间距） */
    var i, cards = [], tabss = [], uis = [], maxUi = 0, maxTabs = 48;
    for (i = 0; i < slides.length; i++) {
      var ui0 = slides[i].querySelector('.reel__ui');
      if (ui0) ui0.style.setProperty('height', 'auto', 'important');
      cards.push(slides[i].querySelector('.reel__card'));
      tabss.push(slides[i].querySelector('.reel__tabs'));
      uis.push(ui0);
    }
    /* 用全部 slide 的最大值当基准：各卡信息区高度不一样（有结算条时 +56），
       逐卡算会让翻页时卡片大小、位置都变 ⇒ 取 max 后所有卡几何完全一致，翻页零跳动。 */
    for (i = 0; i < slides.length; i++) {
      var uh = uis[i] ? uis[i].offsetHeight : 186;
      var th = tabss[i] ? tabss[i].offsetHeight : 48;
      if (uh > maxUi) maxUi = uh;
      if (th > maxTabs) maxTabs = th;
    }
    var top0 = topB + 10;
    var uiGap = GAP_CARD_TABS + maxTabs + GAP_TABS_UI;
    var budget = Math.max(180, H - top0 - maxUi - uiGap);       /* 卡片可用高 */
    /* 先定高、再反推宽：ch 必须 ≤ budget。原来是「宽×0.71429 反推高」再四舍五入，
       桌面 1440x900 实测会多出 1px，信息区被顶出屏幕底 1px（验收 G 抓到）。 */
    var ch = Math.round(Math.min(budget, (W - 106) / 0.71429));
    var cw = Math.round(ch * 0.71429);
    var ctop = Math.round(top0 + Math.max(0, budget - ch) / 2); /* 块内居中：余下高度上下平分 */
    for (i = 0; i < slides.length; i++) {
      var cd = cards[i], tb = tabss[i], uu = uis[i];
      if (cd) {
        cd.style.setProperty('top', ctop + 'px', 'important');
        cd.style.setProperty('height', ch + 'px', 'important');
        cd.style.setProperty('width', cw + 'px', 'important');
      }
      if (tb) {
        tb.style.setProperty('top', (ctop + ch + GAP_CARD_TABS) + 'px', 'important');
        tb.style.setProperty('bottom', 'auto', 'important');
      }
      if (uu) {
        uu.style.setProperty('top', (ctop + ch + uiGap) + 'px', 'important');
        uu.style.setProperty('bottom', 'auto', 'important');
      }
      slides[i].style.setProperty('--rd-cardtop', ctop + 'px');
      slides[i].style.setProperty('--rd-cardw', cw + 'px');
      slides[i].style.setProperty('--rd-cardh', ch + 'px');
    }
  }
  window.addEventListener('resize', function () {
    if (document.body.classList.contains('reels-open')) layoutReels();
  });
  window.addEventListener('orientationchange', function () { setTimeout(layoutReels, 260); });

  /* ---------------- PDP media ---------------- */
  function setPdpMedia(wantVideo) {
    var main = $('#pdpMain'); if (!main) return;
    main.classList.toggle('is-video', wantVideo);
    main.classList.toggle('is-image', !wantVideo);
    var v = $('#pdpVideo');
    if (v) {
      if (wantVideo) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else { v.pause(); }
    }
    var tag = main.querySelector('.pm__tag');
    if (tag) tag.textContent = wantVideo ? 'Video' : 'Photo';
  }

  function syncPaused() {
    var main = $('#pdpMain'), v = $('#pdpVideo');
    if (!main || !v) return;
    main.classList.toggle('is-paused', v.paused);
  }

  /* PDP-LADDER-20261102（侯哥：「把上传好的视频优化好，确保最佳观看效果和流畅度」）
     现象：详情页主视频只有一条 src = HD-1080p / 7.2Mbps（11 秒约 10 MB）。
     4G 慢网喂不动就永远停在 poster，页面上除了「Watch the card move」没有别的出路。
     main-product.liquid 现在输出 data-src-mid(720p) / data-src-lo(480p)，
     这里复用看货器同一套判据降档：主源永远是 1080p（画质优先，QUALITY-FIRST-20261027），
     只有真的喂不动才逐级降，最多两档；档位用尽切回图片层 —— 客户至少看得清卡面。
     没有兜底源时（!mid && !lo）整段直接返回，行为与改动前逐字节一致。 */
  function initPdpVideoLadder() {
    var vv = document.getElementById('pdpVideo');
    if (!vv || vv.dataset.pdpLadder) return;
    var mid = vv.getAttribute('data-src-mid'), lo = vv.getAttribute('data-src-lo');
    if (!mid && !lo) return;
    vv.dataset.pdpLadder = '1';
    var ladder = [mid, lo].filter(function (x) { return !!x; });
    var step = 0, done = false;
    function playIt() { var q = vv.play(); if (q && q.catch) q.catch(function () {}); }
    function settle() { done = true; }
    function giveUp() {
      done = true;
      try { vv.pause(); } catch (e) {}
      try { setPdpMedia(false); } catch (e) {}
    }
    function downgrade() {
      if (done) return;
      if (step >= ladder.length) { giveUp(); return; }
      vv.setAttribute('src', ladder[step++]);
      try { vv.load(); } catch (e) {}
      playIt();
      setTimeout(function () { if (!done && vv.currentTime < 1.2) downgrade(); }, 3000);
    }
    vv.addEventListener('error', function () { if (!done) downgrade(); });
    setTimeout(function () {
      if (done) return;
      /* 暂停 / autoplay 被系统拦下时 currentTime 本来就不涨，这不是「喂不动」，
         贸然降档只会让客户点播放时白降一档画质 ⇒ 直接收工，交给 syncPaused 露播放入口。 */
      if (vv.paused) { settle(); return; }
      /* 第一道：3 秒还拿不到画面（readyState 低 / currentTime 不动）⇒ 立刻降一档 */
      if (vv.currentTime < 1.2) { downgrade(); return; }
      var t3 = vv.currentTime;
      /* 第二道：起播了但喂不满（8 秒均速 < 85% 实时）才降，避免误伤正常网络。
         视频 loop 过的话 currentTime 会跳回 0 ⇒ 比 3 秒时还小就当它播得飞快，放过。 */
      setTimeout(function () {
        if (done) return;
        if (vv.paused) { settle(); return; }
        if (vv.currentTime < t3) { settle(); return; }
        if (vv.currentTime / 8 < 0.85) { downgrade(); return; }
        settle();
      }, 5000);
    }, 3000);
  }

  /* PDP-STICKY-20261025（侯哥：「详情页更紧凑更美观」）
     症状：页内「Add to cart — $9.90」正下方紧贴一条吸底「Add to cart」，看起来像两个按钮。
     做法：IntersectionObserver 盯页内按钮 —— 它在视野里就收起吸底条，滚出视野再浮上来。
     ⚠️ 默认（没有 JS / 观察器不支持）吸底条照常显示，宁可重复也不让买家看不到加购。 */
  function initPdpSticky() {
    var bar = document.querySelector('.mobile-buy');
    var inline = document.getElementById('addBtn');
    if (!bar || !inline || !window.IntersectionObserver) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-off', e.isIntersecting && e.intersectionRatio > 0.6);
      });
    }, { threshold: [0, 0.6, 1] });
    io.observe(inline);
  }

  /* ---------------- delivery estimate ---------------- */
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function warehouseNow(tz) {
    /* TZ-DST-20261030：原来只用 settings.warehouse_utc_offset 这一个**固定数字**（默认 -7）。
       美西 2026-11-01 起切入 PST = UTC-8，固定 -7 会让仓库当地时间多算 1 小时 ⇒
       「是否已过 14:00 截单点」在 13:00-14:00 这一小时里判反，「Ships by」白推一天（买家看到晚一天发货）。
       修：offset 落在美西（-7/-8）时，改用 IANA 时区算真实当地时间，自动跟随夏令时；
       Intl 不可用或 offset 不是美西，原样退回固定偏移 —— 行为零变化。
       ⚠️ 只管「发货日」这一处。BBStock 的 CUT_TZ = -8 是**刻意固定**的每日重置口径，不要跟着改。 */
    if (tz === -7 || tz === -8) {
      try {
        var p = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Los_Angeles', hour12: false,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).formatToParts(new Date()), m = {}, i;
        for (i = 0; i < p.length; i++) m[p[i].type] = p[i].value;
        var hh = parseInt(m.hour, 10) % 24;   // 部分实现在午夜给 "24"
        return new Date(parseInt(m.year, 10), parseInt(m.month, 10) - 1, parseInt(m.day, 10),
          hh, parseInt(m.minute, 10), parseInt(m.second, 10));
      } catch (e) { }
    }
    var utc = Date.now() + new Date().getTimezoneOffset() * 60000;
    return new Date(utc + tz * 3600000);
  }
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime()), added = 0;
    while (added < n) {
      r.setDate(r.getDate() + 1);
      if (r.getDay() !== 0 && r.getDay() !== 6) added++;
    }
    return r;
  }
  function fmt(d) { return WD[d.getDay()] + ', ' + MO[d.getMonth()] + ' ' + d.getDate(); }

  function paintDelivery() {
    /* SHIP-ONLY-20261025：只算**我们发得出去的那天**，不再推算到达日。
       规则（全部是我们能控制的）：
         · 工作日且早于截单点(settings.ship_cutoff_hour, 仓时区) ⇒ 今天算第 1 个工作日；
         · 周末或已过截单点 ⇒ 从下一个工作日算第 1 个；
         · 发货日 = 第 1 个工作日 + (handling_days - 1) 个工作日（周末跳过）。
       例：10/25 周日下单、handling=2 ⇒ 10/26(Mon)=1、10/27(Tue)=2 ⇒「Ships by Tue, Oct 27」。
       ⚠️ 别再引进运输天数/到达区间：买家地址与仓库距离在下单前我们都不知道，写出来就是编的。 */
    $$('[data-delivery]').forEach(function (box) {
      var tz = parseInt(box.getAttribute('data-tz'), 10) || -7;
      var handle = parseInt(box.getAttribute('data-handle'), 10) || 2;
      var cutoff = parseInt(box.getAttribute('data-cutoff'), 10) || 14;

      var now = warehouseNow(tz);
      var isWeekday = now.getDay() !== 0 && now.getDay() !== 6;
      var beforeCut = now.getHours() < cutoff;

      var start = new Date(now.getTime());
      if (!isWeekday || !beforeCut) start = addBusinessDays(start, 1);   // 从下一个工作日开始
      var ship = addBusinessDays(start, Math.max(0, handle - 1));

      var el = box.querySelector('[data-delivery-ship]');
      if (!el) return;
      var tpl = box.getAttribute('data-tpl-ship') || 'Ships by [[D]]';
      el.textContent = tpl.replace('[[D]]', fmt(ship));
      /* 今天就能发出时给一点"轻紧迫感"，但仍然只是发货承诺 */
      el.classList.toggle('is-today', isWeekday && beforeCut && handle <= 1);
    });
  }

  /* ---------------- 库存徽标（2026-10-23） ----------------
     只剩 ≤5 件时切成「Only N left」+ 琥珀色呼吸点，>5 保持平静的「N in stock」。
     文案模板从元素上的 data-tpl-low / data-tpl-ok 取（服务端由 locale 渲染），JS 里不写死英文。 */
  /* ================= 🔴 库存双轨铁律 STOCK-LAW-20261030 =================
     侯哥 2026-10-30 定死（原话）：
       「渲染库存是独立的，客户加够会不会超限要以真实库存为主，不能以渲染的库存为主，
         这是铁律写死 —— 渲染库存只是渲染效果，不参与任何真实的购物，
         真实的加购等所有全部以真实库存为准。」

     两条轨，永不交叉：
       · 渲染轨（BBStock.shown）→ **只允许写文案 / 视觉**：textContent、data-bbs-shown、is-low 类。
       · 真值轨（variant.inventory_quantity）→ **所有真实购物判断只认它**：
         `data-inv`（卡片/看货器）、`#pdpStock[data-qty]`（PDP 数量上限与闸门）、
         `#bbInvMap` / `#bbInvMapCart`（handle→真库存映射）。
     禁止：把渲染值写回 data-inv / data-qty / data-bbs-qty；用文案数字（"Only 2 left"）做拦截；
           用 data-bbs-shown 做任何上限或校验。违反本条 = 客户会被"虚高的库存"卡住买不了。
     ⚠️ 历史 bug（本条诞生原因）：paintPdpStock 曾把 q 覆盖成渲染值再 `setAttribute('data-qty', q)`
        ⇒ PDP 数量 + 号上限变成渲染值（真实 105 件时客户只能加 2 件）。2026-10-30 修复。
     ==================================================================== */
  function paintPdpStock(opt) {
    var el = $('#pdpStock');
    if (!el || !opt) return;
    var real = parseInt(opt.getAttribute('data-qty'), 10);   /* ← 真值轨：本次唯一依据 */
    var avail = opt.getAttribute('data-avail') === 'true' && !opt.disabled;
    if (!avail || !(real > 0)) { el.hidden = true; return; }
    /* 渲染轨：只算"给客户看的数字"，绝不回写真值属性 */
    var q = real;
    if (window.BBStock) {
      var _r = BBStock.shown(el.getAttribute('data-bbs-key') || '', real, true);
      if (_r.out) { el.hidden = true; return; }
      q = _r.q;
    }
    var low = q <= (window.BBStock ? BBStock.lowAt : 5);
    var tpl = el.getAttribute(low ? 'data-tpl-low' : 'data-tpl-ok') || '##';
    el.hidden = false;
    el.textContent = tpl.replace('##', q);
    /* 🔴 只写真实库存：数量上限（数量 + 号 _max）与 stockGuard 都读这里 */
    el.setAttribute('data-qty', real);
    /* data-bbs-qty 是渲染轨的输入基数，同样必须是真值（切规格后要跟着变） */
    el.setAttribute('data-bbs-qty', real);
    el.classList.toggle('is-low', low);
  }

  function paintStockFromSelect() {
    var sel = $('[data-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    if (opt) paintPdpStock(opt);
  }

  /* ---------------- variants ---------------- */
  function bindVariants() {
    var sel = $('[data-variant-select]');
    if (!sel) return;

    $$('[data-opt]').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var btn = e.target.closest('.opt'); if (!btn) return;
        $$('.opt', row).forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');

        // 把当前选中的 option 值拼成 Shopify 的 variant title 去匹配
        var picked = $$('[data-opt]').map(function (r) {
          var on = r.querySelector('.opt.on');
          return on ? on.getAttribute('data-opt-value') : '';
        });
        // 2026-10-23：改成「按 option 索引逐项比对」。
        // 原来靠 variant.title 拼字符串（' / ' 拼接）匹配，选项数变化/顺序不同/含斜杠就命中不了，
        // 命不中时页面价格和库存都不动 —— 客户以为切了规格其实没切。
        var target = null;
        Array.prototype.forEach.call(sel.options, function (o) {
          if (target) return;
          var ok = true;
          for (var i = 0; i < picked.length; i++) {
            if (!picked[i]) continue;
            if ((o.getAttribute('data-o' + (i + 1)) || '') !== picked[i]) { ok = false; break; }
          }
          if (ok) target = o;
        });
        if (target) {
          sel.value = target.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var price = opt.getAttribute('data-price') || (opt.textContent.split(' — ')[1] || '').trim();
      var p = $('#addPrice'); if (p && price) p.textContent = price;
      var add = $('#addBtn'); if (add) add.setAttribute('data-variant-id', sel.value);
      $$('[data-add-to-cart], [data-buy-now]').forEach(function (b) { b.setAttribute('data-variant-id', sel.value); });

      var avail = opt.getAttribute('data-avail') === 'true' && !opt.disabled;
      if (add) add.disabled = !avail;
      paintPdpStock(opt);
    });

    // 初始也按当前变体刷一次（服务端渲染的文案可能与库存不一致时兜底）
    paintStockFromSelect();
  }

  /* ---------------- init ---------------- */
  /* ---------------- 集合页「加载更多」 ----------------
     千级 SKU 下翻页不可用（1000 件按 24/页 = 42 页）。这里用 Shopify 的
     Section Rendering API：请求下一页时带 section_id，返回该 section 的 HTML 片段，
     解析出 #productGrid 里的新卡片追加进去，不整页刷新。
     加购是 document 级事件委托，所以新追加的卡片天然可点，不用重新绑定。 */
  /* ================= SEARCH-INFINITE-20261024 =================
    侯哥：「显示 127 个皮卡丘但就一版，往上滑也不加载，最下面结算条还挡着」
    ① 搜索结果原来没有 {% paginate %}，只有第一页 10 条 —— 先补分页（见 main-search.liquid）
    ② 这里做**滚动自动加载**：哨兵进入视口下方 500px 就拉下一页，
       走 section_id=main-search 只取这段 HTML（实测 21KB / 整页 168KB），解析 #searchGrid 追加。
    ③ 不做"加载更多"按钮 —— 买家往上翻就该自动出，多一个按钮就多一次点击。
    ⚠️ 用 data-next / data-pages 记进度，滚到底没页了就把哨兵摘掉，避免无限空转。
    ⚠️ busy 锁：一次只飞一个请求，否则快速滚动会重复拉同页。
     ============================================================= */
  function initSearchInfinite() {
    var grid = document.getElementById('searchGrid');
    var sentinel = document.getElementById('searchSentinel');
    if (!grid || !sentinel || !('IntersectionObserver' in window)) return;

    var next = Number(sentinel.getAttribute('data-next')) || 2;
    var pages = Number(sentinel.getAttribute('data-pages')) || 1;
    var busy = false;

    function load() {
      if (busy || next > pages) return;
      busy = true;
      sentinel.classList.add('is-loading');

      var u = new URL(location.href);
      u.searchParams.set('page', String(next));
      u.searchParams.set('section_id', 'main-search');

      fetch(u.toString(), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('searchGrid');
          if (!fresh) return;
          var added = 0;
          Array.prototype.forEach.call(fresh.children, function (node) {
            grid.appendChild(document.importNode(node, true));   // 事件都是 document 委托，追加即可用
            added++;
          });
          next++;
          if (!added || next > pages) {
            sentinel.remove();       // 到底了：摘掉哨兵，不再观察
          }
        })
        .catch(function () {})
        .then(function () {
          busy = false;
          if (sentinel.parentNode) sentinel.classList.remove('is-loading');
        });
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) load();
    }, { rootMargin: '500px 0px' });

    io.observe(sentinel);
  }

  /* ================= COLL-AUTOLOAD-20261025 =================
     侯哥（2026-10-25）：「全部产品往下翻到底还要点一下才能继续滑动，改成到底自动加载」
     原来合集页只有「Show more」按钮手动点。这里不碰取数逻辑（按钮那套已处理
     追加卡片 / 更新 data-next / 到底移除 wrap / 失败退化成链接），只加观察器。
     ⚠️ 不能只在 isIntersecting 回调里点一次：IO 只在「进出视口」时回调，
        加载完用户还在底部时不会再触发 ⇒ 停在底部。故进视口后每 450ms 复查。
     ⚠️ 按钮 disabled（上一页还在飞）时不点，避免并发重复请求。
     ========================================================= */
  function initLoadMoreAuto() {
    var btn = document.getElementById('loadMore');
    var wrap = document.getElementById('loadMoreWrap');
    if (!btn || !wrap || !('IntersectionObserver' in window)) return;
    if (btn.getAttribute('data-fallback') === '1') return;   // 已退化成链接，交给用户点

    var inView = false, timer = null;

    function alive() { return document.body.contains(btn) && wrap.parentNode; }
    function hasNext() { return !!btn.getAttribute('data-next'); }

    function tick() {
      timer = null;
      if (!inView || !alive() || !hasNext()) return;
      if (btn.disabled) { timer = setTimeout(tick, 350); return; }  // 上一页还在飞
      btn.click();
      timer = setTimeout(tick, 450);                                // 拉完再看一眼
    }

    var io = new IntersectionObserver(function (entries) {
      inView = !!(entries[0] && entries[0].isIntersecting);
      if (inView && !timer) tick();
    }, { rootMargin: '800px 0px' });

    io.observe(wrap);
  }

  function initLoadMore() {
    var btn = $('#loadMore');
    if (!btn) return;
    var busy = false;

    btn.addEventListener('click', function () {
      if (busy) return;
      var url = btn.getAttribute('data-next');
      if (!url) return;
      busy = true;
      btn.disabled = true;
      btn.textContent = 'Loading…';

      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'section_id=main-collection', { headers: { 'Accept': 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = $('#productGrid');
          var fresh = doc.querySelectorAll('#productGrid > .card');
          if (!grid || !fresh.length) throw new Error('no cards');
          Array.prototype.forEach.call(fresh, function (card) { grid.appendChild(card); });

          var nb = doc.querySelector('#loadMore');
          var nextUrl = nb && nb.getAttribute('data-next');
          if (nextUrl) {
            btn.setAttribute('data-next', nextUrl);
            btn.setAttribute('data-left', nb.getAttribute('data-left') || '');
            btn.textContent = nb.textContent.trim();
            btn.disabled = false;
          } else {
            var wrap = $('#loadMoreWrap');
            if (wrap) wrap.parentNode.removeChild(wrap);
          }
        })
        .catch(function () {
          // 失败就退回「翻页」：把按钮换成链接，用户还能继续看
          var a = document.createElement('a');
          a.className = 'btn btn--ghost';
          a.href = url;
          a.textContent = 'Load next page';
          btn.parentNode.replaceChild(a, btn);
          a.setAttribute('data-fallback', '1');
        })
        .then(function () { busy = false; });
    });
  }

  /* ---------------- 购物车「搭配推荐」 ----------------
     不做协同过滤（千级 SKU 初期样本不足），用同系列规则：
     读购物车行上的 data-pcol → 取该 collection 的商品 → 排除已在车里的 → 推 4 个。
     数据走 Shopify 公开端点 /collections/{handle}/products.json，不依赖任何 App。
     任何一步失败就保持 hidden，绝不留空壳给客户看。

     🔴 2026-10-22 线上实证：本店每个「版次」集合只有一个商品（整箱套装），
     买的就是它本身 ⇒ 同系列过滤后必然为空，货架永远是 hidden。
     所以加一级兜底：同系列凑不够 2 个，就退到 /collections/all 取全站现货。 */
  /* CART-REC-STOCK-20261025：推荐卡的库存只能查服务端输出的映射（公开 JSON 没有 inventory_quantity）。
     先查购物车页专用的 #bbInvMapCart（铺满全店），再退回看货器的 #bbInvMap（前 50 个）。 */
  var _cartInv = null;
  function cartStockMap() {
    if (_cartInv) return _cartInv;
    var m = {};
    ['bbInvMapCart', 'bbInvMap'].forEach(function (id) {
      var tag = document.getElementById(id);
      if (!tag) return;
      try {
        var j = JSON.parse(tag.textContent || '{}');
        for (var k in j) if (j.hasOwnProperty(k) && m[k] === undefined) m[k] = j[k];
      } catch (e) {}
    });
    _cartInv = m;
    return m;
  }
  function cartRecStock(p) {
    if (!p) return '';
    if (p.available === false) return '<span class="cart-rec__s is-out">Sold out</span>';
    var q = cartStockMap()[p.handle];
    if (typeof q === 'number' && q > 0) {
      var _t = window.BBStock ? BBStock.text(p.handle, q, true) : (q + ' in stock');
      return '<span class="cart-rec__s" data-bbs-key="' + escHTML(p.handle) + '" data-bbs-qty="' + q + '">' + _t + '</span>';
    }
    return '';
  }
  /* CART-QTY-CAP-20261030（侯哥：「可以按照你的建议来」）
     购物车 / 抽屉里点 + 号时的**真实库存上限**。
     背景：`/cart/change.js` 库存不足时服务端会把数量改回可用值 —— 不会超卖，
           但客户看到的是「点上去又弹回来」，不知道发生了什么。这里提前拦并给一句人话。
     🔴 铁律配套（STOCK-LAW-20261030）：只读真值映射 cartStockMap()（源自
        `#bbInvMapCart` / `#bbInvMap` 的 `inventory_quantity`），
        **绝不读 BBStock 渲染出来的数字**；拿不到真值就返回 null（放行，交服务端兜底）。 */
  function cartLineStockLeft(row) {
    try {
      /* ① 行上直接挂的 variant 真值（cart-line / cart-drawer 输出）——最精确，优先 */
      var d = row && row.getAttribute('data-inv');
      if (d !== null && d !== undefined && d !== '' && !isNaN(parseInt(d, 10))) return parseInt(d, 10);
      /* ② 退到 handle 映射（#bbInvMapCart 只铺得下 250 个，长尾靠这条兜） */
      var h = row && row.getAttribute('data-phandle');
      if (!h) return null;
      var q = cartStockMap()[h];
      if (q === undefined || q === null || q === '') return null;
      var n = parseInt(q, 10);
      return isNaN(n) ? null : n;
    } catch (e) { return null; }
  }
  function recPrice(v) {
    // 🔴 Ajax API 的 variants[].price 是「美元字符串」（如 "9.90"），不是分。
    // 旧代码写 price/100 ⇒ 真实价 $9.90 会显示成 $0.10（线上实测踩到）。
    var n = parseFloat(v);
    return '$' + (isFinite(n) ? n.toFixed(2) : '0.00');
  }

  /* SHOPPATHS-20261023：空车推荐（清空车 / 误入 /cart 时的挽回位）。
     复用 recCandidates 的取数（pcols 传空 ⇒ 自动走 /collections/all 兜底），不写第二套逻辑。 */
  function fillEmptyCartRecs() {
    var ebox = $('#cartRecEmpty'), erow = $('#cartRecEmptyRow');
    if (!ebox || !erow || ebox.getAttribute('data-filled')) return;
    ebox.setAttribute('data-filled', '1');
    recCandidates([], {})
      .then(function (list) {
        if (!list.length) { ebox.hidden = true; return; }
        erow.innerHTML = list.slice(0, 4).map(function (p) {
          var img = (p.images && p.images[0]) ? p.images[0].src : '';
          var price = (p.variants && p.variants[0]) ? p.variants[0].price : 0;
          var pvid = (p.variants && p.variants[0] && p.variants[0].id) || '';
          return '<div class="cart-rec__item">'
            + '<a class="cart-rec__link" href="/products/' + p.handle + '" data-reels-open="' + p.handle + '">'
            + '<img class="cart-rec__img" src="' + img + '" alt="" loading="lazy" width="280" height="280"' +
             ' onerror="this.style.visibility=\'hidden\'">'
            + '<div class="cart-rec__n">' + p.title + '</div>'
            + '<div class="cart-rec__p">' + recPrice(price) + cartRecStock(p) + '</div></a>'
            + (pvid ? '<button class="cart-rec__add" type="button" data-add-to-cart data-variant-id="' + pvid + '">Add to cart</button>' : '')
            + '</div>';
        }).join('');
        ebox.hidden = false;
      })
      .catch(function () { ebox.hidden = true; });
  }

  /* REC-V2-20261026：推荐数据源换成离线打分的 custom.recs（走 ?view=rec JSON 视图）。
     只换「拿哪几件」，返回结构仍是 {handle,title,images,variants} 与原来完全一致，
     所以下面三处渲染代码（抽屉条 / 购物车页 / 空车挽回）一行没动。
     任何一步失败都退回原来的合集取数，绝不把货架搞空。 */
  var _recViewCache = {};
  function recView(handle) {
    if (_recViewCache[handle]) return _recViewCache[handle];
    var pr = fetch('/products/' + encodeURIComponent(handle) + '?view=rec')
      .then(function (r) { return r.ok ? r.json() : Promise.reject(0); })
      .then(function (d) { return d && d.items ? d.items : []; })
      .catch(function () { return []; });
    _recViewCache[handle] = pr;
    return pr;
  }
  function recFromMeta(handles, inCart) {
    if (!handles || !handles.length) return Promise.resolve(null);
    return Promise.all(handles.map(recView)).then(function (groups) {
      var out = [], seen = {};
      groups.forEach(function (g) {
        (g || []).forEach(function (p) {
          if (!p || !p.handle || seen[p.handle] || inCart[p.handle]) return;
          seen[p.handle] = 1;
          out.push(p);
        });
      });
      return out.length ? out : null;
    });
  }

  function recCandidates(pcols, inCart) {
    function usable(list) { return (list || []).filter(function (p) { return !inCart[p.handle]; }); }
    /* 先试 metafield：车里有几件就查几个商品的推荐序列并合并去重 */
    var _keys = Object.keys(inCart).slice(0, 2);   // 最多查 2 个，避免 13 件车发 13 个请求
    var metaP = _keys.length ? recFromMeta(_keys, inCart) : Promise.resolve(null);
    return metaP.then(function (hit) {
      if (hit && hit.length >= 2) return hit;
      return recCandidatesFallback(pcols, inCart, usable);
    });
  }

  function recCandidatesFallback(pcols, inCart, usable) {
    function get(url) {
      return fetch(url).then(function (r) { return r.ok ? r.json() : Promise.reject(0); })
        .then(function (d) { return d.products || []; });
    }
    var first = pcols.length ? get('/collections/' + encodeURIComponent(pcols[0]) + '/products.json?limit=16') : Promise.resolve([]);
    return first.then(function (list) {
      var picked = usable(list);
      if (picked.length >= 2) return picked;
      // 同系列不够（常见：集合就一个商品）⇒ 全站兜底，绝不留空货架
      return get('/collections/all/products.json?limit=16').then(function (all) {
        var merged = picked.concat(usable(all).filter(function (p) { return picked.indexOf(p) < 0; }));
        return merged;
      });
    });
  }
  function renderCartRecs() {
    var box = $('#cartRec');
    if (!box) return;
    /* 🔴 DRAWER-REC-NOREBUILD-20261026（侯哥 20:43：抽屉推荐位点加购，卡死半天）
       实测（tools/_diag_drawer_addcart_20261026.js）：
         · 主线程 maxGap **65ms**、零 longtask ⇒ 不是前端卡死
         · POST /cart/add.js **874ms**、GET /cart.js 288ms ⇒ 接口本身不慢
         · 真正吃时间的是**图片**：5 张推荐图合计 **30,034ms**（最大 ttfb 1389ms），
           而这台机器实测下行只有 ~9.8 KB/s（国内直连 Shopify CDN）
       根因：加购成功 → syncDrawerHTML → 这里整块 `box.innerHTML = …` 重建推荐区
             ⇒ 4 张 <img> 被重新创建 ⇒ 在慢网下等于又排一轮下载。
       修：一次抽屉会话里推荐区只渲染一次（`data-rec-lock`），加购后不再重建。
           加购的那张就地显示 Added ✓ 并禁用，不抽走、不重排 ⇒ 用户看到的是「点一下立刻变」。
           关抽屉时解锁，下次打开再按最新购物车重算。 */
    if (box.getAttribute('data-rec-lock') === '1' && !box.hidden) return;
    var lines = $$('#drawer [data-line-key]');
    if (!lines.length) { box.hidden = true; return; }

    var pcols = [];
    var inCart = {};
    lines.forEach(function (l) {
      var h = l.getAttribute('data-pcol');
      if (h && pcols.indexOf(h) < 0) pcols.push(h);
      var ph = l.getAttribute('data-phandle');
      if (ph) inCart[ph] = 1;
    });
    /* 2026-10-23：cart line 里的 product.collections 取不到（Shopify 购物车对象不带 collections），
       data-pcol 常为空 ⇒ 原来直接 hidden，货架永远不出现。
       现在把空数组交给 recCandidates，它会走 /collections/all 兜底。 */
    recCandidates(pcols, inCart)
      .then(function (list) {
        if (!list.length) { box.hidden = true; return; }
        list = list.slice(0, 4);
        box.innerHTML = '<div class="rec__head">Pairs well with your cart</div>'
          + '<div class="rec__row">'
          + list.map(function (p) {
              var img = (p.images && p.images[0]) ? p.images[0].src : '';
              var price = (p.variants && p.variants[0]) ? p.variants[0].price : 0;
              var vid = (p.variants && p.variants[0] && p.variants[0].id) || '';
              /* DRAWER-COMPACT-FOLD-20261023：<a> 里不能套 <button>（交互元素不能嵌套），
                 所以外层用 div，图/名/价继续是一个 <a>（点了进看货器），下面单独一个 Add 按钮
                 走全局 [data-add-to-cart] 委托 ⇒ 在抽屉内不会重复弹抽屉，加完 syncDrawerHTML 重建。 */
              return '<div class="rec__item">'
                + '<a class="rec__link" href="/products/' + p.handle + '" data-reels-open="' + p.handle + '">'
                + '<img class="rec__img" src="' + img + '" alt="" loading="lazy" decoding="async" fetchpriority="low" width="104" height="104"' +
                  ' onerror="this.style.visibility=\'hidden\'">'
                + '<div class="rec__n">' + p.title + '</div>'
                + '<div class="rec__p">' + recPrice(price) + '</div></a>'
                + (vid ? '<button class="rec__add" type="button" data-add-to-cart data-variant-id="' + vid + '">Add to cart</button>' : '')
                + '</div>';
            }).join('')
          + '</div>';
        box.hidden = false;
        // 推荐区高度变化会挤占 body ⇒ 折叠行数要重算
        try { applyDrawerFold(); } catch (e) {}
      })
      .catch(function () { box.hidden = true; });
  }

  /* ---------------- 购物车页「同系列」货架 ----------------
     抽屉那支是内联标记取 data-pcol；购物车页用的是共享片段（本轮才补上 data-pcol）。
     同一套取数规则，只是渲染成网格而不是横滑条。失败一律保持 hidden。 */
  function renderPageRecs() {
    var box = $('#cartRecPage');
    var row = $('#cartRecPageRow');
    /* SHOPPATHS-20261023：空车页模板不渲染 #cartRecPage（它在 else 分支），所以这里必须直接走空车填充 */
    if (!box || !row) { fillEmptyCartRecs(); return; }

    var lines = $$('#cartForm [data-line-key]');
    if (!lines.length) { box.hidden = true; fillEmptyCartRecs(); return; }

    var pcols = [];
    var inCart = {};
    lines.forEach(function (l) {
      var h = l.getAttribute('data-pcol');
      if (h && pcols.indexOf(h) < 0) pcols.push(h);
      var ph = l.getAttribute('data-phandle');
      if (ph) inCart[ph] = 1;
    });
    /* 2026-10-23：cart line 里的 product.collections 取不到（Shopify 购物车对象不带 collections），
       data-pcol 常为空 ⇒ 原来直接 hidden，货架永远不出现。
       现在把空数组交给 recCandidates，它会走 /collections/all 兜底。 */
    recCandidates(pcols, inCart)
      .then(function (list) {
        if (!list.length) { box.hidden = true; return; }
        row.innerHTML = list.slice(0, 4).map(function (p) {
          var img = (p.images && p.images[0]) ? p.images[0].src : '';
          var price = (p.variants && p.variants[0]) ? p.variants[0].price : 0;
          var pvid = (p.variants && p.variants[0] && p.variants[0].id) || '';
          return '<div class="cart-rec__item">'
            + '<a class="cart-rec__link" href="/products/' + p.handle + '" data-reels-open="' + p.handle + '">'
            + '<img class="cart-rec__img" src="' + img + '" alt="" loading="lazy" width="280" height="280"' +
             ' onerror="this.style.visibility=\'hidden\'">'
            + '<div class="cart-rec__n">' + p.title + '</div>'
            + '<div class="cart-rec__p">' + recPrice(price) + cartRecStock(p) + '</div></a>'
            + (pvid ? '<button class="cart-rec__add" type="button" data-add-to-cart data-variant-id="' + pvid + '">Add to cart</button>' : '')
            + '</div>';
        }).join('');
        box.hidden = false;
      })
      .catch(function () { box.hidden = true; });
  }

  /* ---------------- 收藏者名单（主题侧） ----------------
     1) 订阅表单提交时把「名单状态」记到本地，供结账自动带折扣参数
     2) 点任何结账链接时，若在名单里就自动补 ?discount=CODE —— 客户全程不用看码、不用输入
     真实核销仍由 Shopify 折扣码的「每客户限用一次」兜底。 */
  var COLLECTOR_KEY = 'bb_collector';
  var PENDING_KEY = 'bb_pending_email';
  var COLLECTOR_CODE = window.BB_COLLECTOR_CODE || 'COLLECTOR5';

  function readCollector() {
    try {
      var c = JSON.parse(localStorage.getItem(COLLECTOR_KEY) || 'null');
      return (c && typeof c === 'object' && c.code) ? c : null;
    } catch (e) { return null; }
  }

  function markCollector(email) {
    try {
      localStorage.setItem(COLLECTOR_KEY, JSON.stringify({
        email: email || '', code: COLLECTOR_CODE, at: Date.now()
      }));
    } catch (e) {}
    paintCollectorState();
  }

  function paintCollectorState() {
    var c = readCollector();
    var badge = $('#collectorBadge');
    if (badge) badge.hidden = !c;
  }

  function initCollector() {
    paintCollectorState();

    var f = $('.news__form');
    var ok = $('#newsJoined');

    function showJoined() {
      if (ok) ok.hidden = false;
      if (f) f.hidden = true;
      paintCollectorState();
    }

    /* 2026-10-23：只有 Shopify 回跳带 customer_posted=true 才算订阅成功。
       之前是在 submit 事件里直接发码 —— captcha 还没过就先发了，
       等于没订阅也能吃到订阅价。现在提交只记「待确认邮箱」，回跳后才发码。 */
    var posted = /[?&]customer_posted=true/.test(location.search);
    var pending = '';
    try { pending = sessionStorage.getItem(PENDING_KEY) || ''; } catch (e) {}

    if (posted) {
      if (pending) markCollector(pending);
      try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
      /* 只有真拿到订阅态（本次回跳带邮箱）才显示成功态；伪造 ?customer_posted=true 不给 */
      if (readCollector()) showJoined();
      try { history.replaceState({}, '', location.pathname + '#join'); } catch (e) {}
    } else if (readCollector()) {
      showJoined();
    }

    if (f) {
      f.addEventListener('submit', function () {
        var inp = f.querySelector('input[type=email]');
        try { sessionStorage.setItem(PENDING_KEY, inp ? inp.value.trim() : ''); } catch (e) {}
        /* 不 preventDefault：原生 POST 给 Shopify；此处不发码 */
      });
    }

    /* 2026-10-23：首屏钩子直接落到订阅输入框并聚焦（手机端即弹键盘），不再只跳到区块顶部 */
    document.addEventListener('click', function (e) {
      var hk = e.target.closest && e.target.closest('.hero__hook');
      if (!hk) return;
      var inp = $('#newsEmail');
      if (!inp || (f && f.hidden)) return;   /* 已订阅（表单已收起）：按原锚点跳区块 */
      e.preventDefault();
      var box = inp.closest('.news__form') || inp;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () {
        try { inp.focus({ preventScroll: true }); } catch (err) { try { inp.focus(); } catch (e2) {} }
      }, 420);
      try { history.replaceState({}, '', '#join'); } catch (e3) {}
    }, true);

    /* 结账链接：capture 阶段改 href，赶在浏览器导航之前 */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="/checkout"]');
      if (!a) return;
      var c = readCollector();
      if (!c || /[?&]discount=/.test(a.href)) return;
      a.href = a.href + (a.href.indexOf('?') > -1 ? '&' : '?') +
               'discount=' + encodeURIComponent(c.code);
    }, true);
  }

  function init() {
    paintCart();
    try { applyCartFold(); } catch (e) {}
    paintDelivery();
    initPdpSticky();
    bindVariants();

    // 加购（卡片 / 商品页 / 移动购买条 / 播放器）
    document.addEventListener('click', function (e) {
      // 移动端汉堡：开/关（原先完全没绑定，手机端点它没有任何反应）
      if (e.target.closest('#menuBtn')) {
        e.preventDefault();
        menuOpen() ? closeMenu() : openMenu();
        return;
      }
      // 搜索入口：推开搜索面板（原先也是死按钮）
      if (e.target.closest('#searchBtn')) {
        e.preventDefault();
        openSheet();
        return;
      }
      if (e.target.closest('[data-close-sheet]')) { closeSheet(); return; }
      // 点菜单里的链接后就收起菜单，不占历史（马上要跳走）
      if (e.target.closest('#mobileNav a')) { closeMenu(true); return; }
      // 搜索快捷词
      var chip = e.target.closest('[data-q]');
      if (chip) {
        var si0 = $('#searchInput');
        if (si0) { si0.value = chip.getAttribute('data-q'); doSearch(si0.value); }
        return;
      }

      // 2026-10-23 Buy it now：先把当前变体加进车，成功即直达结账（失败给 toast，不静默）
      /* SHOPPATHS-20261023：数量选择器 +/− */
      var _qBtn = e.target.closest('[data-pdp-qty]');
      if (_qBtn) {
        e.preventDefault();
        var _wrap = _qBtn.closest('.qtyrow');
        var _val = _wrap ? _wrap.querySelector('[data-pdp-qty-val]') : null;
        var _inp = _wrap ? _wrap.querySelector('[data-pdp-qty-input]') : null;
        var _hint = _wrap ? _wrap.querySelector('[data-pdp-qty-hint]') : null;
        var _maxEl = document.getElementById('pdpStock');
        var _max = _maxEl ? parseInt(_maxEl.getAttribute('data-qty'), 10) || 99 : 99;
        var _n = Math.max(1, Math.min(_max, (parseInt(_inp ? _inp.value : 1, 10) || 1) + parseInt(_qBtn.getAttribute('data-pdp-qty'), 10)));
        if (_inp) _inp.value = _n;
        if (_val) _val.textContent = _n;
        if (_hint) {
          if (_n >= _max && _max < 99) { _hint.textContent = 'Only ' + _max + ' available'; _hint.hidden = false; }
          else { _hint.hidden = true; }
        }
        return;
      }

      var bn = e.target.closest('[data-buy-now]');
      if (bn) {
        e.preventDefault();
        var bvid = bn.getAttribute('data-variant-id');
        if (!bvid) return;
        var bLabel = bn.textContent.trim();
        var bBusy = bn.getAttribute('data-tpl-busy') || '…';
        bn.disabled = true;
        bn.textContent = bBusy;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(bvid), quantity: (function () { var i = document.querySelector('[data-pdp-qty-input]'); return i ? Math.max(1, parseInt(i.value, 10) || 1) : 1; })() })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); location.href = '/checkout'; })
          .catch(function () {
            bn.disabled = false;
            bn.textContent = bLabel;
            toast('Could not start checkout — please try again');
          });
        return;
      }

      // DRAWER-COMPACT-FOLD-20261023：展开 / 收起（抽屉）
      if (e.target.closest('[data-cart-fold]')) {
        e.preventDefault();
        cartFoldOpen = !cartFoldOpen;
        applyDrawerFold();
        return;
      }
      // CART-PAGE-COMPACT-20261023：展开 / 收起（购物车页）
      if (e.target.closest('[data-cart-fold-page]')) {
        e.preventDefault();
        cartPageFoldOpen = !cartPageFoldOpen;
        applyCartFold();
        return;
      }

      var add = e.target.closest('[data-add-to-cart]');
      if (add) {
        e.preventDefault();
        var vid = add.getAttribute('data-variant-id');
        if (!vid) return;
        /* SHOPPATHS-20261023：详情页数量选择器 —— 加购数量读当前值，其它入口（卡/抽屉/看货器）仍是 1 */
        var _qIn = add.closest('form') && add.closest('form').querySelector('[data-pdp-qty-input]');
        if (!_qIn) { var _gq = document.querySelector('[data-pdp-qty-input]'); if (_gq && !add.closest('#drawer') && !add.closest('.reels')) _qIn = _gq; }
        var _qty = _qIn ? Math.max(1, parseInt(_qIn.value, 10) || 1) : 1;
        /* CARD-LABEL-20261030：原来这里是 `var label = add.textContent`，每次点击现读。
           连点间隔 < 1.6s（按钮回滚时长）时按钮还显示 "Added ✓"，label 就被污染成 "Added ✓"
           ⇒ 回滚也回滚到 "Added ✓"，按钮**永久卡住**，只有刷新才恢复。
           线上实测：库存 6 件的卡连点 6 次加满后，按钮永久停在 "Added ✓"。
           与看货器分支（reelAdd 用 dataset.label）保持一致：首次点击存进 dataset，之后只读它。 */
        var label = add.dataset.label || (add.dataset.label = add.textContent.trim());
        /* 2026-10-23：原来加车只弹 2.4s 的 toast，抽屉不开 ——
           「商品卡 → Add to cart → 抽屉 Checkout」这条 3 次点击的路径实际断了，
           客户点完不知道该去哪。现在加车成功就开抽屉（看货器内/抽屉内/购物车页不动）。 */
        /* 推荐卡（购物车页 / 抽屉）：把卡片现成的图、名、价一起传下去，
           好让购物车页能立刻插一行占位，而不是等整页刷新。 */
        var _card = null;
        var _holder = add.closest('.cart-rec__item, .rec__item');
        if (_holder) {
          var _img = _holder.querySelector('img');
          var _nm = _holder.querySelector('.cart-rec__n, .rec__n');
          var _pr = _holder.querySelector('.cart-rec__p, .rec__p');
          _card = { img: _img ? _img.getAttribute('src') : '', title: _nm ? _nm.textContent.trim() : '', price: _pr ? _pr.textContent.trim() : '' };
        }
        /* 库存闸门：超了就地拒绝，不发请求、不显示 Added ✓（见上方 STOCK-GUARD-20261025） */
        var _over = stockGuard(add, vid, _qty);
        if (_over) return;
        var _adding = addToCart(vid, _qty, { card: _card, fast: true });   /* 卡片加购不开抽屉，不必等 cart.js */
        /* 🔴 CARD-ADD-NOJUMP-20261025（侯哥 20:46 截图报的硬 bug）：
           「合集页点 Add to cart 直接整页跳进购物车，要再加购必须关掉再返回」。
           根因：2026-10-23 为了修 PDP「加购后不知道去哪」，这里一刀切开抽屉，
           只排除了 看货器 / 抽屉内 / 购物车页，**没排除商品卡（.card__add）** ⇒
           合集页、首页、搜索页的卡片加购也会 openCart()，整页被抽屉盖住 + body 锁滚。
           正确行为：**商品卡加购就地反馈（按钮 Added ✓ + 角标 +1），留在原地可以连续加购**；
           只有 PDP 那两颗大按钮（#addBtn / 手机 .mobile-buy）才开抽屉看包邮进度并结账。 */
        var _isCard = add.classList.contains('card__add');
        if (!_isCard && !add.closest('#reels') && !add.closest('#drawer') && !document.body.classList.contains('template-cart')) {
          _adding.then(function (ok) { if (ok) openCart(); });
        }
        if (add.classList.contains('cart-rec__add')) {
          add.disabled = true;
          add.textContent = 'Added ✓';
          add.classList.add('is-added');
          /* 🔴 INSTANT-ADD-20261023：这里原来 `setTimeout(location.reload, 750)` ——
             一次整页刷新 2~4s，就是「总要加载才能显示」的真正原因。
             现在改为本地插占位行（见 insertPendingLine / settlePendingLines），**不再刷新**。
             服务端失败时 settlePendingLines 会把占位行撤掉，金额由 paintCart 校正。 */
        }
        if (add.classList.contains('rec__add')) {
          add.disabled = true;
          add.textContent = 'Added ✓';
          add.classList.add('is-added');
          /* 同上：锁住推荐区，别让 syncDrawerHTML 把 4 张图重下一遍（慢网下次要几十秒） */
          var _rb = $('#cartRec'); if (_rb) _rb.setAttribute('data-rec-lock', '1');
          /* 立刻在购物车列表顶部插一行「Adding…」，别让用户盯着不动的列表等几秒 */
          try { insertDrawerPendingLine(add); } catch (e) {}
        }
        if (add.classList.contains('card__add') || add.classList.contains('reel__add')) {
          /* 🔴 原来这里**无条件**写 Added ✓ —— 服务端 422 失败也照样显示成功（客户以为加上了）。
             现在按真实结果：成功才 Added ✓，失败显示原因并 1.6s 后恢复。 */
          _adding.then(function (ok) {
            if (ok) {
              add.textContent = 'Added ✓';
              add.classList.add('is-added');
            } else {
              add.textContent = 'Not added';
              add.style.opacity = '.6';
            }
            setTimeout(function () {
              add.textContent = label;
              add.classList.remove('is-added');
              add.style.opacity = '';
            }, 1600);
          });
        }
        /* ADD-BLUE-UNIFY-20261024：详情页那两颗大按钮（桌面 #addBtn / 手机 .mobile-buy .btn）
           也要有「√」反馈。不能改 textContent —— 桌面那颗里面有 <span id="addPrice">，
           换掉会把价格节点一起销毁。所以只加状态类，✓ 由 CSS ::before 画。 */
        if (!add.classList.contains('cart-rec__add') && !add.classList.contains('rec__add') &&
            !add.classList.contains('card__add') && !add.classList.contains('reel__add')) {
          add.classList.add('is-added');
          setTimeout(function () { add.classList.remove('is-added'); }, 1500);
        }
        return;
      }

      var reelAdd = e.target.closest('[data-reel-add]');
      if (reelAdd) {
        var slide = reelAdd.closest('.reel');
        /* ADD-BLUE-UNIFY-20261024：看货器按钮带的是 data-reel-add（不是 data-add-to-cart），
           原来走这条分支加车后**没有任何反馈**；补「Added ✓」+ 蓝底状态，和全站一致。 */
        /* _label 必须缓存「原始文案」：原来每次点击都读当前 textContent，
           1.6s 内连点第二次就会把 "Added ✓" 当成原始文案存下来 ⇒ 按钮永久停在 Added ✓。 */
        var _label = reelAdd.dataset.label || (reelAdd.dataset.label = reelAdd.textContent);
        var _rvid = slide ? slide.getAttribute('data-variant-id') : '';
        /* 🔴 STOCK-GUARD-20261025：原来这里 `addToCart(...)` 的 Promise 被丢掉、下一行**无条件**
           写 Added ✓ —— 侯哥 21:10 截图「库存只剩 1 件却能无限加购」看到的就是这个假成功。
           现在：先按 slide 的 data-inv 拦，再按真实结果反馈。 */
        var _rover = slide ? stockGuard(slide, _rvid, 1) : null;
        if (_rover) {
          reelAdd.classList.add('is-shake');
          setTimeout(function () { reelAdd.classList.remove('is-shake'); }, 420);
          return;
        }
        /* ⚠️ 防连点：加购要等 /cart/add.js 跨境一个来回（实测 600~850ms），
           这段窗口里用户会以为没点上而连按 ⇒ 同 SKU 变成 2 件、3 件。
           用 dataset.busy 拦（不用 disabled：disabled 会连带改样式，恢复时还要判断库存）。 */
        if (reelAdd.dataset.busy === '1') return;
        reelAdd.dataset.busy = '1';
        /* REEL-ADD-FAST-20261029：0ms 就给反馈 —— 按钮立刻进 Adding…，不再是「点了没动静」 */
        reelAdd.textContent = 'Adding…';
        /* 上一次的绿底 is-added 必须先摘掉，否则「绿底 + 扫光」同时存在，看着像已完成又在转 */
        reelAdd.classList.remove('is-added');
        reelAdd.style.opacity = '';
        reelAdd.classList.add('is-loading');
        try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) {}   /* Android 上「点到了」的手感，iOS 静默忽略 */
        var _radd = slide ? addToCart(_rvid, 1, { fast: true }) : Promise.resolve(false);
        _radd.then(function (ok) {
          reelAdd.dataset.busy = '';
          reelAdd.classList.remove('is-loading');
          reelAdd.textContent = ok ? 'Added ✓' : 'Not added';
          reelAdd.classList.add('is-added');
          if (!ok) reelAdd.style.opacity = '.6';
          /* 复位定时器要可取消：连点第二次时若上一次的定时器还在，会把
             「Adding…」直接刷回 Add to cart，看着像没点上。 */
          if (reelAdd.__resetT) clearTimeout(reelAdd.__resetT);
          reelAdd.__resetT = setTimeout(function () {
            reelAdd.textContent = _label;
            reelAdd.classList.remove('is-added');
            reelAdd.style.opacity = '';
            reelAdd.__resetT = 0;
          }, 1600);
        });
        return;
      }

      // 播放器入口
      var opener = e.target.closest('[data-reels-open]');
      if (opener) {
        e.preventDefault();
        /* 🔴 DRAWER-RECS-REELS-20261023（2026-10-23 07:4x 侯哥报「抽屉里推荐卡点了没反应」）
           实况（tools/_diag_drawer_recs_click_20261023.js）：点完 reels 确实 on 了、40 张卡也加载了，
           但抽屉 z-index 2100 ＞ 看货器 2000 ⇒ 看货器在抽屉**底下**打开，用户什么变化都看不到。
           先把抽屉视觉让开再走原逻辑。注意不能用 closeCart()：它会 backIfTop('cart') → history.back()
           → popstate 把紧接着 push 的 'reels' 记录弹掉，看货器会瞬间自己关掉（跟 #reelsCart 同一个坑）。 */
        if (opener.closest('#drawer')) {
          var _d = $('#drawer'), _o = $('#overlay');
          if (_d) { _d.classList.remove('on'); _d.setAttribute('aria-hidden', 'true'); }
          if (_o) _o.classList.remove('on');
          document.body.classList.remove('locked', 'drawer-open');
          resumePageVideos();
          var _ci = panelStack.lastIndexOf('cart');
          if (_ci >= 0) panelStack.splice(_ci, 1);
        }
        /* 2026-10-23：从搜索结果点进去时，搜索面板必须收起。
           原来面板留在看货器底下（点完再关看货器就看到一个还开着的搜索层），
           而且这里不能调 closeSheet() —— 它会 history.back()，把 openReels 刚 push 的条目弹掉。
           所以只做视觉收起 + 摘栈。 */
        var ssheet = document.getElementById('searchSheet');
        if (ssheet && ssheet.classList.contains('on')) {
          ssheet.classList.remove('on');
          ssheet.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('locked', 'sheet-open');
          var shi = panelStack.lastIndexOf('sheet');
          if (shi >= 0) panelStack.splice(shi, 1);
        }
        /* 2026-10-23：feed 里没有这张卡就先按它所属系列重建，避免「点 A 看 B」 */
        openReelsForHandle(opener.getAttribute('data-reels-open'), opener.getAttribute('href'));
        return;
      }

      // 2026-10-23 修「看货器里点购物车没反应」：
      // ① 抽屉 z-index 910 ＜ 看货器 2000 ⇒ 抽屉其实开了，但被整块压住（用户看到"没反应"）；
      // ② 直接调 closeReels() 也不行：它内部 backIfTop('reels') 会 history.back()，
      //    popstate 回调随后把 panelStack 里刚 push 的 'cart' 弹掉 ⇒ 抽屉瞬间被关。
      // 所以这里只做「视觉关闭 + 摘掉栈里的 reels」，history 一步不动，再开抽屉。
      if (e.target.closest('#reelsCart, [data-reel-opencart], .reel__go')) {
        e.preventDefault();
        var rb = reelsEl();
        if (rb && rb.classList.contains('on')) {
          rb.classList.remove('on');
          rb.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('reels-open');
          $$('video', feedEl()).forEach(function (v) { v.pause(); });
          var ri = panelStack.lastIndexOf('reels');
          if (ri >= 0) panelStack.splice(ri, 1);
        }
        openCart();
        return;
      }
      if (e.target.closest('#openCart')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('#closeCart, [data-close-cart], #overlay')) { closeCart(); return; }
      if (e.target.closest('#reelsClose')) { closeReels(); return; }

      // 缩略图
      var thumb = e.target.closest('.thumb[data-kind]');
      if (thumb) {
        $$('.thumb').forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
        if (thumb.getAttribute('data-kind') === 'video') {
          setPdpMedia(true);
        } else {
          var src = thumb.getAttribute('data-src');
          var img = $('.pm__img');
          if (src && img) img.src = src;
          setPdpMedia(false);
        }
        return;
      }

      // 视频播放/暂停
      var vb = e.target.closest('[data-video]');
      if (vb) {
        var v = document.getElementById(vb.getAttribute('data-video'));
        if (!v) return;
        if (v.paused) { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); vb.style.opacity = 1; }
        else { v.pause(); vb.style.opacity = 0.6; }
        return;
      }

      // 静音
      var mb = e.target.closest('[data-mute]');
      if (mb) {
        var mv = document.getElementById(mb.getAttribute('data-mute'));
        if (!mv) return;
        mv.muted = !mv.muted;
        mb.style.opacity = mv.muted ? 0.75 : 1;
        if (!mv.muted && mv.paused) mv.play().catch(function () {});
        return;
      }

      // 播放器内静音
      var rm = e.target.closest('[data-mute-reel]');
      if (rm) {
        reelsMuted = !reelsMuted;
        $$('video', feedEl()).forEach(function (x) { x.muted = reelsMuted; });
        $$('[data-mute-reel]').forEach(function (b) {
          b.classList.toggle('is-on', !reelsMuted);
          b.setAttribute('aria-pressed', String(!reelsMuted));
        });
        return;
      }

      // REELS-TABS-20261026：VIDEO / PHOTO 切换（只对有视频的卡存在）
      var tab = e.target.closest('[data-reel-tab]');
      if (tab) {
        var tsl = tab.closest('.reel');
        if (tsl) {
          var toPhoto = tab.getAttribute('data-reel-tab') === 'photo';
          tsl.classList.toggle('is-photo', toPhoto);
          var tv = tsl.querySelector('video');
          if (tv) {
            if (toPhoto) tv.pause();
            else { tv.muted = reelsMuted; var tp = tv.play(); if (tp && tp.catch) tp.catch(function () {}); }
          }
          var tabs = tsl.querySelectorAll('[data-reel-tab]');
          for (var ti = 0; ti < tabs.length; ti++) tabs[ti].classList.toggle('on', tabs[ti] === tab);
        }
        return;
      }

      // 播放/暂停整条 reel
      if (e.target.closest('.reel__tap')) {
        var slide2 = e.target.closest('.reel');
        /* 停在 PHOTO 视图时，点画面不该偷偷把视频播起来（看不见却有声/耗流量） */
        if (slide2 && slide2.classList.contains('is-photo')) return;
        var rv = slide2 && slide2.querySelector('video');
        if (rv) { if (rv.paused) rv.play().catch(function () {}); else rv.pause(); }
        return;
      }

      // 数量增减
      var qd = e.target.closest('[data-qty-down], [data-qty-up]');
      if (qd) {
        var row = qd.closest('[data-line-key]');
        var key = row && row.getAttribute('data-line-key');
        if (!key) return;
        var cur = parseInt(row.querySelector('[data-qty-val]').textContent, 10) || 1;
        var next = qd.hasAttribute('data-qty-down') ? Math.max(0, cur - 1) : cur + 1;
        /* 🔴 CART-QTY-CAP-20261030：加号先按**真实库存**封顶，给一句人话，
           而不是让服务端把数字改回去（客户会以为按钮坏了）。减号不受影响。 */
        if (!qd.hasAttribute('data-qty-down')) {
          var _left = cartLineStockLeft(row);
          if (_left !== null && next > _left) {
            toast(_left > 0 ? ('Only ' + _left + ' in stock — that’s all we have') : 'Sold out — this card is gone');
            return;
          }
        }
        /* 减到 0 语义上就是移除：走同一条幂等链路，否则慢网下同样会留残件 */
        if (next === 0) markRemoveLine(row);
        else changeLine(key, next);
        return;
      }

      var rmLine = e.target.closest('[data-remove]');
      if (rmLine) {
        var r2 = rmLine.closest('[data-line-key]');
        if (r2 && r2.getAttribute('data-removing') === '1') return;   // 同一行重复点：忽略
        if (r2) {
          r2.setAttribute('data-removing', '1');
          _pendingRemove[r2.getAttribute('data-line-key') || ''] = 1;
          /* PERF-CART-20261023：Shopify 的 /cart/change.js 实测 0.8~3.3s（跨境 + 服务端），
             等它回来再删行 = 用户点了半天没反应。这里**乐观**：立刻淡出并摘掉这一行，
             视觉 0 延迟；服务端失败时 catch 分支会 fetchCart + 整块重建把行放回来。
             ⚠️ 只对「移除」这么做。改数量不能乐观（库存不足会被 Shopify 改成别的值）。 */
          var _row = r2;
          _row.style.transition = 'opacity .16s var(--ease)';
          _row.style.opacity = '0';
          setTimeout(function () {
            if (_row.parentNode) _row.parentNode.removeChild(_row);
            try { applyCartFold(); } catch (e) {}
            try { applyDrawerFold(); } catch (e) {}
          }, 160);
          /* REMOVE-ALL-20261025：不再逐行排队 change.js（慢网 3s×N 会把用户逼到手刷），
             改走 合并 + 幂等 + 卸载 beacon 兜底（见 flushRemoveIntents） */
          markRemoveLine(r2);
        }
        return;
      }

      // PDP 播放提示
      if (e.target.closest('#pmSwitch')) {
        var pv = $('#pdpVideo');
        if (pv) { var p3 = pv.play(); if (p3 && p3.catch) p3.catch(function () {}); }
        return;
      }

      // 手风琴
      var acc = e.target.closest('.acc__btn');
      if (acc) {
        var item = acc.parentElement;
        var panel = item.querySelector('.acc__panel');
        var wasOpen = item.classList.contains('open');
        $$('.acc__item', item.parentElement).forEach(function (i) {
          i.classList.remove('open');
          var p = i.querySelector('.acc__panel');
          if (p) p.style.height = '0px';
          var b = i.querySelector('.acc__btn');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('open');
          if (panel) panel.style.height = panel.scrollHeight + 'px';
          acc.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      // 页内锚点
      var jump = e.target.closest('[data-jump]');
      if (jump) {
        e.preventDefault();
        var el = document.getElementById(jump.getAttribute('data-jump'));
        if (el) {
          var top = el.getBoundingClientRect().top + window.scrollY - 72;
          window.scrollTo({ top: top, behavior: 'smooth' });
          setTimeout(function () {
            var now = el.getBoundingClientRect().top;
            if (now > 160 || now < -160) window.scrollTo({ top: top, behavior: 'auto' });
          }, 450);
        }
        return;
      }
    });

    // 键盘
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var top = topPanel();
      if (top === 'cart') closeCart();
      else if (top === 'reels') closeReels();
      else if (top === 'sheet') closeSheet();
      else if (top === 'menu') closeMenu();
    });

    /* 浏览器后退（手机边缘右滑）：只关最上面那层面板，绝不退出站点。
       这里直接弹栈、不再调 history，否则会和 backIfTop 互相触发。 */
    window.addEventListener('popstate', function () {
      var name = panelStack.pop();
      if (!name) return;
      if (name === 'cart') closeCart(true);
      else if (name === 'reels') closeReels(true);
      else if (name === 'sheet') closeSheet(true);
      else if (name === 'menu') closeMenu(true);
    });

    /* 搜索：边输边出（220ms 防抖），走 Shopify Predictive Search API */
    var si = $('#searchInput');
    if (si) {
      si.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var q = si.value;
        searchTimer = setTimeout(function () { doSearch(q); }, 220);
      });
    }

    /* ================= 2026-10-24 13:0x REELS-COUNTER-LIVE-20261024 =================
       侯哥 13:02：「3/40 比如这个 3 滑动这个增减数字变化有问题，必须停下来才能加减显示，
       刷过程一直卡着不动」
       根因：整段逻辑（算 index + 换视频 + 写计数 + 续拉）都塞在 scroll 事件的
             **90ms setTimeout 防抖**里 —— 手指不停，scroll 事件就一直重置定时器 ⇒
             定时器根本不会触发，计数全程停在滑动前的旧值，只有手指停下来才跳一次。
       修法：拆两层
         · 计数/续拉：requestAnimationFrame 节流（每帧最多一次，跟手实时变）；
         · 视频播放/图片 hydrate：保留 70ms 防抖（快速掠过时不该每张都 play/pause）。
       ====================================================================== */
    var feed = feedEl();
    if (feed) {
      var rafPend = false, tPlay = 0;
      function onReelScroll() {
        rafPend = false;
        var h = feed.clientHeight || 1;
        var n = feed.children.length;
        if (!n) return;
        var i = Math.round(feed.scrollTop / h);
        if (i < 0) i = 0; else if (i > n - 1) i = n - 1;
        if (i !== reelsIdx) {
          reelsIdx = i;
          updateCounter();                       // 跟手实时
          clearTimeout(tPlay);
          tPlay = setTimeout(function () { playReelAt(reelsIdx); }, 70);
        }
        /* REELS-FEED-20261024：离末尾还剩 4 张就续拉下一批，买家一直刷得下去 */
        if (i >= n - 4) appendReelPage();
      }
      feed.addEventListener('scroll', function () {
        if (rafPend) return;
        rafPend = true;
        requestAnimationFrame(onReelScroll);
      }, { passive: true });
    }

    // 主视频状态 → 决定要不要露出播放入口
    var pv2 = $('#pdpVideo');
    if (pv2) {
      ['play', 'pause', 'playing'].forEach(function (ev) { pv2.addEventListener(ev, syncPaused); });
      syncPaused();
      setTimeout(syncPaused, 1200);
      setTimeout(syncPaused, 3000);
    }
    /* PDP-LADDER-20261102：详情页主视频弱网降档（无兜底源时函数内部直接返回） */
    try { initPdpVideoLadder(); } catch (e) {}

    initLoadMore();
    initLoadMoreAuto();   // COLL-AUTOLOAD-20261025：滚到底自动续，不用点
    initSearchInfinite();   // SEARCH-INFINITE-20261024
    initSearchFallback();   // SEARCH-FUZZY-20261026：搜索页 0 结果时用本地索引兜底（搜 1144 能出 Y1144）
    initCollector();

    // 初次拉一次真实购物车（首屏可能是缓存页）
    fetchCart();

    // 每 5 分钟刷新送达时间（跨过截单点时提示要跟着变）
    setInterval(paintDelivery, 300000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    try { applyDrawerFold(); } catch (e) {}
    try { applyCartFold(); } catch (e) {}
  });

  /* 通知 head 里那段抢占脚本「可以交棒了」，并补开它替我们拦下来的那次点击 */
  try {
    window.__bbReelsReady = true;
    if (window.__bbPendingReel) {
      var _ph = window.__bbPendingReel; window.__bbPendingReel = null;
      setTimeout(function () { openReelsForHandle(_ph, null); }, 0);
    }
  } catch (e) {}

  /* SHARE-CARD-DEEP-20261031（侯哥 23:5x：「扫码应该直接进看货器，看完这张还能继续滑」）
     ------------------------------------------------------------------
     `?reels=<handle>` = 直接开看货器并定位到这张卡；不再落商品详情页。
     来源两处（缺一不可）：
       ① 当前 URL —— 正常扫码首访；
       ② localStorage['bb_reels_deeplink'] —— 带 ref 的新客会先被 BB_UPGRADE_DISCOUNT
          跳一次 /discount/FRIEND10?redirect=/，回来 query 全丢，只能靠 head 里那段存的值。
     时机很重要：本文件是 defer，但看货器的 feed / openReels 要等 init() 跑完才可用
     ⇒ 用轮询重试（最多 100×400ms = 40s），只调一次打开，只认「看货器真开了」。
     🔴 不能只 setTimeout 一次：慢网下 init 还没跑完，那一次就白丢了（2026-10-31 实测）。 */
  (function () {
    var h = '';
    try {
      var m = location.search.match(/[?&]reels=([^&]+)/);
      if (m) h = decodeURIComponent(m[1]);
      if (!h) {
        var raw = localStorage.getItem('bb_reels_deeplink') || '';
        var seg = raw.split('|');
        if (seg[0] && (!seg[1] || Date.now() - Number(seg[1]) < 600000)) h = seg[0];
      }
      if (!h) {
        var cm = document.cookie.match(/(?:^|;\s*)bb_reels=([^;]+)/);
        if (cm) h = decodeURIComponent(cm[1]);
      }
    } catch (e) {}
    h = String(h || '').toLowerCase().replace(/[^a-z0-9-]/g, '');
    if (!h) return;
    window.__bbDeepHandle = h;
    /* 🔴 这里绝不能「调用即算成功」：openReelsForHandle 内部可能先 seed feed 再开，
       是**异步**的，返回时看货器还没开。早期版本调用后立刻 opened=true，导致 6 秒后
       误判失败、兜底把客户送到商品页 —— 就是侯哥看到的「扫码还是进详情页」（2026-10-31 实测）。
       现在只认「body.reels-open 真的出现」，并且给到 24 秒（慢网真机要 5~10 秒）。 */
    var tries = 0, called = false, done = false;
    function clearMark() {
      try { localStorage.removeItem('bb_reels_deeplink'); } catch (e) {}
      try { document.cookie = 'bb_reels=;path=/;max-age=0;samesite=lax'; } catch (e) {}
    }
    function go() {
      tries++;
      if (done) return;
      try {
        if (document.body && document.body.classList.contains('reels-open')) {
          done = true;
          /* 撤掉「等深链」的遮罩 class（theme.liquid 里加的），首页内容立刻回来 */
          try { document.documentElement.classList.remove('bb-deeplink'); } catch (e) {}
          setTimeout(clearMark, 8000);
          return;
        }
        if (!called && window.__bbReelsReady && window.BB && typeof window.BB.openReels === 'function') {
          called = true;
          /* 🔴 直接用 window.BB.openReels(handle)：它自带「按 handle 找下标并滚过去」，
             不碰 seed、不等异步回调 ⇒ 快 3~5 倍、也不会静默失败（2026-10-31 实测：
             openReelsForHandle 要 seedReelFeed，慢且失败时什么都不做，客户就停在首页）。
             只有当这张卡不在静态 feed（前 50 张）里时，才回落到 openReelsForHandle 去拉数据。 */
          var inFeed = false;
          try { inFeed = !!document.querySelector('.reel[data-handle="' + h + '"]'); } catch (e) {}
          if (inFeed) window.BB.openReels(h);
          else openReelsForHandle(h, null);
        }
      } catch (e) {}
      if (tries < 100) { setTimeout(go, 400); return; }   /* 40s 上限：真机慢网 5~10s，慢设备也给足余量 */
      /* 40 秒还开不出来（脚本被打断 / 极端环境）：退到商品页，好过停在首页什么都不发生。
         ⚠️ 这个兜底绝不能提前：真机慢网 5~10s 才开得出来，早了就会把客户送进详情页 ——
            侯哥 2026-10-31 报的「扫码还是进详情页」正是这一类（旧图 + 过早兜底）叠加。 */
      try { clearMark(); location.replace('/products/' + h); } catch (e) {}
    }
    if (document.readyState === 'complete') setTimeout(go, 100);
    else {
      window.addEventListener('load', function () { setTimeout(go, 100); });
      setTimeout(go, 300);          /* 不等 load 就开始试：真机上 load 常常 3~5s */
    }
  })();

  window.BB = { openCart: openCart, closeCart: closeCart, openReels: openReels,
                closeReels: closeReels, addToCart: addToCart, refreshCart: fetchCart,
                openMenu: openMenu, closeMenu: closeMenu,
                openSheet: openSheet, closeSheet: closeSheet, search: doSearch };
})();

/* 新品预告条倒计时（2026-10-22 · 与预览站同构）
   分段数字格 02d 14:59:57，1 秒一跳。
   · 数字等宽 + 固定两位 ⇒ 跳秒时整条宽度不变
   · 每秒只改 <b data-u> 的文本，不重建 DOM
   · 到点把标签切成 Just dropped，并把格子换成 LIVE */
(function () {
  function pad2(n){ return (n < 10 ? '0' : '') + n; }
  function parts(ms){
    if(ms < 0) ms = 0;
    var t = Math.floor(ms / 1000);
    return { d: Math.floor(t / 86400), h: Math.floor(t % 86400 / 3600), m: Math.floor(t % 3600 / 60), s: t % 60, long: t > 7 * 86400 };
  }
  function blocks(ms){
    if(ms <= 0) return '<span class="cdb cdb--live"><b>LIVE</b></span>';
    var p = parts(ms);
    function cell(v, u){ return '<span class="cdb"><b data-u="' + u + '">' + pad2(v) + '</b><i>' + u + '</i></span>'; }
    var out = '';
    if(p.d > 0) out += cell(p.d, 'd');
    out += cell(p.h, 'h') + cell(p.m, 'm') + (p.long ? '' : cell(p.s, 's'));
    return out;
  }
  function tick(){
    var els = document.querySelectorAll('[data-cd]');
    for(var i = 0; i < els.length; i++){
      var raw = els[i].getAttribute('data-cd');
      if(!raw) continue;
      var at = Date.parse(raw);
      if(isNaN(at)) continue;
      var left = at - Date.now();
      if(!els[i].querySelector('.cdb')){ els[i].innerHTML = blocks(left); }
      var cells = els[i].querySelectorAll('.cdb b[data-u]');
      if(cells.length){
        var p = parts(left);
        for(var k = 0; k < cells.length; k++){
          var u = cells[k].getAttribute('data-u');
          var v = pad2(p[u] == null ? 0 : p[u]);
          if(cells[k].textContent !== v) cells[k].textContent = v;
        }
        if(left <= 0) els[i].innerHTML = blocks(0);
      }
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);
  else tick();
  setInterval(tick, 1000);
})();

/* 导航「More」下拉（2026-10-22） */
(function(){
  function init(){
    var more=document.querySelector('.nav__more'); if(!more) return;
    var btn=more.querySelector('.nav__more-btn');
    btn.addEventListener('click', function(e){
      e.stopPropagation();
      var open=more.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function(){ more.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ more.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); } });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* 进场动画（2026-10-22 补）：CSS 里 html.js .reveal 才隐藏，
   这里负责加 js 类 + 观察器；任何一步失败都不会让内容消失。 */
(function(){
  if(!('IntersectionObserver' in window)) return;   /* 不支持就不加 js 类 ⇒ 内容全显示 */
  document.documentElement.classList.add('js');
  function observe(){
    var els=[].slice.call(document.querySelectorAll('.reveal:not(.in)'));
    if(!els.length) return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{rootMargin:'0px 0px -10% 0px',threshold:0.05});
    els.forEach(function(el){ io.observe(el); });
    /* 兜底：3 秒后仍没露出的，强行显示（防止被裁切/隐藏容器困住） */
    setTimeout(function(){ els.forEach(function(el){ el.classList.add('in'); }); }, 3000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', observe); else observe();
})();

/* 商品卡图淡入（2026-10-22）：img 的 load 不冒泡，用捕获阶段统一处理 */
(function(){
  function mark(img){ if(img && img.tagName==='IMG' && img.closest && img.closest('.card__media')) img.classList.add('is-loaded'); }
  document.addEventListener('load', function(e){ mark(e.target); }, true);
  // 加载失败也要露出来（否则永久停在米色占位，看不出是坏图）
  document.addEventListener('error', function(e){ mark(e.target); }, true);
  function sweep(){ [].forEach.call(document.querySelectorAll('.card__media img'), function(i){ if(i.complete && i.naturalWidth) mark(i); }); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', sweep); else sweep();
  setTimeout(sweep, 1500);
})();

/* 购物车「显示更多」（2026-10-22） */
(function(){
  function init(){
    var btn=document.getElementById('cartMore'), box=document.getElementById('cartExtra');
    if(!btn||!box) return;
    btn.addEventListener('click', function(){
      var open=box.hasAttribute('hidden');
      if(open) box.removeAttribute('hidden'); else box.setAttribute('hidden','');
      btn.setAttribute('aria-expanded', open?'true':'false');
      btn.textContent = open ? 'Show less' : ('Show '+btn.getAttribute('data-rest')+' more items');
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ==================================================================
   CATEGORIES-L1-20261023 · 分类总览页交互
   纯客户端：174 个合集已经在 HTML 里，搜索/Tab/字母都只做显隐与滚动，
   不发任何请求 —— 所以输入即时响应，没有「加载中」。
   ================================================================== */
(function(){
  var body = document.getElementById('l1body');
  if(!body) return;
  var q = document.getElementById('l1q');
  var clearBtn = document.getElementById('l1clear');
  var tabs = document.getElementById('l1tabs');
  var alpha = document.getElementById('l1alpha');
  var nomatch = document.getElementById('l1nomatch');
  var grps = [].slice.call(body.querySelectorAll('.l1grp'));
  var curTab = 'all';

  function norm(s){ return (s||'').toLowerCase().trim(); }

  function apply(){
    var term = norm(q ? q.value : '');
    var shown = 0;
    grps.forEach(function(g){
      var k = g.getAttribute('data-k');
      var tabOK = (curTab === 'all') || (curTab === k);
      var vis = 0;
      g.querySelectorAll('.l1t').forEach(function(t){
        var hit = !term || norm(t.getAttribute('data-n')).indexOf(term) !== -1;
        var ok = tabOK && hit;
        t.style.display = ok ? '' : 'none';
        if(ok) vis++;
      });
      g.style.display = (tabOK && vis > 0) ? '' : 'none';
      shown += vis;
      var cnt = g.querySelector('.l1grp__h span');
      if(cnt) cnt.textContent = vis;
    });
    if(nomatch) nomatch.hidden = shown > 0;
    if(clearBtn) clearBtn.hidden = !term;
    buildAlpha();
  }

  function buildAlpha(){
    if(!alpha) return;
    alpha.hidden = (curTab !== 'char') || !!(q && norm(q.value));
    if(alpha.hidden) return;
    var have = {};
    body.querySelectorAll('.l1t[data-l]').forEach(function(t){
      if(t.style.display !== 'none') have[t.getAttribute('data-l')] = 1;
    });
    var letters = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    alpha.innerHTML = letters.map(function(L){
      return '<button type="button" data-l="'+L+'"'+(have[L]?'':' class="dim"')+'>'+L+'</button>';
    }).join('');
  }

  if(q) q.addEventListener('input', apply);
  if(clearBtn) clearBtn.addEventListener('click', function(){ q.value=''; apply(); q.focus(); });

  if(tabs) tabs.addEventListener('click', function(e){
    var b = e.target.closest('.l1tab'); if(!b) return;
    [].forEach.call(tabs.querySelectorAll('.l1tab'), function(x){ x.classList.toggle('on', x===b); });
    curTab = b.getAttribute('data-k');
    apply();
  });

  if(alpha) alpha.addEventListener('click', function(e){
    var b = e.target.closest('button'); if(!b) return;
    var L = b.getAttribute('data-l');
    var t = body.querySelector('.l1grp[data-k="char"] .l1t[data-l="'+L+'"]');
    if(t){
      t.scrollIntoView({ behavior:'smooth', block:'center' });
      t.style.transition = 'background .3s';
      t.style.background = '#e8e8ec';
      setTimeout(function(){ t.style.background = ''; }, 900);
    }
  });

  // 首页 5 个入口带过来的 ?g=char
  // 2026-10-25：该分组若已没有任何有货分类（例如 ?g=collab —— 13 个联动分类全是空壳、已全部下线），
  // 对应 tab 不存在 ⇒ 停在 All，并把 ?g= 从地址栏抹掉，免得用户以为筛选生效、或把死参数分享出去。
  try{
    var g = new URLSearchParams(location.search).get('g');
    if(g){
      var hit = tabs && tabs.querySelector('.l1tab[data-k="'+g+'"]');
      if(hit){
        hit.click();
      } else {
        var u = new URL(location.href);
        u.searchParams.delete('g');
        history.replaceState(null, '', u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash);
      }
    }
  }catch(err){}
})();


/* ==================================================================
   WALLET-EMPTY-20261023 · 钱包行空壳兜底
   平台在 additional_checkout_buttons 为 true 时会输出
   <shopify-accelerated-checkout-cart>，再由 shop.js 异步注入按钮。
   实测店铺（Shop Pay / Apple Pay 未启用）该容器渲染不出任何按钮，
   PDP 上就只剩一句悬空的 "or check out with a card" —— 买家会以为加载失败。
   处理：判空就整块隐藏（钱包行 + 分隔文案），并对外发一个事件便于断言。
   ================================================================== */
(function () {
  // 🔴 实测真相（2026-10-23 二次定位）：
  //   平台不是「什么都不渲染」，而是渲染 3 个 167x54 的 **骨架占位块**
  //   .wallet-cart-button.wallet-cart-button__skeleton（innerHTML 只有一个 &nbsp;），
  //   再也没被 shop.js 换成真按钮 ⇒ PDP 上凭空多出 186px 的灰块 +
  //   一句悬空的 "or check out with a card"。买家看到的就是「页面挂了」。
  //   ⇒ 判空必须跳过 skeleton / placeholder 类元素，只认真正可点的。
  function isEmpty(el) {
    if (!el) return false;
    var kids = el.querySelectorAll('button,iframe,input[type=image],a[role="button"],[role="button"]');
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      var cn = (k.className || '').toString();
      if (/skeleton|placeholder/i.test(cn)) continue;
      var cs = getComputedStyle(k);
      var r = k.getBoundingClientRect();
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.width > 8 && r.height > 8) return false;
    }
    return true;
  }
  // 每次重算（幂等 toggle）：不能像第一版那样打一次性 checked 标记 ——
  // 那样 shop.js 晚 2 秒注入真按钮时再也不会恢复，钱包按钮就被永久藏了。
  function sweep() {
    var rows = document.querySelectorAll('.wallet-row--pdp');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var empty = isEmpty(row);
      row.classList.toggle('is-empty', empty);
      var or = row.nextElementSibling;
      if (or && or.classList.contains('pdp__or')) or.hidden = empty;
      window.__bbWalletEmpty = empty;
      document.documentElement.setAttribute('data-wallet-empty', empty ? '1' : '0');
    }
  }
  function boot() {
    // shop.js 是异步注入的：立刻扫一次，再 1.2s / 3s 各补一次（注入慢时不误杀）
    sweep();
    // shop.js 注入真按钮的时间不确定：多档补扫，出现真按钮就自动取消隐藏
    setTimeout(sweep, 600);
    setTimeout(sweep, 1500);
    setTimeout(sweep, 3000);
    setTimeout(sweep, 6000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* ============================================================================
   2026-10-25 · 首屏 15 格标题「单行 + 字号自适应」
   CSS 无法按可用宽度缩放字体，这里用实测宽度逐级降字号（每次 -0.5px，下限 9px）。
   全部用完再兜底省略号 —— 保证不换行、不出现半截字。
   ============================================================================ */
(function () {
  var MIN = 9;
  function fitOne(el) {
    el.style.fontSize = '';
    el.style.textOverflow = 'clip';
    var base = parseFloat(getComputedStyle(el).fontSize) || 13;
    var size = base, guard = 0;
    while (el.scrollWidth > el.clientWidth + 0.5 && size > MIN && guard < 40) {
      size -= 0.5; guard++;
      el.style.fontSize = size + 'px';
    }
    if (el.scrollWidth > el.clientWidth + 0.5) el.style.textOverflow = 'ellipsis';
  }
  function fitMiniNames() {
    var list = document.querySelectorAll('.cats .mini--block .mini__n');
    for (var i = 0; i < list.length; i++) fitOne(list[i]);
  }
  var t = null;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(fitMiniNames, 120);
  }
  function boot() {
    fitMiniNames();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitMiniNames);
    window.addEventListener('resize', schedule, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(schedule);
      var grid = document.querySelector('.cats .mini-grid');
      if (grid) ro.observe(grid);
    }
    /* 图片加载完可能改变 flex 基准宽度，再补一次 */
    window.addEventListener('load', fitMiniNames);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ============================================================================
   BB-STOCK-BOOT-20261029 —— 把静态 Liquid 渲染出来的库存节点也拉进展示口径。
   Liquid 只负责把「真实库存 + handle」挂到 data-bbs-qty / data-bbs-key 上，
   数字一律由 BBStock 改写，保证：商品卡 / PDP / 看货器 / 购物车推荐 四处同一个值。
   动态插入的节点（看货器换卡、购物车推荐、搜索现拼）靠 MutationObserver 补刷，
   用 data-bbs-shown 打标记防止自我触发死循环。
   ============================================================================ */
(function () {
  'use strict';
  function run() {
    if (!window.BBStock) return;
    var list = document.querySelectorAll('[data-bbs-qty]:not([data-bbs-shown])');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      el.setAttribute('data-bbs-shown', 'pending');
      if (el.getAttribute('data-bbs-avail') === 'false') continue;
      var r = BBStock.shown(el.getAttribute('data-bbs-key') || '', el.getAttribute('data-bbs-qty'), true);
      if (r.out) continue;
      el.textContent = r.q <= BBStock.lowAt ? ('Only ' + r.q + ' left') : (r.q + ' in stock');
      el.setAttribute('data-bbs-shown', r.q);
      el.classList.toggle('is-low', r.q <= BBStock.lowAt);
    }
  }
  function boot() {
    run();
    if (!document.body || !window.MutationObserver) return;
    var t = null;
    var mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 60);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', function () { setTimeout(run, 120); });
})();

/* ============================================================================
   BB-STOCK-LIVE-20261029 —— 库存实况监控（极端并发兜底）
   侯哥 12:38：「几个客户同时下单某张卡瞬间没有库存，能不能瞬间补回，一定要把极端考虑进去」
   ----------------------------------------------------------------------------
   先认事实（2026-10-29 实测，别记错）：
     · 全店 250 个在售商品 **policy=DENY** ⇒ 服务端不会超卖，库存归 0 就是真没货；
     · 但 `/cart/add.js` **不校验库存**（购物车不是预留）⇒ 「加满一车去结账才发现没货」是真实风险；
     · 库存 ≤5 会被 inv-sync 自动从货架摘掉 ⇒ 卖空的卡会消失。

   所以前端能做、也必须做的两件事：
     ① **卖空立刻知道**：PDP 每 25 秒查一次 `/products/{handle}.js` 的 available，
        一旦变 false 立即锁死加购按钮 + 标 Sold out —— 不让客户白点，更不让客户加满车去结账才崩；
     ② **补货立刻恢复**（这就是「瞬间补回」的技术上限）：available 一旦回 true，
        25 秒内自动恢复显示与购买，客户不用刷新页面。

   ⚠️ 说清楚边界：前端**不能**凭空把库存补回来 —— DENY 策略下 0 就是 0。
      真正的补回只有两条路：后台补货入库、订单取消释放库存。
      前端负责的是「一有货就第一时间显示出来」，而不是制造一个买不了的数字。
   ============================================================================ */
(function () {
  'use strict';
  var TICK = 25000;          /* 25 秒一次：比 inv-sync 的分钟级更快，又不会给店里加压力 */
  var REVIVE_QTY = 3;        /* 补货恢复后本地放行 3 件：刚补的卡通常不多，卡牌又是一人一张 */

  function boot() {
    var el = document.getElementById('pdpStock');
    if (!el || !window.BBStock) return;
    var handle = el.getAttribute('data-bbs-key') || '';
    if (!handle) return;      /* 拿不到 handle 就不监控（老的 Liquid 缓存会走到这里，安全） */

    var btns = [].slice.call(document.querySelectorAll('[data-add-to-cart]'));
    var orig = btns.map(function (b) { return b.innerHTML; });
    var qtyInput = document.querySelector('[data-pdp-qty-input]');
    var lastAvail = null, busy = false, changed = 0;

    /* 🔴 STOCK-LAW-20261030：补货复活**必须带真实库存**进来。
       旧实现把 `data-qty` 写成硬编码 REVIVE_QTY(3) ⇒ 真实补了 50 件，客户也只能加 3 件。
       现在：realQty 来自 `/products/{handle}.js` 的 variants[0].inventory_quantity；
       取不到真值 ⇒ **一个真值属性都不许写**（宁可沿用旧值，也不用猜的数字顶上）。 */
    function paint(avail, realQty) {
      var s = document.getElementById('pdpStock');
      btns.forEach(function (b, i) {
        b.disabled = !avail;
        if (!avail) b.innerHTML = 'Sold out';
        else if (b.innerHTML === 'Sold out') b.innerHTML = orig[i];
      });
      var hasReal = avail && typeof realQty === 'number' && realQty > 0;
      /* 真值轨：只有拿到真实库存才写；写的是真值，不是 REVIVE_QTY */
      if (hasReal) {
        if (qtyInput) qtyInput.setAttribute('data-qty', String(realQty));
        var s0 = document.getElementById('pdpStock');
        if (s0) s0.setAttribute('data-qty', String(realQty));
      }
      if (!s) return;
      s.hidden = false;
      if (!avail) {
        s.textContent = 'Sold out';
        s.className = 'pdp__stock';
        s.setAttribute('data-bbs-shown', '0');
      } else {
        /* 渲染轨：只决定"给人看的数字"；基数优先用真实库存，拿不到才用 REVIVE_QTY 兜底显示 */
        var baseQ = hasReal ? realQty : REVIVE_QTY;
        var r = window.BBStock.shown(handle, baseQ, true);
        s.textContent = r.q <= window.BBStock.lowAt ? ('Only ' + r.q + ' left') : (r.q + ' in stock');
        s.className = 'pdp__stock is-low';
        s.setAttribute('data-bbs-qty', String(baseQ));
        s.setAttribute('data-bbs-shown', String(r.q));
      }
    }

    function probe() {
      if (busy || document.hidden) return;
      busy = true;
      var url = '/products/' + encodeURIComponent(handle) + '.js';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          busy = false;
          if (!j) return;
          var avail = !!j.available;
          var _v0 = (j.variants && j.variants[0]) || {};
          var realQty = (typeof _v0.inventory_quantity === 'number') ? _v0.inventory_quantity : null;   /* 真值轨 */
          if (lastAvail === null) { lastAvail = avail; return; }   /* 首次只记基线，不动作 */
          if (avail === lastAvail) return;
          lastAvail = avail;
          changed++;
          paint(avail, realQty);
          try {
            if (window.__bbToast) {
              window.__bbToast(avail ? 'Back in stock — grab it before it goes again'
                                     : 'Sold out — someone just took the last one');
            }
          } catch (e) {}
          try { document.documentElement.setAttribute('data-bbs-live', avail ? 'back' : 'out'); } catch (e) {}
        })
        .catch(function () { busy = false; });
    }

    setInterval(probe, TICK);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) probe(); });
    setTimeout(probe, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
